import type { Dict } from './de';

const tr: Dict = {
  app: {
    name: 'Projektzeit',
    demo: 'Demo',
    demoNotice: 'Kurgusal verilerle demo. Değişiklikler sayfa yenilenene kadar geçerlidir.',
    loading: 'Yükleniyor …',
    loadingDemo: {
      db: 'Veritabanı başlatılıyor …',
      schema: 'Tablolar oluşturuluyor …',
      data: 'Örnek veriler üretiliyor …',
    },
    noWasm: 'Bu görünüm WebAssembly çalıştırmaya izin vermediği için demo başlatılamadı. Yerelde başlatmak için: npm install, ardından npm run dev:demo -w @pz/web.',
    fatal: 'Uygulama başlatılamadı.',
  },
  nav: {
    myAbsences: 'Devamsızlıklarım',
    team: 'Ekip',
    planning: 'Planlama',
    evaluation: 'Personel değerlendirme',
    absences: 'Devamsızlıklar',
    rejectedBadge: '{{count}} reddedilen kayıt',
    rejectedBadge_one: '{{count}} reddedilen kayıt',
    overview: 'Genel bakış',
    week: 'Haftam',
    entries: 'Saatlerim',
    tasks: 'Görevler',
    approvals: 'Saat onayları',
    billing: 'Faturalandırma',
    workload: 'İş yükü',
    projects: 'Projeler',
    people: 'Kişiler',
    admin: 'Sistem yönetimi',
    logout: 'Çıkış yap',
    theme: 'Görünüm',
    themeSystem: 'Sisteme göre',
    themeLight: 'Açık',
    themeDark: 'Koyu',
    menu: 'Menü',
    groupMine: 'Benim alanım',
    groupProjects: 'Projeler ve ekip',
    groupLead: 'Yönetim',
    groupAdmin: 'Sistem yönetimi',
    cockpit: 'Kokpit',
    help: 'Kısa kılavuz',
    leaveRequests: 'İzin talepleri',
    analysis: 'Proje analizleri',
    customers: 'Müşteriler',
    planningGroup: 'Planlama ve kapasite',
    insightsGroup: 'Raporlar',
    subTime: 'Saatler',
    approvalsGroup: 'Onaylar',
    peopleGroup: 'Kişiler',
    announcements: 'Duyurular',
  },
  common: {
    moveDialog: 'Taşımak için sürükleyin; çift tık: yerine geri',
    day: 'Gün',
    undo: 'Geri al',
    undone: 'Geri alındı',
    undoReason: 'Değişiklik geri alındı',
    sortAsc: 'Artan sırala (seçiminiz saklanır)',
    sortDesc: 'Azalan sırala',
    sortReset: 'Varsayılan sıraya dön',
    shiftHint: 'Shift tuşuna basılı tutup tıklayarak bir aralığın tamamını seçebilirsiniz.',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    close: 'Kapat',
    delete: 'Sil',
    edit: 'Düzenle',
    add: 'Ekle',
    create: 'Oluştur',
    search: 'Ara',
    all: 'Tümü',
    yes: 'Evet',
    no: 'Hayır',
    reset: 'Sıfırla',
    apply: 'Uygula',
    from: 'Başlangıç',
    to: 'Bitiş',
    date: 'Tarih',
    week: 'Hafta',
    month: 'Ay',
    year: 'Yıl',
    hours: 'Saat',
    total: 'Toplam',
    status: 'Durum',
    note: 'Not',
    reason: 'Gerekçe',
    reasonHint: 'Değişiklik kaydında saklanır.',
    optional: 'isteğe bağlı',
    exportExcel: 'Excel\'e aktar',
    today: 'Bugün',
    previous: 'Önceki',
    next: 'Sonraki',
    open: 'Aç',
    archive: 'Arşivle',
    unarchive: 'Geri al',
    archived: 'Arşivlendi',
    active: 'Aktif',
    inactive: 'Pasif',
    name: 'Ad',
    email: 'E-posta',
    role: 'Rol',
    project: 'Proje',
    task: 'Görev',
    person: 'Kişi',
    description: 'Açıklama',
    booked: 'Girilen',
    planned: 'Planlanan',
    budget: 'Bütçe',
    of: '/',
    h: 'sa',
    cw: 'Hf',
    noData: 'Seçilen dönemde veri yok.',
    saved: 'Kaydedildi',
    deleted: 'Silindi',
    copied: 'Kopyalandı',
    copy: 'Kopyala',
    history: 'Geçmiş',
    createdAt: 'Giriş tarihi',
    select: 'Seç',
    selectAll: 'Tümünü seç',
    selected: '{{count}} seçildi',
    period: 'Dönem',
    type: 'Tür',
    showArchived: 'Arşivlenenleri göster',
    showInactive: 'Pasifleri göster',
    noResults: 'Sonuç yok.',
    typeToSearch: 'Aramak için yazın',
    noMatches: 'Sonuç yok',
    moreMatches: '{{count}} sonuç daha: lütfen aramayı daraltın',
    demoPrint: 'Demoda yazdırma penceresi engellenmiş olabilir. Kurulu platformda yazdırma penceresi doğrudan açılır; orada "PDF olarak kaydet" seçilir.',
  },
  status: {
    draft: 'Taslak',
    submitted: 'Gönderildi',
    approved_l1: 'Proje lideri onayladı',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    billed: 'Faturalandı',
  },
  billingType: {
    billable: 'Faturalandırılır',
    included: 'Götürü bedele dahil',
    non_billable: 'Faturalandırılmaz',
    billableHint: 'Saat dökümünde ve faturada yer alır.',
    includedHint: 'Götürü bedelin içindedir; dökümde görünür, tutar olarak yansımaz.',
    non_billableHint: 'Şirket içi, eğitim, iş geliştirme: faturalandırmaya girmez.',
    fixed: 'Görev tarafından belirlendi',
  },
  task: {
    manual: 'Manuel',
    internal: 'İç',
    deleted: 'Görev silindi',
    deletedHint: 'Görev silindi. Lütfen taslağı başka bir göreve taşıyın veya silin; bu haliyle gönderilmez.',
    formaDeleted: 'Forma\'da silindi',
    formaAccessLost: 'Forma\'da artık görünmüyor',
    closed: 'Kapalı',
    done: 'Tamamlandı',
    openInForma: 'Forma\'da aç',
    status: {
      draft: 'Taslak',
      open: 'Açık',
      pending: 'Beklemede',
      in_progress: 'Devam ediyor',
      in_review: 'İncelemede',
      completed: 'Tamamlandı',
      not_approved: 'Onaylanmadı',
      in_dispute: 'İhtilaflı',
      closed: 'Kapatıldı',
    },
  },
  week: {
    withdrawWeek: 'Haftayı geri çek',
    markAbsence: 'Devamsızlık gir',
    title: 'Haftam',
    titleOther: '{{name}} haftası',
    submitWeek: 'Haftayı gönder',
    submitDone: '{{count}} kayıt gönderildi',
    submitDone_one: '{{count}} kayıt gönderildi',
    nothingToSubmit: 'Bu haftada taslak yok.',
    addEntry: 'Kayıt',
    recent: 'Son kullanılanlar',
    recentEmpty: 'Son haftalarda kayıt yok.',
    absence: {
      special: 'Mazeret izni',
      overtime: 'Fazla mesai izni',
      unpaid: 'Ücretsiz izin',
      child_sick: 'Çocuk hasta',
      parental: 'Doğum / ebeveyn izni',
      pending: 'talep edildi: {{kind}}',
      vacation: 'İzin',
      sick: 'Hastalık',
      training: 'Eğitim',
      other: 'Diğer izin',
      absent: 'Ofis dışında',
    },
    locked: 'Ay kapatıldı',
    noEntries: 'Kayıt yok',
    viewPerson: 'Haftasını göster',
    me: 'Ben',
    lockedHint: 'Bu ay kapatıldı. Değişiklik ancak ofis ayı yeniden açarsa mümkün.',
    rejectedHint: 'Reddedildi: {{reason}}',
    tipKeyboard: 'İpucu: saatleri 7,5 veya 7:30 şeklinde girin.',
    showWeekend: 'Hafta sonu',
    showWeekendHint: 'Cumartesi ve pazarı göster. Seçim bu tarayıcıda saklanır.',
    weekendNeeded: 'Gösteriliyor: hafta sonu kayıt var, sözleşmeye göre hafta sonu çalışma günü var veya bugün hafta sonu.',
    compHint: '{{hours}} sa fazla mesai izni dahil',
    freeDay: 'çalışma günü değil',
    copied: '{{date}} tarihine kopyalandı',
    moved: '{{date}} tarihine taşındı',
    moveOrCopy: 'Taşı veya kopyala',
    copyHere: 'Kopyala',
    moveHere: 'Taşı',
    targetDate: 'Hedef gün',
    dragHint: 'İpucu: Kaydı başka bir güne sürüklemek taşır; Ctrl veya Alt basılıyken kopyalar. Aynı gün içinde sürükleyerek sıralayabilirsiniz.',
    toTop: 'En üste al',
    dragEntryHint: 'Bir güne sürükleyin: taşı · Ctrl veya Alt ile: kopyala',
    dragTaskHint: 'Bir güne sürükleyin: bu görevle yeni kayıt · favorilerin arasına: oraya yerleştir',
    dropNew: '{{day}} için yeni kayıt',
    dropMove: 'Buraya taşı',
    dropCopy: 'Buraya kopyala',
    dayFull: 'Günlük süre tamamlandı',
    dayOver: 'Günlük süre aşıldı',
    tipDrag: 'İpucu: kayıt girmek için görevi bir güne sürükleyin; saatleri 7,5 veya 7:30 şeklinde girin.',
  },
  entry: {
    submittedDone: '{{count}} kayıt gönderildi',
    submittedDone_one: '{{count}} kayıt gönderildi',
    withdrawnDone: '{{count}} kayıt geri çekildi',
    withdrawnDone_one: '{{count}} kayıt geri çekildi',
    restored: 'Geri yüklendi',
    billingTypeByRule: 'Proje veya görevden alınır',
    newTitle: 'Saat gir',
    editTitle: 'Kaydı düzenle',
    task: 'Görev',
    pickTask: 'Görev ara: numara veya başlık',
    changeTask: 'Başka görev',
    hours: 'Saat',
    hoursHint: 'ör. 7,5 veya 7:30 (adım {{step}} dk)',
    description: 'Yapılan iş',
    descriptionHint: 'Kısa ve açık, isterseniz kendi dilinizde; saat dökümünde görünür, müşteri için gün metnini gerekirse ofis düzenler.',
    billingType: 'Faturalandırma türü',
    location: 'Çalışma yeri',
    date: 'Tarih',
    billedMinutes: 'Faturalanacak saat',
    billedMinutesHint: 'Boş = girildiği gibi. Daha yüksek veya düşük olabilir.',
    billingNote: 'Faturalandırma notu',
    saveAndNew: 'Kaydet ve yeni',
    bookFor: 'Kimin adına',
    deleteTitle: 'Kaydı sil',
    deleteText: 'Kayıt çöp kutusuna taşınır ve geri alınabilir.',
    submit: 'Gönder',
    withdraw: 'Geri çek',
    restore: 'Geri al',
    warnings: {
      TASK_FORMA_DELETED: 'Görev Forma\'da silinmiş. Kayıt yine de saklandı.',
      TASK_FORMA_ACCESS_LOST: 'Görev Forma\'da artık görünmüyor. Kayıt yine de saklandı.',
      TASK_CLOSED: 'Görev kapalı.',
      DAILY_LIMIT: 'Bu gün için {{hours}} saatten fazla.',
      WEEKEND: 'Hafta sonu kaydı. Saatler fazla mesai sayılır (o gün hedef: 0) ve fazla mesai izni olarak talep edilebilir.',
      WEEKEND_DATE: 'Hafta sonu kaydı. Lütfen tarihi kontrol edin.',
      FREE_DAY: 'Sözleşmeye göre çalışma günü olmayan bir güne kayıt. Saatler fazla mesai sayılır.',
      HOLIDAY: 'Resmî tatil veya ofisin kapalı olduğu bir güne kayıt. Saatler fazla mesai sayılır.',
      ABSENCE_DAY: 'Bu gün için tam günlük bir izin kayıtlı. Yine de çalıştıysanız izni geri çekin veya personel birimine düzelttirin.',
    },
    audit: {
      'time.submit': 'Gönderildi',
      'time.withdraw': 'Geri çekildi',
      'time.approve_undo': 'Onay geri alındı',
      'time.reject_undo': 'Ret geri alındı',
      'time.update': 'Değiştirildi',
      'time.delete': 'Silindi',
      'time.restore': 'Geri alındı',
      'time.approve': 'Onaylandı',
      'time.reject': 'Reddedildi',
      'time.reopen': 'Yeniden açıldı',
      'time.create_for_other': 'Başkası adına girildi',
      'time.billed': 'Faturalanacak saat değişti',
    },
    locationNone: 'belirtilmedi',
    billedTitle: 'Faturalanacak saat',
    recorded: 'girilen {{hours}} sa',
    billedReset: 'Girildiği gibi',
    billedInfo: 'Yalnızca müşteri faturası için geçerlidir. Göstergeler, kapasite ve plan/gerçekleşen oranı girilen saatlerle hesaplanır.',
    billedShort: 'Fat. {{hours}} sa',
    billedAction: 'Fat. saat',
    noOvertime: 'Fazla mesai sayılmaz',
    noOvertimeHint: 'Örneğin mesai dışı gönüllü eğitim. Saatler kayıtlı kalır.',
    noOvertimeByCategory: 'Görevin kategorisi fazla mesai sayılmaz.',
    why: {
      title: 'Henüz kaydedilemiyor: {{list}}',
      task: 'görev seçin',
      hours: 'saati girin ({{step}} dk adımlarla)',
      date: 'tarih seçin',
      description: 'yapılan işi yazın (bu faturalandırma türünde zorunlu)',
      reason: 'değişikliğin gerekçesini yazın (en az 3 karakter)',
      unchanged: 'değişiklik yok',
      weekdays: 'en az bir hafta günü seçin',
      repeatEnd: 'bitiş başlangıçtan önce',
    },
  },
  entries: {
    nothingFor: 'Seçili kayıtların hiçbiri bu işleme uygun değil.',
    deletedMany: '{{count}} kayıt çöp kutusuna taşındı',
    deletedMany_one: '{{count}} kayıt çöp kutusuna taşındı',
    title: 'Saatlerim',
    thisMonth: 'Bu ay',
    lastMonth: 'Geçen ay',
    thisYear: 'Bu yıl',
    trash: 'Çöp kutusu',
    count: '{{count}} kayıt',
    count_one: '{{count}} kayıt',
    sum: 'Toplam',
    exportHint: 'Dönemdeki tüm kayıtlar, yazdığınız yapılan işlerle birlikte, günlük ve proje bazında toplamlarla Excel dosyası. Kendi yedeğiniz olarak da kullanabilirsiniz.',
    thisWeek: 'Bu hafta',
    showing: '{{total}} kaydın {{shown}} tanesi gösteriliyor, kaydırdıkça devamı gelir',
    capped: 'Dönemin en yeni {{count}} kaydı gösteriliyor. Daha kısa bir dönem seçin; Excel dışa aktarımı tüm kayıtları içerir.',
    formaLostFilter: 'Filtre: silinmiş veya artık erişilemeyen Forma görevlerindeki kayıtlar. Lütfen başka göreve aktarın veya ofisle netleştirin.',
    taskFilter: 'Filtre: tek bir görevdeki kayıtlar.',
    clearFilter: 'Filtreyi kaldır',
    search: 'Ara',
    searchHint: 'Görev, proje, yapılan iş …',
    allProjects: 'Tüm projeler',
    allTypes: 'Tüm faturalandırma türleri',
    clearFilters: 'Filtreleri temizle',
    noMatch: 'Arama ve filtrelere uyan kayıt yok. Dönemin tüm kayıtlarını görmek için filtreleri temizleyin.',
  },
  tasks: {
    showHidden: 'Gizlenenleri göster',
    hideSelected: 'Gizle',
    showSelected: 'Yeniden göster',
    hiddenMany: '{{count}} görev gizlendi',
    hiddenMany_one: '{{count}} görev gizlendi',
    shownMany: '{{count}} görev yeniden gösteriliyor',
    shownMany_one: '{{count}} görev yeniden gösteriliyor',
    title: 'Görevler',
    search: 'Numara, başlık veya proje',
    includeClosed: 'Kapalıları göster',
    createManual: 'Manuel görev',
    manualTitle: 'Manuel görev oluştur',
    manualHint: 'Forma issue\'su olmayan işler için, ör. eğitim, iş geliştirme, toplantılar. Forma\'da olan işler orada issue olarak kalmalı.',
    category: 'Kategori',
    similar: 'Benzer görevler zaten var:',
    billingTypeFixed: 'Tüm kayıtlar için faturalandırma türünü sabitle',
    created: '{{ref}} görevi oluşturuldu',
    book: 'Saat gir',
    count: '{{count}} görev',
    count_one: '{{count}} görev',
    empty: 'Kayıt girilebilecek görev bulunamadı. Projelere atamayı proje lideri yapar.',
    subtitle: 'Kayıt girebildiğim tüm görevler: Forma issue\'ları ve manuel görevler (M numaraları).',
    billingForced: 'Kategori veya iç proje tarafından belirlenir.',
    planHint: 'İsteğe bağlı. Görev bazında plan/gerçekleşen karşılaştırmasının temeli.',
    formaKind: 'Kategori / tip (Forma)',
    allKinds: 'Tüm kategoriler ve tipler',
    wholeCategory: '{{category}}: tüm tipler',
    typeExcluded: '{{type}} (aktarılmıyor)',
    withoutValue: '(değer yok)',
    period: 'Başlangıç - bitiş',
    allStatuses: 'Tüm durumlar',
    resetFilters: 'Filtreleri sıfırla',
    selectAllShown: '{{count}} görevin tümünü seç',
    noneFiltered: 'Bu filtreler için görev yok.',
    none: 'Henüz görev yok. Forma görevleri eşitlemeden sonra görünür; manuel görevler için "Görev oluştur".',
    kindColumn: 'Kategori / tip',
    hiddenByFilter: 'Aktarım filtresiyle gizlendi (tip aktarılmıyor)',
    filteredOut: 'Aktarım filtresi',
    hide: 'Gizle',
    listLegend: 'Plan: Projektzeit plan saatleri (0 = değerlendirilmez). Gizlenen görevler saatleriyle korunur ve yeniden gösterilebilir. Forma görevleri yalnızca okunur.',
    clashHint: 'Çakışmaları kalıcı olarak dışarıda tutmak için:',
    toImportFilter: '"Forma" sekmesindeki aktarım filtresi',
    editManual: '{{ref}} görevini düzenle',
    number: 'Numara',
    numberHint: 'Projede tekil',
    numberTaken: '{{ref}} bu projede zaten var (gizli görevler de sayılır). İki manuel görev aynı numarayı taşıyamaz.',
    numberInvalid: 'Lütfen 1 ile 9999999 arasında bir sayı girin.',
    numberChangeHint: 'Yeni numara her yerde geçerli olur: saatlerde, onaylarda, analizlerde, favorilerde ve açık faturalama taslaklarında ("veri değişti" uyarısıyla). Kesinleşmiş belgeler o zamanki numarayı korur.',
    renameBooked: 'Yeni ad her yerde, daha önce girilmiş {{hours}} saat için de geçerli olur. Başka bir iş ise yeni bir görev oluşturmak daha doğru olur.',
    renameHint: 'Yeni ad, görevin geçtiği her yerde geçerli olur.',
    delete: {
      button: 'Sil …',
      title: '{{ref}} silinsin mi?',
      hideInstead: 'Bunun yerine gizle',
      confirm: 'Kalıcı olarak sil',
      hidden: '{{ref}} gizlendi; saatler korunuyor',
      done: '{{ref}} silindi, {{count}} kayıt kaldırıldı',
      done_one: '{{ref}} silindi, {{count}} kayıt kaldırıldı',
      warnTitle: 'Yalnızca saati olmayan görevler silinir: gönderilmiş saati olan görev gizlenir, böylece saatler korunur.',
      warnHours: 'Görevde: {{people}} kişiden {{count}} kayıt, toplam {{hours}} sa (kendi taslaklarınız dahil).',
      warnHours_one: 'Görevde: {{count}} kayıt, {{hours}} sa.',
      warnNoHours: 'Göreve (görünür) henüz bir şey girilmemiş.',
      warnFinal: 'Silme işlemi geri alınamaz. Bu yüzden görevi silmemek hemen her zaman daha doğrudur.',
      drafts: 'Kişilerin henüz göndermediği taslaklar özeldir: kişilerde kalır, onlar taslağı başka bir göreve taşır.',
      better: 'Daha iyisi: "Bunun yerine gizle". Görev kayıt girişinden kalkar, saatlerin tamamı korunur ve istenince yeniden gösterilebilir.',
      blocked: 'Silinemez: {{count}} kayıt kapatılmış bir ayda veya faturalandırılmış. Görev yalnızca gizlenebilir.',
      blocked_one: 'Silinemez: {{count}} kayıt kapatılmış bir ayda veya faturalandırılmış. Görev yalnızca gizlenebilir.',
      approvedNeedsRight: '{{count}} kayıt zaten onaylanmış; bunları yalnızca kayıt düzeltme yetkisi olan kişi (ofis) silebilir.',
      hasHours: 'Silinemez: {{count}} kayıtta saat var (gönderilmiş, onaylanmış veya iade edilmiş). Görev bunun yerine gizlenir; saatlerin tamamı korunur.',
      understood: 'Görevin ve üzerindeki taslaklarımın silineceğini ve bunun geri alınamayacağını anladım.',
    },
    startDate: 'Başlangıç',
    dueDate: 'Bitiş',
    datesInvalid: 'Bitiş başlangıçtan önce.',
    datesHint: 'Başlangıç ve bitiş tarihiyle görev proje analizinin zaman planında ve termin durumunda görünür.',
    closedLabel: 'Tamamlandı (kapalı)',
    closedHint: 'Kapalı görevler ilerlemede tamamlanmış sayılır; saat yazmak yine mümkündür.',
    kindCount: '{{kind}} ({{count}})',
    billingColumn: 'Faturalama',
    sortNumber: 'No.',
    truncated: 'Filtreye {{count}} görevden fazlası uyuyor; ilk {{count}} görev gösteriliyor. Lütfen aramayı veya filtreyi daraltın.',
    formaDraft: 'Forma\'da taslak',
    formaDraftHint: 'Forma\'da hâlâ taslak; yayınlandığında veya taslaklar aktarıldığında görünür.',
    billingByRole: 'Faturalama türünü proje lideri, faturalandırma ve ofis belirler; aksi halde kategorinin varsayılanı geçerlidir.',
    billingMany: 'Faturalama türünü ayarla …',
    billingSetMany: '{{count}} manuel görev için faturalama türü ayarlandı',
    billingSkipped: '{{count}} görev atlandı (Forma görevi veya kategori tarafından sabit)',
  },
  approvals: {
    weekendHint: 'Hafta sonu kaydı',
    undone: '{{count}} kayıt eski durumuna alındı',
    undone_one: '{{count}} kayıt eski durumuna alındı',
    undoSkipped: '{{count}} kayıt bu arada işlendiği için değişmedi.',
    undoSkipped_one: '{{count}} kayıt bu arada işlendiği için değişmedi.',
    title: 'Onaylar',
    subtitle: 'Gönderilen saatleri kontrol edin. Kimin onaylayacağını her proje belirler: ofis (varsayılan), proje lideri ya da önce proje lideri (1. aşama), sonra ofis (2. aşama).',
    mine: 'Onaylarım',
    all: 'Tüm açıklar',
    stage: {
      l1: 'Proje lideri onayı',
      final: 'Ofis onayı',
      override: 'Doğrudan onayla',
    },
    approve: 'Onayla',
    reject: 'Reddet',
    rejectTitle: 'Kayıtları reddet',
    rejectReason: 'Ne düzeltilmeli?',
    done: '{{count}} kayıt onaylandı',
    done_one: '{{count}} kayıt onaylandı',
    rejected: '{{count}} kayıt reddedildi',
    rejected_one: '{{count}} kayıt reddedildi',
    skipped: '{{count}} atlandı',
    nothing: 'Kontrol edilecek bir şey yok.',
    weekOf: '{{week}}. hafta',
    bulk: {
      open: 'Saatler: export / import',
      title: 'Onay bekleyen saatleri dosyayla düzenle',
      intro: '1. Onay bekleyen kayıtları CSV olarak dışa aktarın. 2. Excel\'de yalnızca "hours", "description" ve "billing_type" sütunlarını değiştirin. 3. Dosyayı geri yükleyin: önce önizleme, sonra uygula. Değişiklikler düzenleme penceresiyle aynı kurallardan geçer (yetki, sürüm, kapalı aylar) ve kayda geçer; kayıtlar onay için açık kalır.',
      export: '1. Dışa aktar (CSV)',
      exported: '{{count}} kayıt dışa aktarıldı',
      save: 'Dosyayı kaydet',
      copy: 'Metni kopyala',
      fileText: 'Dosya içeriği (düzenlenebilir)',
      import: '2. İçe aktar',
      chooseFile: 'CSV dosyası seç',
      orPaste: 'veya içeriği buraya yapıştırın',
      preview: 'Önizleme',
      apply: 'Değişiklikleri uygula',
      summary: '{{changed}} değişti, {{unchanged}} aynı, {{errors}} hatalı',
      previewOnly: 'Önizleme: henüz hiçbir şey değişmedi.',
      applied: '{{count}} kayıt değiştirildi',
      line: 'Satır',
      person: 'Kişi',
      date: 'Tarih',
      change: 'Değişiklik',
      state: 'Sonuç',
      stateChanged: 'değişecek',
      stateApplied: 'değişti',
      stateUnchanged: 'aynı',
      stateError: 'Hata',
      fields: {
        hours: 'Saat',
        description: 'Yapılan iş',
        billing_type: 'Faturalama türü',
      },
      errors: {
        NOT_IN_QUEUE: 'Artık onay bekleyenleriniz arasında değil',
        CONFLICT: 'Dışa aktarımdan sonra değişti (sürüm)',
        BAD_HOURS: 'Geçersiz saat (adım ve üst sınıra dikkat)',
        BAD_BILLING_TYPE: 'Geçersiz faturalama türü (billable, included, non_billable)',
        PERIOD_LOCKED: 'Ay kapalı',
        ENTRY_BILLED: 'Zaten faturalandı',
        ENTRY_DELETED: 'Kayıt silinmiş',
        ENTRY_APPROVED: 'Zaten onaylandı',
        SELF_APPROVAL: 'Kendi kayıtlarınızı burada düzenleyemezsiniz',
        WRONG_STATUS: 'Durum uygun değil (artık onay beklemiyor)',
        FORBIDDEN: 'Düzenleme yetkisi yok',
        NOT_FOUND: 'Kayıt bulunamadı',
        REASON_REQUIRED: 'Gerekçe gerekli',
        OTHER: 'Uygulanmadı',
      },
      noRows: 'Dışa aktarılacak açık kayıt yok.',
    },
    groupsShown: '{{total}} kişi-haftanın {{shown}} tanesi gösteriliyor, kaydırdıkça devamı gelir',
    filterPerson: 'Kişi',
    allPersons: 'Tüm kişiler',
    filterKind: 'Görev türü',
    allKinds: 'Tüm görevler',
    kindForma: 'Forma görevleri',
    kindManual: 'Manuel görevler (kategorisiz)',
    summaryLine: '{{total}} kaydın {{shown}} tanesi · {{hours}} sa bekliyor',
    moreHint: 'Gösterilen: {{total}} bekleyen kaydın {{shown}} tanesi. Kişi veya görev filtresi listeyi küçültür.',
    loadMore: 'Daha fazla yükle',
    views: {
      pending: 'Onay bekleyenler',
      approved: 'Onaylananlar (iade)',
    },
    filterTaskStatus: 'Görev durumu',
    allTaskStatuses: 'Tüm görev durumları',
    closedTask: 'Görev kapatıldı',
    closedTaskHint: 'Görev Forma’da kapatılmış. Saatler yine de sayılır; kaydın bu göreve ait olduğunu kısaca kontrol edin.',
    approvedTitle: 'Onaylanmış saatler',
    approvedSubtitle: 'Onaylanmış kayıtlar artık kimse tarafından doğrudan değiştirilmez. Bir düzeltme gerekiyorsa kaydı gerekçesiyle kişiye iade edin; kişi düzeltir ve yeniden gönderir.',
    returnRule: 'İade etme yetkisi onayın sahibindedir: proje lideri (“Yalnız proje lideri” ayarında veya 1. aşama için), diğer durumlarda ofis. Faturalanmış kayıtlar ve kapatılmış aylar burada görünmez.',
    approvedEmpty: 'Bu dönemde iade edebileceğiniz onaylanmış kayıt yok.',
    return: 'İade et',
    returnTitle: '{{count}} kaydı düzeltme için iade et',
    returnTitle_one: 'Kaydı düzeltme için iade et',
    returnText: 'Onay kaldırılır; kişiye bildirim gider, kaydı düzeltir ve yeniden gönderir. İade kayıt altına alınır.',
    returnDraft: 'Bunlardan {{count}} tanesi bir taslak saat dökümünde; taslak bundan sonra “veriler değişti” uyarısı gösterir.',
    returnReason: 'Ne düzeltilmeli?',
    returned: '{{count}} kayıt iade edildi',
    returned_one: '{{count}} kayıt iade edildi',
    returnSkipped: '{{count}} kayıt iade edilmedi (bu arada değişti, faturalandı veya yetki yok).',
    inDraft: 'Taslakta',
    inDraftHint: 'Gün, bu projenin taslak saat dökümüne dahil. İadeden sonra taslak “veriler değişti” gösterir ve yeniden kontrol edilmelidir.',
  },
  billing: {
    print: 'Yazdır / PDF',
    printHint: 'İmza alanlı yazdırma görünümü; yazdırma penceresinde "PDF olarak kaydet" seçin.',
    noAccess: 'Faturalama yalnızca "Faturalama" yetkisi olan kişilere açıktır (ör. yönetici asistanı). Proje liderleri saatleri onaylar.',
    title: 'Faturalandırma',
    subtitle: 'Saat dökümleri ve hakedişler',
    defaults: {
      title: 'Belgelerin varsayılanları',
      hint: 'Yeni belgeler için geçerlidir ve her belgede değiştirilebilir. Bunları yalnızca "Faturalandırma" yetkisine sahip kişiler değiştirir, teknik yönetim değiştirmez.',
      show: 'Varsayılanları göster',
      hide: 'Varsayılanları gizle',
    },
    documents: 'Belgeler',
    search: 'Numara, başlık veya proje ara',
    listCapped: 'En yeni {{count}} belge gösteriliyor. Daha eski belgeler için numara, başlık veya proje ile arayın.',
    empty: 'Henüz belge yok. Yukarıdan saat dökümü veya hakediş oluşturun.',
    noMatch: 'Bu aramaya uyan belge yok. Arama sözcüğünü veya durumu değiştirin.',
    unbilledNone: 'Onaylanan her şey faturalandı.',
    newSn: 'Saat dökümü',
    newAbschlag: 'Hakediş',
    newSnTitle: 'Saat dökümü oluştur',
    newAbschlagTitle: 'Hakediş oluştur',
    unbilled: 'Onaylı, henüz faturalanmamış',
    unbilledHint: 'Onaylanmış ve kapatılmış bir saat dökümünde yer almayan faturalandırılabilir saatler.',
    noRate: 'saat ücreti yok',
    kinds: {
      stundennachweis: 'Saat dökümü',
      abschlag: 'Hakediş',
    },
    docStatus: {
      draft: 'Taslak',
      final: 'Kesinleşti',
      invoiced: 'Faturası kesildi',
      paid: 'Ödendi',
      cancelled: 'İptal edildi',
    },
    number: 'Numara',
    header: 'Başlık bilgileri',
    options: 'Seçenekler',
    layout: {
      label: 'Görünüm',
      matrix: 'Günler × kişiler',
      list: 'Liste',
    },
    includeTypes: 'Dahil edilen faturalandırma türleri',
    showAmounts: 'Tutarları göster (saat ücretleri)',
    language: 'Belge dili',
    dayTextPrefix: {
      label: 'Gün metninin başı',
      discipline: 'Disiplin',
      name: 'Ad',
      none: 'hiçbiri',
      code: 'Kişinin kısaltması (HA, HAL)',
    },
    includeUnapproved: 'Onaylanmamış kayıtları önizlemede göster',
    preview: 'Önizleme',
    dayText: 'Yapılan işler',
    dayTextReset: 'Otomatik metni kullan',
    dayTextEdited: 'düzenlendi',
    rows: 'Tek tek kayıtlar',
    exclude: 'Faturalandırma',
    billedHours: 'Fat. saat',
    finalize: 'Kesinleştir',
    finalizeTitle: 'Belgeyi kesinleştir',
    finalizeText: 'Numara verilir, içerik dondurulur, kayıtlar faturalandı olarak işaretlenir. Yalnızca onaylı kayıtlar alınır.',
    finalized: '{{number}} olarak kesinleşti',
    markInvoiced: 'Faturası kesildi',
    markPaid: 'Ödendi',
    cancel: 'İptal et',
    cancelTitle: 'Belgeyi iptal et',
    cancelText: 'Kayıtlar yeniden serbest kalır ve tekrar faturalanabilir. Numara iptal olarak kalır.',
    deleteDraft: 'Taslağı sil',
    fields: {
      customerReference: 'İşveren referansı / sipariş no.',
      title: 'Başlık',
      consultant: 'Yüklenici',
      customer: 'İşveren',
      projectLabel: 'Proje adı',
      projectNumber: 'Proje numarası',
      partner: 'Partner',
      periodLabel: 'Dönem (metin)',
      siteLocation: 'Çalışma yeri',
      place: 'Yer',
      documentDate: 'Tarih',
      providerSignatureName: 'İmza altındaki ad (yüklenici)',
      clientSignatureName: 'İmza altındaki ad (işveren)',
      issuerName: 'Firma (üst satır)',
      issuerAddress: 'Adres (üst satır)',
      note: 'Belgedeki not',
      contractNote: 'Sözleşme dayanağı',
      asOf: 'İlerleme tarihi',
      sequenceLabel: 'Sıra numarası',
      vatPercent: 'KDV %',
      customerAddress: 'İşveren adresi',
      customerContact: 'İşverendeki ilgili kişi',
      customerVatId: 'Alıcının KDV numarası',
    },
    phases: 'Hizmet aşamaları',
    phase: 'Hizmet aşaması',
    weight: 'Ağırlık %',
    fee: 'Ücret',
    progress: 'İlerleme %',
    earned: 'Hak edilen',
    previous: 'Önceki hakedişler',
    current: 'Bu hakediş',
    extras: 'Ek kalemler',
    addExtra: 'Kalem ekle',
    net: 'Net',
    vat: 'KDV',
    gross: 'Brüt',
    previousDocs: 'Önceki hakedişler',
    unapprovedWarning: 'Dönemdeki {{count}} kayıt henüz onaylanmadı ve faturalanmayacak.',
    unapprovedWarning_one: 'Dönemdeki {{count}} kayıt henüz onaylanmadı ve faturalanmayacak.',
    noEntries: 'Dönemde onaylı kayıt yok.',
    amount: 'Tutar',
    readOnly: 'Kesinleşmiş belgeler değiştirilemez. Düzeltme için iptal edip yeniden oluşturun.',
    recalcHint: 'Tutarlar kaydettikten sonra yeniden hesaplanır.',
    noFee: 'Bu proje için ücret tanımlanmamış (proje > ücret).',
    billedHint: 'Faturalanacak saatler girilen saatlerle önceden doldurulur ve farklı olabilir, yukarı doğru da (örn. götürü anlaşma). Diğer tüm değerlendirmeler girilen saatleri kullanır.',
    printPreview: 'Baskı önizlemesi',
    dayTextTask: {
      label: 'Gün metninde görev',
      fallback: 'yalnızca yapılan işi yazılmamış kayıtlarda',
      always: 'her zaman, cümlelerin önünde [görev] olarak',
      byTask: 'görev başına bir satır: “Görev: HLS: … · ELT: …”',
    },
    dayTextHint: 'Her gün için disiplin (veya kişi) başına bir satır. Yazılan her iş bir cümle olur, aynı cümleler bir kez görünür; yapılan iş yazılmamışsa görev başlığı yazılır, satır o görevi zaten açıklıyorsa yazılmaz. Seçilen çalışma yerleri parantez içinde yazılır. Elle düzenlenen metinler korunur; günün kayıtları sonradan değişirse işaretlenir.',
    dayTextOutdated: 'Düzenlemeden sonra kayıtlar değişti',
    dayTextOutdatedHint: 'Güncel kayıtlara göre otomatik metin:',
    dayTextKeep: 'Düzenlenmiş metni koru',
    outdatedNotice: 'Elle düzenlenmiş {{count}} gün metni kayıtlarla artık uyuşmayabilir (önizlemede işaretli). Lütfen kontrol edin.',
    outdatedNotice_one: 'Elle düzenlenmiş bir gün metni kayıtlarla artık uyuşmayabilir (önizlemede işaretli). Lütfen kontrol edin.',
    finalizeOutdated: 'Dikkat: düzenlenmiş {{count}} gün metni, kayıtlar değiştikten sonra kontrol edilmedi.',
    finalizeOutdated_one: 'Dikkat: düzenlenmiş bir gün metni, kayıtlar değiştikten sonra kontrol edilmedi.',
    dayTextLocations: 'Gün metninde çalışma yerini belirt',
    payment: {
      title: 'Ödeme koşulları',
      intro: 'Bu fatura için vade, erken ödeme iskontosu ve KDV sonrası kesintiler. Projenin koşullarından (Müşteriler › Koşullar) otomatik dolar; bu belge bunlardan farklı olabilir. Orijinal fatura muhasebe sisteminde kalır.',
      none: 'Bu proje için henüz ödeme koşulu kayıtlı değil. Bu belge için buraya, ya da kalıcı olarak projenin koşullarına girin.',
      fromProject: 'Proje koşullarından al',
      summary: 'Müşterinin ödeyeceği tutar',
      frozen: 'Belgeyle birlikte sabitlendi: projenin koşullarında sonradan yapılan değişiklikler bu belgeyi değiştirmez.',
      noteSaved: 'Tutarlar ve vade, kalemlerin kaydedilmiş haline göre hesaplanır.',
    },
    basis: {
      changedShort: 'Veri değişti',
      changed: 'Bu taslak hazırlandıktan sonra sistem verileri değişti: {{parts}}. Taslak saatleri, adları ve tutarları zaten güncel haliyle gösteriyor; elle değiştirilmiş gün metinleri ve başlık bilgileri (alıcı, proje) olduğu gibi kalır. Lütfen taslağı gözden geçirip “Kontrol edildi ve onaylandı”yı seçin: uyarı bir sonraki değişikliğe kadar kaybolur.',
      checked: 'Kontrol edildi ve onaylandı; uyarı ancak bir sonraki değişiklikte yeniden görünür.',
      markChecked: 'Kontrol edildi ve onaylandı',
      takeRecipient: 'Alıcıyı müşteri verilerinden al',
      takeProject: 'Proje numarası ve adını al',
      parts: {
        entries: 'dönemin zaman kayıtları',
        texts: 'Kişi veya görev adları',
        rates: 'Satış ücretleri (tutarlar)',
        customer: 'müşteri verileri (alıcı)',
        project: 'proje numarası veya adı',
        fee: 'ücret, hizmet aşamaları veya koşullar',
      },
    },
    edit: {
      export: 'Düzenleme için (Excel)',
      exportHint: 'Taslağı düzenleme için Excel dosyası olarak al: sarı sütunları değiştirip buraya geri yükleyin',
      import: 'Düzenlemeyi içe aktar',
      previewTitle: 'Düzenlenen dosya: önizleme',
      apply: '{{count}} değişikliği uygula',
      applied: '{{count}} değişiklik uygulandı',
      previewRefreshed: 'Önizlemeden sonra sistem verileri değişti. Önizleme şimdi yeni durumu gösteriyor; lütfen kontrol edip yeniden uygulayın.',
      stale: 'Taslak dışa aktarımdan sonra değişti. Önizleme güncel durumla karşılaştırır; lütfen değişiklikleri kontrol edin.',
      noChanges: 'Dosyada taslağa göre değişiklik yok.',
      entries: 'Kayıtlar ({{count}})',
      excluded: 'faturalanmaz',
      days: '{{count}} gün metni değişti',
      phases: 'İlerleme durumu',
      extras: 'Ek kalemler: {{count}} satır',
      problems: '{{count}} satır aktarılmadı:',
      row: 'satır {{row}}',
      problem: {
        hours: 'geçersiz saat (0 ile 24 arası)',
        percent: 'geçersiz ilerleme (0 ile 100 arası)',
        line: 'ek kalem eksik',
        date: 'geçersiz tarih',
        number: 'geçersiz sayı',
        unknown: 'kayıt veya hizmet aşaması belgeye ait değil',
        own: 'kendi kayıtlarınız değişmez (kendi saatlerinize başka biri karar verir)',
        too_many: 'çok fazla ek kalem (en fazla 30)',
      },
    },
    recipient: {
      button: 'Alıcıyı müşteri verilerinden al',
      title: 'Müşteri verilerinden alıcı',
      none: 'Bu projeye henüz firma bağlanmadı (Müşteriler > Projeler).',
      agreed: 'koşullara göre',
      take: 'Al',
      following: 'Alıcı müşteri verilerini izliyor: firma, ilgili kişi, sipariş numarası veya koşullardaki değişiklikler bu taslağa kendiliğinden yansır (kayıt altına alınır). Bir alıcı alanını elle değiştirmek bunu sonlandırır.',
      manual: 'Alıcı elle girildi ve müşteri verilerini izlemiyor. “Müşteri verilerinden al” yeniden bağlar.',
    },
    bulk: {
      button: 'Toplu dışa aktar',
      title: 'Belgeleri toplu dışa aktar',
      intro: 'Filtredeki tüm belgeler tek bir zip dosyasında: her belge ayrı bir Excel dosyası olarak, yanında bir liste. Hizmet dönemi (veya tarihi) seçilen dönemle kesişen belge döneme dahildir. Dosya başına en çok 300 belge.',
      kind: 'Tür',
      export: 'Zip dosyası oluştur',
    },
  },
  workload: {
    leadPrivacy: 'Doluluk düzeyini (renk) görürsünüz, sözleşme saatlerini görmezsiniz. Saatleri yalnızca personel birimi ve yönetim görür.',
    cellTitleLead: 'planlanan {{plan}} sa, girilen {{booked}} sa',
    levelTitle: 'Doluluk: {{level}}',
    levelShort: {
      none: 'yok',
      low: '< %70',
      ok: '%70-100',
      high: '%100-110',
      over: '> %110',
    },
    title: 'İş yükü',
    subtitle: 'Kapasite = sözleşme saatleri eksi resmî tatiller (konuma göre) ve izinler.',
    level: {
      none: 'kapasite yok',
      low: '%70 altı',
      ok: '%70 ile %100 arası',
      high: '%100 ile %110 arası',
      over: '%110 üstü',
    },
    legend: 'Kapasiteye göre değer',
    cellTitle: 'Kapasite {{cap}} sa, planlanan {{plan}} sa, girilen {{booked}} sa',
    internalPart: 'bunun dahili kısmı (Ar-Ge, eğitim, idari): {{hours}} sa',
    location: 'Konum',
    planHint: 'Bu proje için haftalık saatleri girin. Renk, kişinin tüm projelerdeki doluluğunu gösterir.',
    fill: 'Seri gir',
    fillTitle: 'Birden çok hafta planla',
    perWeek: 'Haftalık saat',
    import: 'CSV içe aktar',
    importTitle: 'İzinleri içe aktar',
    importResult: '{{ok}} aktarıldı, {{errors}} hata',
    calendar: 'Takvim',
    overrides: 'Şirket düzenlemeleri',
    overrideNew: 'Günü düzenle',
    fraction: 'İzinli kısım',
    fractionFull: 'tam gün',
    fractionHalf: 'yarım gün (öğleden sonra tatil)',
    fractionNone: 'iş günü (tatili kaldır)',
    allCalendars: 'tüm takvimler',
    rowsFound: '{{count}} satır bulundu',
    rowsFound_one: '{{count}} satır bulundu',
    noAccess: 'İş yükünü proje liderleri (kendi projeleri), planlama ve yönetim görür.',
    onlyFlagged: 'Yalnızca uyarılı',
    stateHint: 'Tamamlanmış haftalar: kayıtlar kapasiteden {{hours}} sa fazla saparsa uyarı (tüm projeler).',
  },
  kpi: {
    solo: 'Ağırlıklı olarak tek başına',
    soloHint: 'Saatlerinin en az %80\'i bu kişiden gelen {{count}} görev; oran sadece burada kişinin kendi işi hakkında bilgi verir.',
    soloHint_one: 'Saatlerinin en az %80\'i bu kişiden gelen {{count}} görev; oran sadece burada kişinin kendi işi hakkında bilgi verir.',
    confidentialNote: 'Kişisel performans verileri. Yalnızca yönetim için; her erişim kayıt altına alınır.',
    utilization: 'Doluluk',
    utilizationHint: 'girilen / kapasite',
    billableShare: 'Faturalanabilir pay',
    projectShare: 'Proje çalışması payı',
    balance: 'Hedef/gerçekleşen farkı',
    punctuality: 'Zamanında gönderilen',
    rejectionRate: 'Düzeltme istenen',
    capacity: 'Hedef',
    booked: 'Gerçekleşen',
    billable: 'Faturalanabilir',
    budgetUsed: 'Kullanılan bütçe',
    salesValue: 'Faturalanabilir değer',
    unbilledValue: 'Henüz faturalanmamış',
    cost: 'Maliyet',
    costMissing: 'maliyet ücreti olmayan: {{hours}} sa',
    byPerson: 'Kişiye göre',
    byMonth: 'Aya göre',
    byProject: 'Projeye göre',
    weekly: 'Haftalık seyir',
    plannedRemaining: 'Hâlâ planlı',
    otherHours: 'Diğer saatler',
    showTable: 'Tablo olarak',
    showChart: 'Grafik olarak',
    weekPrefix: 'Hf.',
    asOf: 'Hedef/gerçekleşen {{from}} - {{to}}',
    weekState: 'Hafta',
    under: 'Hedefin {{hours}} sa altında',
    over: 'Hedefin {{hours}} sa üstünde',
    underLegend: 'Hedefin altında kalan hafta',
    overLegend: 'Hedefi aşan hafta',
    efficiency: 'Plan/gerçekleşen oranı',
    efficiencyHint: '{{count}} görev: {{plan}} sa plan payı, {{actual}} sa girilen',
    efficiencyHint_one: '{{count}} görev: {{plan}} sa plan payı, {{actual}} sa girilen',
    efficiencyNone: 'Bu dönemde planı olan tamamlanmış görev yok.',
    efficiencyExplain: 'Planı olan tamamlanmış görevler (Forma alanı veya proje liderinin girdiği değer). Oran = plan / göreve girilen tüm saatler; %100 üzeri = plandan hızlı. Değer göreve aittir: bir görevde çalışan herkes aynı değeri alır. Kişinin ne kadar hızlı çalıştığını değil, üzerinde çalışılan görevlerin plana göre nasıl gittiğini gösterir.',
    efficiencyExplainOwn: 'Planı olan ve yalnızca sizin saat girdiğiniz tamamlanmış görevler (Forma alanı veya proje liderinin girdiği değer). Oran = plan / sizin saatleriniz; %100 üzeri = plandan hızlı. Birlikte çalışılan görevler burada görünmez, çünkü oranları diğer kişilerin saatlerini ele verirdi.',
    sharedLeftOut: 'Birlikte çalışılan {{count}} görev dahil değildir.',
    sharedLeftOut_one: 'Birlikte çalışılan {{count}} görev dahil değildir.',
  },
  projects: {
    openBookingImportHint: 'İşaretlenmezse yalnızca proje ekibi kayıt girebilir; ekibi büro veya proje lideri projede belirler.',
    importForma: 'Forma\'dan aktar',
    importInfo: 'Seçilen her Forma projesi için Projektzeit\'ta bir proje oluşturur, bağlar ve senkronizasyonu açar. Numara ve ad Forma adından alınır (ör. "2024-017 Klinikum Nordtal"). Görevler ve konumlar bir sonraki senkronizasyondan sonra görünür. Proje lideri, üyeler ve ücret sonra her projede tamamlanır.',
    importResult: '{{created}} aktarıldı, {{skipped}} atlandı (zaten bağlı)',
    importDone: '{{count}} proje aktarıldı',
    importDone_one: '{{count}} proje aktarıldı',
    importCount: '{{count}} proje aktar',
    importAs: 'Projektzeit\'ta',
    alreadyLinked: '{{number}} ile bağlı',
    autoNumber: 'F numarası',
    archivedMany: '{{count}} proje arşivlendi',
    archivedMany_one: '{{count}} proje arşivlendi',
    restoredMany: '{{count}} proje geri yüklendi',
    restoredMany_one: '{{count}} proje geri yüklendi',
    archiveCount: '{{count}} arşivle',
    restoreCount: '{{count}} geri yükle',
    title: 'Projeler',
    new: 'Proje oluştur',
    number: 'Proje numarası',
    name: 'Proje adı',
    customer: 'İşveren',
    customerAddress: 'İşveren adresi',
    partner: 'Partner',
    site: 'Çalışma yeri',
    calendar: 'Tatil takvimi (proje yeri)',
    billingMode: {
      label: 'Faturalandırma',
      hourly: 'Saate göre',
      fixed_fee: 'Götürü bedel',
      mixed: 'Karma',
      internal: 'Şirket içi',
    },
    defaultBillingType: 'Varsayılan faturalandırma türü',
    openBooking: 'Tüm çalışanlar kayıt girebilir',
    openBookingHint: 'Eğitim veya idari işler gibi şirket içi projeler için.',
    budget: 'Bütçe (saat)',
    fee: 'Toplam ücret',
    start: 'Başlangıç',
    end: 'Bitiş',
    statusLabel: 'Durum',
    syncPausedHint: 'Forma ile sadece aktif projeler otomatik eşitlenir. Durdurulmuş, tamamlanmış, iptal edilmiş ve arşivlenmiş projeler bekler; "Şimdi eşitle" her zaman çalışır, proje yeniden aktif yapılınca sonraki çalışma tüm projeyi okur.',
    statuses: {
      active: 'Aktif',
      on_hold: 'Beklemede',
      completed: 'Tamamlandı',
      cancelled: 'İptal edildi',
    },
    notes: 'Notlar',
    color: 'Renk',
    colorHint: '“Haftam”da ve listelerde tanıma rengi; her zaman numara ve adla birlikte. Sekiz renkten biri, özel bir renk (renk seçici veya kod) ya da renksiz. Yeni projeler, aktif projelerden en çok ayrışan rengi alır.',
    colorNone: 'yok',
    colors: {
      blue: 'Mavi',
      orange: 'Turuncu',
      aqua: 'Turkuaz',
      yellow: 'Sarı',
      magenta: 'Pembe',
      green: 'Yeşil',
      violet: 'Mor',
      red: 'Kırmızı',
    },
    assignColors: 'Renk ata',
    assignColorsHint: 'Rengi olmayan aktif projeler, aktif projelerin renklerinden olabildiğince farklı bir renk alır. Mevcut renkler değişmez.',
    assignedColors: '{{count}} projeye renk verildi',
    approval: {
      title: 'Saatlerin onayı',
      mode: 'Kim onaylar',
      companyDefault: 'Şirket varsayılanı ({{mode}})',
      self: 'Kendi saatlerini onaylama (onaylayanlar)',
      selfHint: 'Proje lideri ve ofis bu projede kendi saatlerini onaylayabilsin mi?',
      selfDefault: 'Şirket varsayılanı ({{value}})',
      selfAllowed: 'Onaylayanlar kendi saatlerini onaylayabilir.',
      changeHint: 'Değişiklik, henüz karar verilmemiş tüm kayıtlarda geçerli olur; onaylanmış kayıtlar onaylı kalır.',
      modes: {
        office: 'Ofis / yönetici asistanı (tek aşama)',
        lead: 'Proje lideri (tek aşama)',
        lead_office: 'Önce proje lideri, sonra ofis (iki aşama)',
        self: 'Göndermeyle kişinin kendi onayı',
      },
      hints: {
        office: 'Gönderilen saatleri ofis (yönetici asistanı) tek adımda onaylar; proje liderine sorulmaz.',
        lead: 'Projenin bir proje lideri tek adımda kesin onay verir; birden fazla proje lideri varsa biri yeterlidir. Proje lideri yoksa ya da tek proje lideri kendi saatlerini gönderiyorsa ofis karar verir.',
        lead_office: 'İki adım: önce bir proje lideri (birden fazlaysa biri yeterli), sonra ofis. Üçüncü aşama hiçbir zaman yoktur. Kayıt ancak ofis onayından sonra onaylanmış sayılır ve faturalandırılabilir.',
        self: 'Göndermek saatleri onaylar. Kişi bunu ay kapanana kadar geri çekebilir; ofis düzeltebilir.',
      },
      compare: {
        title: 'Seçeneklerin karşılaştırması',
        who: 'Kim onaylar',
        several: 'Birden fazla proje lideri',
        final: 'Onaylı ve faturalandırılabilir',
        return: 'Onaylı saatlerin iadesi',
        whoOffice: 'Ofis',
        whoLead: 'bir proje lideri',
        whoLeadOffice: '1. bir proje lideri, 2. ofis',
        whoSelf: 'gönderen kişinin kendisi',
        severalNone: 'etkisi yok',
        severalOne: 'biri yeterli',
        severalOneNoThird: 'biri yeterli, üçüncü aşama yok',
        finalOffice: 'ofis onayından sonra',
        finalLead: 'proje lideri onayından sonra',
        finalLeadOffice: 'ancak ofisten sonra (2. aşama)',
        finalSelf: 'gönderildiği anda',
        returnOffice: 'Ofis',
        returnLead: 'proje lideri veya ofis',
        returnLeadOffice: '1. aşamadan sonra: proje lideri veya ofis; 2. aşamadan sonra: ofis',
        returnSelf: 'Ofis',
        note: '“Proje lideri” ile “önce proje lideri, sonra ofis” arasındaki tek fark, proje liderinden sonra ofisin bir kez daha kontrol edip etmemesidir. Saatlerin her proje liderinden ayrı ayrı onay alması hiçbir zaman gerekmez.',
      },
    },
    archiveText: 'Arşivlenen projeler listelerden ve seçimlerden kalkar. Veriler ve Forma bağlantısı korunur.',
    tabs: {
      overview: 'Genel',
      members: 'Ekip',
      tasks: 'Görevler',
      forma: 'Forma',
      fee: 'Ücret',
      kpi: 'Saatler ve bütçe',
      analysis: 'Analiz',
    },
    members: 'Ekip',
    addMember: 'Kişi ekle',
    role: {
      lead: 'Proje lideri',
      member: 'Üye',
    },
    listScope: {
      label: 'Hangi projeler',
      mine: 'Projelerim',
      all: 'Tüm projeler',
      mineHint: 'Üye veya proje lideri olduğunuz projeler. "Tüm projeler" görme yetkiniz olan her projeyi gösterir; seçim her cihazda hesabınız için geçerlidir.',
    },
    scope: {
      label: 'Görevler',
      all: 'tümü',
      selected: 'yalnızca seçilenler',
    },
    validFrom: 'Başlangıç',
    validTo: 'Bitiş',
    removeMember: 'Çıkar',
    removeMemberText: 'Kişinin kayıtları varsa üyelik bugün sona erer; kayıtlar korunur.',
    selectTasks: 'Görev seç',
    editMember: 'Üyeliği düzenle',
    scopeSelectedHint: 'Kişi bundan sonra yalnızca seçilen görevlere saat girebilir. Kaydettikten sonra görev seçimi açılır.',
    noTasksSelected: 'Görev seçilmedi: kişi bu projede saat giremez.',
    validRangeError: '"Bitiş", "Başlangıç" tarihinden önce.',
    myRole: 'Rolüm',
    formaLinked: 'Forma\'ya bağlı',
    formaNotLinked: 'Forma\'ya bağlı değil',
    formaState: {
      not_linked: 'Bağlı değil',
      active: 'Bağlı',
      deleted: 'Forma\'da silindi',
      access_lost: 'Forma\'da erişim yok',
    },
    formaStateHint: 'Platform, Forma\'daki değişiklikler yüzünden hiçbir veriyi silmez. Etkilenen görevlere kayıt girilebilir ve işaretlenirler.',
    formaLink: 'Forma projesini bağla',
    formaUnlink: 'Bağlantıyı kaldır',
    formaProject: 'Forma projesi',
    syncEnabled: 'Issue\'ları otomatik al',
    includeClosed: 'Kapalı issue\'ları da al',
    syncNow: 'Şimdi eşitle',
    fullSync: 'Tam eşitleme',
    lastSync: 'Son eşitleme',
    syncResult: '{{created}} yeni, {{updated}} değişti, {{flagged}} işaretlendi, {{excluded}} filtre nedeniyle aktarılmadı',
    feePhases: 'Hizmet aşamalarına göre ücret (HOAI § 55 Teknik donanım)',
    feeHint: 'Ağırlıklar ve tutarlar değiştirilebilir, ör. indirimler veya özel hizmetler için.',
    resetHoai: 'HOAI standardına sıfırla',
    runStats: '{{fetched}} okundu, {{created}} yeni, {{updated}} değişti, {{excluded}} aktarılmadı',
    whatIsRead: 'Forma\'dan ne okunur',
    readFields: 'Numara, başlık, durum, kategori ve tip, konum, başlangıç ve bitiş ile aşağıda seçilen alanlarla görevler.',
    readNotHours: 'Plan saatleri ve yazılan saatler yalnızca Projektzeit\'tan gelir, Forma\'dan değil.',
    readOneWay: 'Yalnızca okuma: Projektzeit Forma\'ya hiçbir şey yazmaz.',
    includeClosedHint: 'Önerilir: ilerleme ve kayıtların tam olması için tamamlanan görevleri de aktarın.',
    importFilter: 'Kategoriler ve tipler (aktarım filtresi)',
    clashInfo: 'Model koordinasyonundaki çakışmaları (Forma Model Coordination, Navisworks eklentisi) Forma, "Coordination" kategorisinde sabit "Clash" tipiyle görev olarak oluşturur. Bu adı veya "Kollision" adını taşıyan tipler varsayılan olarak aktarılmaz. Hangi tiplerin Projektzeit\'ta görüneceğini burada belirleyin.',
    saveFilter: 'Kaydet ve eşitle',
    filterSaved: 'Kaydedildi: {{hidden}} gizlendi, {{shown}} yeniden görünür, saatleri olduğu için {{kept}} tutuldu',
    cleanupExcluded: 'Gizlenenleri temizle ({{count}})',
    noTypesYet: 'Kategoriler ve tipler bir sonraki eşitlemede Forma\'dan okunur.',
    take: 'Aktar',
    categoryType: 'Kategori / tip',
    inProjektzeit: 'Görünür',
    hiddenByFilter: 'Gizli',
    withHours: 'Saatli',
    clashBadge: 'Çakışma',
    inactiveInForma: 'Forma\'da pasif',
    notTaken: 'aktarılmıyor',
    showTasks: 'Görev listesinde göster',
    lastFullExcluded: 'Son tam eşitlemede ({{date}}) filtre nedeniyle aktarılmayan: {{count}} görev.',
    keptWithHours: 'Hariç tutulan tiplerden {{count}} görev, saat yazıldığı için görünür kalıyor.',
    filterHint: 'Hariç tutmak görevleri hemen gizler (geri alınabilir). "Temizle", saati olmayan gizli görevleri Projektzeit\'tan siler; Forma\'da kalırlar ve tip yeniden aktarılırsa geri gelirler.',
    cleanupTitle: 'Gizli görevleri temizle',
    cleanupText: 'Hariç tutulan tiplerin saati olmayan {{count}} gizli görevi Projektzeit\'tan silinir. Forma\'da hiçbir şey değişmez. Saatli görevler korunur.',
    cleanupConfirm: 'Temizle',
    cleanupDone: '{{deleted}} görev silindi, saatleri olduğu için {{kept}} tutuldu',
    fieldsTitle: 'Forma alanları ({{total}} alandan {{taken}} aktarıldı)',
    fieldsIntro: 'Forma görevlerinin özel alanları, örn. disiplin, kat, hizmet fazı, öncelik, alt proje, sprintler. Aktarılan alanlar görev listelerinde sütun ve filtre olarak ve proje analizinde görünür.',
    reloadFields: 'Alanları yeniden oku',
    fieldsReloaded: '{{count}} alan okundu',
    saveFields: 'Kaydet ve eşitle',
    fieldsSaved: 'Alanlar kaydedildi; eşitleme değerleri okuyor',
    searchFields: 'Alan ara',
    onlyTaken: 'Yalnızca aktarılanlar',
    noFieldsYet: 'Alanlar bir sonraki eşitlemede Forma\'dan okunur.',
    field: 'Alan',
    fieldType: 'Tür',
    fieldValues: 'Değerler',
    fieldRole: 'Analizde',
    fieldDeleted: 'Forma\'da silindi',
    locationsUsed: 'Analiz bina ve katı Forma konumlarından alır (bina: seviye {{building}}, kat: seviye {{floor}}).',
    fieldsHint: 'Değerler yalnızca okunur ve her eşitlemede güncellenir. Hangi alanın kat, bina, disiplin veya hizmet fazı olacağı önerilir; proje analizinde "Ayarlar" altında değiştirilebilir.',
    fieldRoles: {
      floor: 'Kat',
      building: 'Bina',
      trade: 'Disiplin',
      phase: 'Hizmet fazı',
    },
    fieldTypes: {
      list: 'Liste',
      text: 'Metin',
      numeric: 'Sayı',
      date: 'Tarih',
      paragraph: 'Paragraf',
      checkbox: 'Onay kutusu',
    },
    count: '{{count}} proje',
    count_one: '{{count}} proje',
    archiveFilter: 'Görünüm',
    archiveModes: {
      active: 'Güncel projeler',
      only: 'Yalnızca arşivlenenler',
      all: 'Tümü',
    },
    booking: {
      title: 'Zaman kaydı',
      open: 'Kayıt yapılabilir',
      openHint: 'Çalışanlar zaman kaydederken projeyi ve görevlerini bulur.',
      closedShort: 'Kayıt yapılamaz',
      closedHint: 'Etkin bir Forma bağlantısı ve serbest bırakma olmadan proje, proje ve görev aramasında gizlenir.',
      release: 'Forma olmadan kayıt yapılabilir',
      releaseHint: 'Projeyi Forma bağlantısı olmadan zaman kaydına açar (örn. teklif aşaması veya eski proje). İstenildiğinde geri alınabilir.',
    },
    identityOnlyHint: 'Teknik admin olarak proje numarasını ve adını değiştirirsiniz; diğer bilgileri ofis yönetir.',
    includeDrafts: 'Forma\'daki taslakları aktar',
    includeDraftsHint: 'Kapalı (varsayılan): taslak durumundaki issue’lar görev olmaz; daha önce oluşturulmuş, saati olmayan taslaklar gizlenir. Açık: taslaklar analizlerde (ilerleme) sayılır, ancak hiçbir durumda saat girişine açılmaz; saat ancak Forma’da yayımlandıktan sonra girilebilir.',
    formaNameFollow: 'Numara ve adı Forma\'dan al',
    formaNameFollowHint: 'Forma\'daki bir ad değişikliği, sonraki eşitlemede buradaki proje numarasını ve adını değiştirir. Kapalı: burada tutulan bilgiler kalır.',
    runDrafts: '{{count}} taslak aktarılmadı',
    runDrafts_one: '1 taslak aktarılmadı',
    colorCustom: 'Özel renk',
    colorCode: 'Renk kodu (#rrggbb)',
    formaLinks: {
      files: 'Forma: Dosyalar',
      filesHint: 'Projeyi Forma’da Data Management > Files sayfasında açar',
      board: 'Forma Board',
      boardHint: 'Bu projenin Board’unu Forma Board’da açar',
      boardGeneralHint: 'Forma Board’u açar (proje için ayrı bir Board adresi tanımlı değil)',
      boardUrl: 'Bu projenin Forma Board adresi (isteğe bağlı)',
      boardUrlHint: 'Forma Board ayrı bir uygulamadır; Board’un adresini tarayıcı çubuğundan kopyalayıp buraya yapıştırın. Boş: buton genel girişi açar.',
      boardUrlInvalid: 'Adres https:// ile başlamalı',
    },
    resetHoaiHint: 'Hizmet aşamalarını HOAI § 55 (teknik donanım) oranlarına göre ayarlar ve toplam ücreti bu oranlara dağıtır.',
    resetHoaiText: 'Hizmet aşamaları HOAI § 55 standart oranlarıyla değiştirilir ({{shares}}) ve {{total}} tutarındaki toplam ücret bu oranlara dağıtılır. Kendi adlarınız, oranlarınız ve tutarlarınız kaybolur. “Kaydet”e basılmadan hiçbir şey kaydedilmez.',
  },
  people: {
    protectedHint: 'Bu hesabın sizde olmayan korunan yetkileri var. Rolü, erişimi, e-postayı ve etkinliği sadece bu yetkilere sahip kişi (genelde yönetim) değiştirir; acil erişim sadece sunucuda.',
    weeklyHoursHint: 'Yalnızca kişinin kendisi, personel birimi ve yönetim görür.',
    title: 'Kişiler',
    new: 'Kişi oluştur',
    displayName: 'Ad',
    shortCode: 'Kısaltma',
    kind: {
      external: 'Harici',
    },
    company: 'Firma (harici)',
    discipline: 'Disiplin',
    country: 'Konum',
    countries: {
      DE: 'Almanya',
      TR: 'Türkiye',
    },
    calendar: 'Tatil takvimi',
    entryDate: 'İşe giriş',
    exitDate: 'İşten çıkış',
    notes: 'Notlar (İK)',
    contracts: 'Çalışma süresi',
    weeklyHours: 'Haftalık saat',
    workdays: 'Çalışma günleri',
    addContract: 'Tarihten itibaren değişiklik',
    rates: 'Saat ücretleri',
    rateKind: {
      sales: 'Satış',
      cost: 'Maliyet',
      overtime: 'Fazla mesai ücreti',
    },
    rateProject: 'yalnızca proje',
    perHour: '€/sa',
    roles: {
      admin: 'Sistem yöneticisi (BT)',
      office: 'Ofis ve yönetim',
      employee: 'Çalışan',
      external: 'Harici',
    },
    ownRightsHint: 'Kendi rolünüzü ve yetkilerinizi başka bir yetkili kişi değiştirir. Korunan yetkileri sadece bunlara sahip kişi verir.',
    extraPermissions: 'Ek yetkiler',
    permissions: {
      'time.approve.final': 'Saatleri son onaylama',
      'time.manage': 'Tüm saatleri düzeltme',
      'period.manage': 'Ay kapanışı',
      'billing.manage': 'Faturalandırma',
      'rates.sales.view': 'Satış ücretlerini görme',
      'rates.cost.view': 'Maliyet ücretlerini görme',
      'hr.manage': 'Personel: sözleşme saatleri, devamsızlıklar (gizli)',
      'kpi.team.view': 'Ekip göstergeleri (gizli)',
      'workload.manage': 'İş yükü planlama',
      'projects.manage': 'Proje yönetimi',
      'users.manage': 'Kullanıcılar ve roller',
      'settings.manage': 'Ayarlar',
      'backup.manage': 'Yedekleme',
      'audit.view': 'Değişiklik kaydını görme',
      'data.export.all': 'Tam dışa aktarım ve Power BI',
      'sync.manage': 'Forma eşitlemesi',
      'analytics.view': 'Tüm projelerin proje analizi (yönetim)',
      'customers.manage': 'Müşteri portföyü ve koşullar',
      'announcements.manage': 'Duyuru yayınlama',
      'rights.manage': 'Rol ve yetki verme',
      'projects.view.all': 'Tüm projeleri saatleriyle görme',
      'staffing.view': '“Kim nerede çalışıyor” görme',
    },
    permissionHints: {
      'time.approve.final': 'Tüm projelerin saatlerinin nihai onayı (proje liderleri kendi projelerini bu yetki olmadan onaylar).',
      'time.manage': 'Başkalarının kayıtlarını oluşturma, değiştirme ve silme, onaylılar dahil (kayıt altında).',
      'period.manage': 'Ayları kapatma ve yeniden açma.',
      'billing.manage': 'Saat dökümleri, hakedişler, faturalanacak saatler.',
      'rates.sales.view': 'Belgelerde ve analizde satış ücretlerini ve tutarları görme.',
      'rates.cost.view': 'Analizde maliyet ücretlerini ve maliyetleri görme.',
      'hr.manage': 'Sözleşmeler, herkesin devamsızlıkları, raporlar, fazla mesai ve tatiller.',
      'kpi.team.view': 'Personel değerlendirmesi (gizli, her görüntüleme kaydedilir).',
      'workload.manage': 'Tüm projelerin planlaması ve tüm kişilerin iş yükü.',
      'projects.manage': 'Proje oluşturma ve değiştirme, proje lideri ve ekip belirleme, şablonlar.',
      'users.manage': 'Hesap oluşturma, erişimi sıfırlama, etkinleştirme ve devre dışı bırakma.',
      'settings.manage': 'Sistem ayarları, kategoriler, Outlook bağlantısı.',
      'backup.manage': 'Yedek oluşturma ve geri yükleme.',
      'audit.view': 'Kayıt defterini okuma (tutarlar, saatler ve sağlık verileri yalnızca ilgili yetkiyle).',
      'data.export.all': 'Toplu dışa aktarma ve Power BI verileri.',
      'sync.manage': 'Forma bağlantısı ve eşitleme, alan aktarımı.',
      'analytics.view': 'Tüm projelerin proje analizi ve portföyü.',
      'customers.manage': 'Müşteriler, irtibat kişileri ve koşullar.',
      'announcements.manage': 'Herkese veya gruplara duyuru yayınlama.',
      'rights.manage': 'Rol ve yetki verme (korumalı yetkileri yalnızca sahibi verebilir).',
      'projects.view.all': 'Tüm projeleri (arşivlenenler dahil) ekip, görevler ve saatlerle okuma; örneğin bölüm liderine vekâlet eden bir proje lideri için. Değişiklik yalnızca ilgili yetkilerle.',
      'staffing.view': 'Kimin hangi projede çalıştığı (dolu kutucuk, proje lideri “PL” etiketiyle). Saatler yalnızca kişinin zaten saatlerini görebildiği projeler için.',
    },
    roleBase: {
      employee: 'özel yetki olmadan: kendi saatleri ve haftası, kendi devamsızlıkları, ekip takvimi, üye olduğu projeler ve görevler. Proje lideri olarak (projede belirlenir) kendi projelerinin onayı, planlaması ve analizi de – bunun için yetki gerekmez.',
      external: 'özel yetki olmadan: yalnızca atandığı projelere ve görevlere kayıt, kendi kayıtları; ekip takvimi ve göstergeler yok.',
      office: 'ofisin ve yönetimin tüm iş yetkileri (onay, faturalandırma, personel, projeler, raporlar). Rol ve yetki verme dahil değildir.',
      admin: 'teknik yönetim: hesaplar, yetkiler (korumalılar hariç), ayarlar, Forma, yedekleme ve kayıt defteri. Onay, faturalandırma, personel veya performans verisi yok.',
    },
    roleMatrix: {
      title: 'Tüm rollerin varsayılan yetkileri',
      protected: 'Korumalı yetki: yalnızca sahibi verebilir',
      hint: 'Her yetki en az bir rolün varsayılanıdır. Çalışanların varsayılan olarak yalnızca "Kim nerede çalışıyor" yetkisi vardır (başkalarının saatleri olmadan), harici çalışanların bilinçli olarak hiç yoktur; ikisinin de yetkisiz yapabildikleri (kayıt, kendi haftası, kendi izinleri) yukarıda yazar. Diğer yetkiler kişi bazında verilir. Yönetim, ofis artı "rol ve yetki verme"dir.',
    },
    activate: 'Etkinleştir',
    deactivate: 'Devre dışı bırak',
    resetAccess: 'Erişimi sıfırla',
    setupLink: 'Kurulum bağlantısı',
    setupLinkHint: 'Bağlantıyı kişiye doğrudan iletin. 7 gün ve tek kullanım için geçerlidir.',
    memberships: 'Projeler',
    absenceSummary: '{{year}} izinleri',
    days: '{{count, number}} gün',
    days_one: '{{count, number}} gün',
    access: {
      title: 'Erişim',
      password: 'Parola belirlendi',
      totp: 'İkinci faktör aktif',
      pending: 'Kurulum bekliyor',
      entra: 'Microsoft oturumu bağlı',
      lockedUntil: '{{time}} saatine kadar kilitli (girişte veya doğrulamada çok fazla hatalı deneme)',
      unlock: 'Kilidi kaldır',
      unlocked: 'Kilit kaldırıldı',
    },
    tabs: {
      master: 'Ana veriler',
      time: 'Çalışma süresi',
      rates: 'Ücretler',
      access: 'Rol ve erişim',
    },
    weekly: '{{hours}} sa/hafta',
    accessHint: 'Kimse doğrudan şifre vermez: "Erişimi sıfırla" bir kurulum bağlantısı oluşturur, kişi şifresini kendisi belirler.',
    removePicture: 'Profil resmini kaldır',
    approver: {
      title: 'İzinlerin onayı',
      hint: 'Yıllık izin ve diğer talepleri seçilen kişi (örn. ekip lideri) karara bağlar. Hastalık bildirimlerini her zaman personel birimi onaylar. Seçim yoksa personel birimi karar verir.',
      hr: 'Personel birimi',
    },
    subtitle: 'Ana veriler, rol ve erişim. Devamsızlıklar, izin bakiyeleri ve takvimler “Devamsızlıklar” sekmesindedir.',
    searchPlaceholder: 'Ad, kısaltma, bölüm veya e-posta ara',
    count: '{{count}} kişi',
    count_one: '{{count}} kişi',
    shortCodeHint: 'Kişinin belgelerde ve listelerde kullanılan sabit kısaltması (örn. HA, HAL): 2-6 harf veya rakam, şirkette benzersiz.',
    shortCodeAuto: 'otomatik',
    suggestCode: 'Addan öner',
    fillCodes: 'Eksik kısaltmaları ver ({{count}})',
    fillCodesHint: 'Kısaltması olmayan her aktif kişiye benzersiz bir kısaltma verir: baş harfler (HA); alınmışsa bir harf eklenir (HAL).',
    fillCodesDone: '{{count}} kısaltma verildi',
    noAccess: 'Yalnızca insan kaynakları ve sistem yönetimi içindir.',
    rights: 'Yetkiler',
    rightsHint: 'Rol, varsayılan yetkileri belirler (önceden seçili). Tek tek varsayılanlar kaldırılabilir, başka yetkiler eklenebilir. Rol ve yetkileri yalnızca sistem yönetimi ve genel müdürlük değiştirir.',
    rightsDefault: 'Rolün varsayılanları',
    rightsReadOnly: 'Rol ve yetkileri yalnızca sistem yönetimi ve genel müdürlük değiştirir.',
    rightTags: {
      default: 'varsayılan',
      removed: 'kaldırıldı',
      extra: 'ek',
    },
    jobTitle: 'Unvan',
    jobTitleHint: 'Yalnızca gösterim içindir; yetkiler buna bağlı değildir.',
    overtimeAccount: 'Fazla mesai hesabı tutulsun',
    overtimeAccountHint: 'Kapalı: fazla mesai bakiyesi ve izinle telafi yok (örn. genel müdür veya götürü ücret).',
    overtimeRateHint: 'Kişiseldir, tüm projeler için geçerlidir: sözleşmeye göre fazla mesai saati başına tutar (normal ücretle aynı veya farklı). Yalnızca maliyet ücretlerini görme yetkisiyle görünür.',
  },
  admin: {
    outlook: {
      title: 'Outlook takvimleri',
      notConfigured: 'Microsoft 365 bağlantısı kurulmamış (.env içinde GRAPH_*). Kurulum kılavuzuna bakın.',
      off: 'Aktarım ayarlarda kapalı.',
      connection: 'Bağlantı',
      targets: 'Hedefler',
      personal: 'kişisel takvimler',
      appointments: 'Outlook\'taki randevular',
      failing: '{{count}} hatalı',
      failing_one: '{{count}} hatalı',
      lastRun: 'Son çalışma',
      result: 'Sonuç',
      resultText: '{{created}} yeni, {{updated}} değişen, {{removed}} kaldırılan, {{errors}} hata',
      syncNow: 'Şimdi aktar',
      hint: '5 dakikada bir çalışır. Yalnızca onaylı izinler, 7 gün geriden yaklaşık 13 ay ileriye kadar ve açıklamalar olmadan aktarılır. Ekip takvimi için açılmamış türler ve hastalık "Ofis dışında" olarak görünür.',
      problems: 'Hatalı posta kutuları',
      noProblems: 'Hata yok.',
    },
    title: 'Sistem yönetimi',
    tabs: {
      outlook: 'Outlook',
      settings: 'Ayarlar',
      periods: 'Ay kapanışı',
      forma: 'Forma',
      backup: 'Yedekleme',
      audit: 'Değişiklik kaydı',
      categories: 'Kategoriler',
      templates: 'Görev şablonları',
      jobs: 'Bakım raporları',
    },
    settings: {
      leave: 'Devamsızlıklar',
      teamVisible: 'Ekip takviminde türüyle görünenler',
      teamVisibleHint: 'Diğer tüm türler "Ofis dışında" olarak görünür. Hastalık hiçbir zaman türüyle görünmez.',
      outlook: 'Outlook takvimleri',
      outlookEnabled: 'Onaylanan devamsızlıkları Outlook\'a yaz',
      outlookPersonal: 'Kişinin takviminde "Ofis dışında" durumuyla (Outlook ve Teams\'te toplantı planlarken görünür)',
      outlookTeam: 'Ortak ekip takvimi (posta kutusu adresi, isteğe bağlı)',
      outlookHint: 'Ön koşul: uygulama kaydı ve Exchange rol ataması, kurulum kılavuzuna bakın.',
      annMail: 'Duyuruların e-postayla gönderilmesi',
      annMailEnabled: 'Duyurular e-postayla da gönderilebilsin',
      annMailEnabledHint: 'Yayımlayan kişi her duyuru için karar verir ("E-posta olarak da gönderilsin"). Bu kutu her yeni duyuruda başta işaretsizdir. E-posta, harici kişiler dahil ulaşılan kişilerin şirket adreslerine gizli alıcı olarak gider.',
      annMailSender: 'Gönderen',
      annMailSenderHint: 'E-postaların gönderildiği ve "Gönderilmiş Öğeler" klasöründe saklandığı adres.',
      annMailPublisher: 'Duyuruyu yayımlayan kişi',
      annMailNoAddress: 'Seçilen kişinin geçerli bir e-posta adresi yok. Lütfen başka bir kişi seçin veya adresi Kişiler bölümünde ekleyin.',
      annMailNotConfigured: 'E-posta hizmeti kurulu değil (Outlook takvimlerindeki gibi Microsoft Graph). Bu olmadan hiçbir şey gönderilmez.',
      annMailHint: `Teknik: Uygulama kaydı Exchange Online'da yalnızca gönderen posta kutularıyla sınırlandırılmış "Application Mail.Send" yetkisine ihtiyaç duyar (bkz. docs/INTEGRATIONS.md).`,
      syncInterval: 'Forma senkronu her',
      syncWindow: 'Zaman aralığı',
      windows: {
        daily: 'Her gün 06-24, pazar dahil',
        workhours: 'Pzt-Cmt 06-21',
        always: 'Günün her saati',
      },
      minutes: '{{count}} dakikada',
      autoImport: 'Yeni Forma projelerini gece aktar (sadece proje ekibi saat girebilir)',
      company: 'Firma',
      appName: 'Uygulama adı',
      place: 'Yer (belgeler için)',
      defaultCalendar: 'Varsayılan tatil takvimi',
      approval: 'Onay',
      stages: 'Onay aşamaları',
      stages1: '1 aşama (proje lideri veya ofis)',
      stages2: '2 aşama (önce proje lideri, sonra ofis)',
      selfApproval: 'Kendi saatlerini onaylamaya izin ver',
      approvalMode: 'Saatlerin varsayılan onayı',
      approvalModeHint: 'Kendi seçimi olmayan projelerde geçerlidir. Her proje Genel bakış > Saatlerin onayı altında kendi kuralını seçebilir.',
      selfApprovalHint: 'Tüm projeler için varsayılan; bir proje farklı belirleyebilir.',
      time: 'Saat girişi',
      step: 'Adım (dakika)',
      requireDescription: 'Yapılan iş zorunlu',
      ownBillingType: 'Çalışanlar saat girerken faturalama türünü seçer (faturalanır, götürü bedele dahil, faturalanmaz). Görev ve projenin kuralı ön değerdir; kategori veya görevin sabit kuralı değişmez. Faturalanacak saatleri yine faturalama yetkilisi belirler.',
      warnDaily: 'Günlük saat uyarı sınırı',
      maxFuture: 'İleri tarihe giriş (gün)',
      deadline: 'Gönderme süresi (hafta sonundan sonra gün)',
      trackingStart: 'Kayıt başlangıcı (canlıya geçiş)',
      trackingStartHint: 'Hedef/gerçekleşen göstergeleri ve Power BI kapasite verileri bu günden itibaren sayılır.',
      billing: 'Faturalandırma',
      billingMoved: `Belgelerin varsayılanlarını (numara aralıkları, KDV, dil, düzenleyen, gün metinleri) "Faturalandırma" yetkisine sahip kişiler Faturalandırma'da "Belgelerin varsayılanları" altında değiştirir; önerilen ödeme vadesini Müşteriler › Koşullar altında. Her iki modül de yalnızca ek doğrulamayla açılır; teknik yönetim bunları değiştirmez.`,
      prefixSn: 'Saat dökümü numara öneki',
      prefixAb: 'Hakediş numara öneki',
      vat: 'KDV %',
      issuerName: 'Belgelerdeki firma adı',
      issuerAddress: 'Belgelerdeki adres',
      billingLanguage: 'Varsayılan belge dili',
      forma: 'Forma',
      deepLink: 'Issue bağlantı şablonu',
      security: 'Güvenlik',
      totpExternal: 'Hariciler için ikinci faktör',
      teamKpi: 'Ekip göstergeleri (kişisel performans verisi) açık. Örneğin Betriebsrat ile anlaşma yapılana kadar kapatılabilir.',
      leadLoadLevels: 'İş yükü renkleri proje liderleri ve planlama için de görünsün (saat olmadan). Plan değerlerini bilerek değiştiren biri renk değişiminden kişinin haftalık müsait saatini yaklaşık çıkarabilir; istenmiyorsa kapatın.',
      totpPrivileged: 'Ofis, yönetim ve yöneticiler için ikinci faktör',
      idle: 'Hareketsizlikte oturumu kapat (saat)',
      maxDays: 'En uzun oturum (gün)',
      bi: 'Power BI',
      pseudonymize: 'Power BI aktarımında adları kısaltmayla değiştir',
      companyName: 'Şirket adı',
      companyNameHint: 'Menüde, giriş sayfasında ve dışa aktarımlarda görünür.',
      logo: 'Logo',
      logoHint: 'PNG, JPG veya SVG; en fazla 600 × 200 piksele küçültülür ve hemen kaydedilir.',
      noLogo: 'logo yok',
      logoUpload: 'Logo yükle',
      logoChange: 'Logoyu değiştir',
      workLocations: 'Çalışma yerleri (kayıtta seçim)',
      workLocationsHint: 'Serbest metin yerine sabit liste. İlk değer yeni kayıtlar için varsayılandır.',
      hrKpi: 'Göstergeler',
      tolerance: 'Haftalık sapma uyarı eşiği (saat)',
      toleranceHint: 'Kapasiteden daha fazla sapan tamamlanmış haftalar "hedefin altında" veya "hedefin üstünde" olarak işaretlenir.',
      snDefaultHint: 'Yeni saat raporları için varsayılan; belgede değiştirilebilir.',
      docSick: 'Hastalıkta belge, şu takvim gününden itibaren',
      docChildSick: 'Çocuk hastalığında belge, şu takvim gününden itibaren',
      docHint: '0 = belge beklenmez. Beklenen belge eksikse kişi ve personel birimi bir uyarı görür; hastalık bildirimi yine de geçerlidir.',
      retention: 'Belgeleri sakla (izin bitiminden sonra ay)',
      retentionHint: '0 = süresiz sakla. Sonrasında gece bakımı dosyaların içeriğini siler; ad ve zaman kayıtta kalır.',
      saturdayLeaveTR: 'Türkiye: izin içindeki cumartesi yıllık izin günü sayılır',
      saturdayLeaveTRHint: 'Türk resmi tatil takvimindeki ve haftada 5 gün çalışan kişiler için: iş sözleşmesi cumartesiyi hafta tatili olarak belirlemiyorsa iki izin günü arasındaki cumartesi yıllık izin günü sayılır (Yargıtay; İş Kanunu m. 56). Kapalı: yalnızca sözleşmedeki iş günleri sayılır (çalışan lehine). Pazar, resmi tatiller ve cumartesiye denk gelen tatiller hiçbir zaman sayılmaz; hedef süre değişmez.',
      leaveRulesHint: 'Yıllık izin günleri yalnızca sözleşmedeki iş günlerinde sayılır; hafta sonları, kişinin takvimindeki resmi tatiller ve izinli günler sayılmaz. İzindeyken hastalanan kişinin raporunu personel birimi girer: izin günleri iade edilir (Almanya § 9 BUrlG; Türkiye: İş Kanunu m. 56, Yıllık Ücretli İzin Yönetmeliği m. 6), izin uzamaz. Ayrıntılar: Yardım › Devamsızlıklar.',
      standardsUrl: 'Şirket standartları bağlantısı',
      standardsUrlHint: 'Şirketin yönergeleri, şablonları ve düzenlerini tuttuğu sayfa (örn. SharePoint). Ana sayfa yalnızca oraya bağlantı verir; içerik platforma taşınmaz.',
      links: 'Kenar çubuğundaki bağlantılar',
      linksHint: 'Kendi adınızın üstünde, yalnızca adres girildiğinde görünür. Kendi etiketiniz yoksa her dilin standart etiketi kullanılır. İçerik platforma kopyalanmaz.',
      linkUrl: {
        standards: 'Şirket standartları ve şablonlar (adres)',
        meetings: 'Koordinasyon toplantısı notları (adres)',
        website: 'Şirketin web sitesi (adres)',
        formaHome: 'Forma My Home (adres; varsayılan https://acc.autodesk.eu/home)',
        sharepoint: 'Şirket SharePoint’i, ana klasör (adres)',
      },
      linkLabel: 'Etiket (isteğe bağlı)',
      automations: 'Otomasyonlar',
      automationsIntro: 'Platformun kendi ürettiği hatırlatmalar: harici hizmet ve e-posta yok. Her kural bir kişiye yalnızca zaten görmeye yetkili olduğunu gösterir.',
      autoWeekly: 'Haftayı gönderme süresi (çalışanlar)',
      autoMissing: 'Eksik kayıtlar: kaydı olmayan iş günleri (çalışanlar)',
      autoMissingDays: 'Geriye bakış (iş günü)',
      autoPending: 'Bekleyen onaylar (onaylayanlar)',
      autoPendingDays: 'Şu kadar günden sonra vurgula (gün)',
      autoMonth: 'Ayın ilk iş günlerinde ay kapanışı (ofis, yönetim)',
      jobsTitle: 'Arka plan görevleri (yalnızca görüntüleme)',
      jobForma: 'Forma eşitlemesi',
      jobFormaWhen: '{{minutes}} dakikada bir, {{window}}',
      jobOutlook: 'Outlook takvimleri',
      jobOutlookWhen: 'bağlantı açıksa 5 dakikada bir',
      jobNightly: 'Gece çalışması',
      jobNightlyWhen: '02:30: eşitleme, anlık görüntü, kapasite değerleri, saklama süreleri, Power BI dışa aktarımı (kuruluysa)',
      jobsHint: 'Bu görevler her zaman çalışır. Forma eşitlemesinin sıklığını ve zaman penceresini "Forma / Power BI" bölümünde ayarlarsınız.',
      paymentDays: 'Varsayılan ödeme vadesi (gün)',
      paymentDaysHint: 'Bir projenin koşulları oluşturulurken önerilen ödeme vadesi. Proje bazındaki koşullar Müşteriler › Koşullar altındadır.',
      noOvertime: 'Fazla mesaiye etkisi olmayan saatlere izin ver (“fazla mesai sayılmaz”)',
      noOvertimeHint: 'Girilen bazı saatler fazla mesai bakiyesini artırmamalıdır; örn. akşam gönüllü eğitim, mesai dışındaki bir firma etkinliği veya sözleşmeye göre çalışma süresi sayılmayan yol süresi. Açıkken kayıtlar (kişi, onaylayan veya personel birimi tarafından) ve tüm kategoriler bu şekilde işaretlenebilir. Saatler girilmiş, projede görünür ve faturalandırılabilir kalır; yalnızca fazla mesai bakiyesine sayılmaz. Kapalı (varsayılan): girilen her saat sayılır. Açmadan önce Betriebsrat ile netleştirin (A-10).',
      outlookHolidays: 'Tatilleri kişisel takvimlere yaz',
      outlookHolidaysHint: 'Her kişi tatillerini Projektzeit’tan (takvim, firma günleri, kişiye özel değişiklikler) “ofis dışında” randevusu olarak alır; değişiklikler aktarılır. Outlook’un kendi tatil takvimini ayrıca eklemeyin, aksi halde günler iki kez görünür (Outlook: Dosya > Seçenekler > Takvim > Tatil ekle – kullanmayın).',
      splitRuleTR: 'Türkiye: 10 günlük izin parçası uyarısı',
      splitRuleTRHint: 'Kapalı (varsayılan). Açık: yıl içinde en az 10 iş günlük bir izin parçası artık mümkün değilse onay ekranı uyarı gösterir (İş Kanunu m. 56/3). Hiçbir şey engellenmez.',
      leaveTwoStage: 'İzin taleplerini iki aşamada onayla',
      leaveTwoStageHint: 'Kapalı (varsayılan): atanmış kişi (Kişiler > izinlerin onayı) tek başına karar verir. Açık: önce o kişi onaylar, ardından personel birimi karar verir; personel birimi her zaman doğrudan karar verebilir. Atanmış kişi yoksa ve hastalık bildirimlerinde karar personel biriminde kalır.',
    },
    periods: {
      hint: 'Kapatılan ay artık değiştirilemez. Açık kayıtları önce netleştirin.',
      lock: 'Kapat',
      unlock: 'Yeniden aç',
      locked: 'Kapalı',
      open: 'Açık',
      openEntries: 'Taslaklar',
      submitted: 'İncelemede',
      approved: 'Onaylı',
      billed: 'Faturalandı',
      forceTitle: 'Açık kayıtlara rağmen ay kapatılsın mı?',
      forceText: '{{count}} kayıt henüz onaylanmadı. Kapatılan ayda değişmeden kalırlar.',
      forceText_one: '{{count}} kayıt henüz onaylanmadı. Kapatılan ayda değişmeden kalırlar.',
      unlockTitle: 'Ayı yeniden aç',
    },
    forma: {
      connStatus: {
        connected: 'bağlı',
        disconnected: 'bağlı değil',
        error: 'hata',
      },
      nextRun: 'Sonraki senkron',
      load: 'Her çalışmada: {{projects}} aktif proje, yaklaşık {{requests}} istek, yaklaşık {{minutes}} dk.; günde yaklaşık {{perDay}} istek. Eşitlenmeyen: {{skipped}} durdurulmuş, tamamlanmış, iptal edilmiş veya arşivlenmiş proje. Projektzeit dakikada en fazla {{rpm}} istek gönderir ve Autodesk ara vermesini istediğinde bekler.',
      loadWarn: 'Bir çalışma neredeyse tüm aralığı dolduruyor: aralığı büyütün veya biten projeleri tamamlandı olarak işaretleyin.',
      connection: 'Bağlantı',
      mode: 'Mod',
      modes: {
        mock: 'Demo (kurgusal veri)',
        user_3lo: 'Servis kullanıcısı (oturum)',
        ssa: 'Secure Service Account',
      },
      hub: 'Hub',
      connect: 'Forma\'ya giriş yap',
      notConfigured: 'Forma ayarlanmamış (FORMA_MODE). Kurulum kılavuzuna bakın.',
      projects: 'Bağlı projeler',
      runs: 'Son eşitlemeler',
      syncAll: 'Tümünü eşitle',
      fullAll: 'Tüm projelerde tam eşitleme',
      kind: {
        full: 'tam',
        incremental: 'değişiklikler',
      },
      statsHeader: 'alınan / yeni / değişen / işaretlenen',
      duration: 'Süre',
      token: 'Oturum geçerlilik sonu',
      runStatus: {
        ok: 'tamam',
        warning: 'uyarı',
        error: 'hata',
        running: 'çalışıyor',
      },
      filesTemplate: 'Bir projenin “Dosyalar” adresi ({projectId})',
      boardTemplate: '“Forma Board” adresi (genel giriş; {projectId} kullanılabilir)',
      linksHint: 'Forma bağlantılı projelerde proje sayfası “Forma: Dosyalar” ve “Forma Board” butonlarını gösterir. Bir proje, Forma sekmesinde kendi Board adresini taşıyabilir.',
    },
    backup: {
      countsOnly: 'Tablo başına satır sayısı. Kişi, tarih ve saatle değişen kayıtları sadece "Tam dışa aktarım ve Power BI" yetkisi olan görür.',
      title: 'Yedekleme',
      hint: 'Veritabanı her gece eksiksiz yedeklenir (sunucu). Burada: karşılaştırma için anlık görüntüler ve tam dışa aktarımlar.',
      snapshots: 'Anlık görüntüler',
      create: 'Anlık görüntü oluştur',
      label: 'Etiket',
      compare: 'Karşılaştır',
      compareWith: 'Şununla karşılaştır',
      current: 'güncel durum',
      download: 'İndir',
      exportAll: 'Tam dışa aktarım',
      exportXlsx: 'Excel (tüm tablolar)',
      exportJson: 'JSON (eksiksiz)',
      powerbi: 'Power BI',
      powerbiHint: 'İsteğe bağlı: kendi Power BI raporlarınız için CSV dosyaları. SharePoint kuruluysa her gece oraya yazılır; burada elle. Projektzeit içindeki değerlendirmeler için gerekmez.',
      powerbiDownload: 'CSV paketi oluştur',
      powerbiUpload: 'SharePoint\'e yükle',
      result: 'Karşılaştırma',
      protectedOk: 'Korunan veri silinmemiş.',
      protectedBad: '{{count}} korunan kayıt eksik. Hemen kontrol edin.',
      protectedBad_one: '{{count}} korunan kayıt eksik. Hemen kontrol edin.',
      table: 'Tablo',
      before: 'Önce',
      after: 'Sonra',
      added: 'yeni',
      removed: 'silinen',
      changed: 'değişen',
      entryChanges: 'Değişen saat kayıtları',
      monthTotals: 'Farklılık gösteren aylık toplamlar',
      kinds: {
        nightly: 'gece',
        manual: 'elle',
        before_change: 'değişiklik öncesi',
      },
      protected: 'korumalı',
      size: 'Boyut',
      entriesCount: 'Saat kayıtları',
    },
    audit: {
      masked: 'İçerik sadece yetkililere açık (ör. saatler, sözleşme bilgileri, faturalama)',
      action: 'İşlem',
      entity: 'Nesne',
      who: 'Kim',
      when: 'Ne zaman',
      change: 'Değişiklik',
      shown: '{{count}} olay gösteriliyor',
      moreWhileScrolling: '{{count}} olay gösteriliyor, kaydırdıkça devamı gelir',
      partlyMasked: 'Bazı değerler sadece yetkililere açık (ör. ücret, bütçe, saatler, ücret oranları)',
    },
  },
  profile: {
    title: 'Profil',
    language: 'Dil',
    password: 'Parolayı değiştir',
    current: 'Mevcut parola',
    newPassword: 'Yeni parola',
    changed: 'Parola değiştirildi',
    myExport: 'Saatlerimi dışa aktar',
    demoNote: 'Demoda oturum açma yok. Rol yukarıdan değiştirilebilir.',
    picture: 'Profil resmi',
    pictureUpload: 'Resim yükle',
    pictureChange: 'Resmi değiştir',
    pictureHint: 'JPG, PNG veya WebP. Kare kırpılır ve küçültülür. Oturum açmış iş arkadaşları görebilir.',
    themeHint: 'Açık, koyu veya işletim sistemindeki ayar.',
    access: 'Erişim',
    accessHint: 'Erişimi yönetim kurar. Şifre unutulursa yönetim yeni bir kurulum bağlantısı gönderir.',
  },
  auth: {
    entraMismatch: 'Bu Microsoft hesabı, bu e-postaya bağlı hesapla eşleşmiyor. Lütfen yönetimden erişiminizi sıfırlamasını isteyin.',
    title: 'Giriş yap',
    email: 'E-posta',
    password: 'Parola',
    totp: 'Doğrulama uygulamasındaki kod',
    signIn: 'Giriş yap',
    signInMicrosoft: 'Microsoft ile giriş yap',
    or: 'veya',
    setupTitle: 'Erişimi kur',
    setupFor: '{{name}} ({{email}}) için erişim',
    setPassword: 'Parola belirle',
    passwordRules: 'En az 10 karakter; küçük harf, büyük harf, rakam ve özel karakterden üç türü içermeli.',
    totpSetupTitle: 'İkinci faktörü kur',
    totpSetupText: 'QR kodunu Microsoft Authenticator veya başka bir uygulamayla okutun ve gösterilen kodu girin.',
    totpManual: 'Elle giriş için anahtar',
    enable: 'Etkinleştir',
    entraUnknown: 'Bu Microsoft hesabı platformda tanımlı değil.',
    entraFailed: 'Microsoft girişi başarısız oldu.',
    noAccess: 'Erişiminiz yok veya şifrenizi mi unuttunuz? Yönetim bir kurulum bağlantısı gönderir.',
  },
  overview: {
    fastTask: 'Plandan hızlı: {{ref}} {{title}} (plan {{plan}} sa, sizin süreniz {{own}} sa)',
    fastCheck: 'Planın çok altında mı? Tüm saatlerin girildiğini kısaca kontrol edin.',
    overPlanTitle: 'Planı aşan görevler ({{count}})',
    overPlanHint: 'Planlanandan fazla saat girilmiş açık görevler. Planı güncelleyin veya nedenini netleştirin.',
    hello: 'Merhaba {{name}}',
    toWeek: 'Haftaya git',
    openLastWeek: 'Geçen hafta: {{count}} kayıt henüz gönderilmedi',
    openLastWeek_one: 'Geçen hafta: {{count}} kayıt henüz gönderilmedi',
    openOlder: '{{count}} eski taslak',
    openOlder_one: '{{count}} eski taslak',
    approvals: 'Onay bekleyenler',
    approvalsL1: 'Proje liderinde',
    approvalsFinal: 'Ofiste',
    toApprovals: 'İncele',
    budget: 'Bütçe %80 ve üzeri',
    forma: 'Forma\'dan uyarılar',
    formaText: 'Bu görevlerin açık kayıtları var, ancak Forma\'da silinmiş veya artık görünmüyorlar.',
    billing: 'Faturalandırma',
    draftDocs: '{{count}} taslak',
    draftDocs_one: '{{count}} taslak',
    unbilled: '{{hours}} sa onaylı, faturalanmamış',
    system: 'Sistem',
    syncErrors: 'Forma eşitlemesi: 24 saatte {{count}} hata',
    syncErrors_one: 'Forma eşitlemesi: 24 saatte {{count}} hata',
    syncOk: 'Forma eşitlemesi hatasız',
    lastSnapshot: 'Son anlık görüntü: {{when}}',
    mine: 'Benim alanım',
    lead: 'Yönetim',
    toCockpit: 'Kokpite git',
    myWeekTitle: 'Haftam ({{week}}. hafta)',
    remaining: 'hedefe {{hours}} sa kaldı',
    weekFull: 'Bu haftanın hedefi tamamlandı',
    allGood: 'Her şey gönderildi, dikkat gerektiren bir şey yok.',
    weekUnder: '{{week}}. hafta: hedef saatinizin {{hours}} sa altında. Eksik kayıt veya devamsızlık mı var?',
    weekOver: '{{week}}. hafta: hedef saatinizin {{hours}} sa üzerinde (fazla mesai).',
    stateHint: 'Haftalık {{hours}} sa üzeri sapmada uyarı. Resmi tatiller ve onaylanan devamsızlıklar hedef saatten düşülür.',
    myFigures: 'Göstergelerim',
    periods: {
      month: 'Ay',
      quarter: 'Çeyrek',
      year: 'Yıl',
    },
    targetActual: 'Gerçekleşen / hedef',
    weekStates: 'Hedefin altında: {{under}} hafta, üstünde: {{over}} hafta',
    planVsActual: 'Görevler: plan ve gerçekleşen',
    showLess: 'Daha az göster',
    showAll: 'Tümünü göster ({{count}})',
    doneOn: 'Tamamlanma',
    planTask: 'Plan (sa)',
    actualTask: 'Toplam gerçekleşen (sa)',
    ownHours: 'Benim saatlerim (sa)',
    personHours: 'kişinin payı (sa)',
    factor: 'Faktör',
    leadQuiet: 'Açık konu yok.',
    layout: {
      button: 'Özelleştir',
      title: 'Ana sayfayı özelleştir',
      hint: 'Blokları gösterin veya gizleyin ve sıralarını değiştirin. Ayar, hesabınız için tüm cihazlarda geçerlidir.',
      reset: 'Varsayılan',
      up: 'Yukarı taşı',
      down: 'Aşağı taşı',
      tiles: 'Kutucuklar',
      blocks: {
        tiles: 'Kutucuklar',
        work: 'İşlerim',
        week: 'Haftam',
        announcements: 'Duyurular',
        upcoming: 'Yaklaşanlar',
        figures: 'Göstergelerim',
        lead: 'Yönetim için',
      },
    },
  },
  demo: {
    viewAs: 'Görünüm',
    personasHint: 'Yetkileri ve görünürlüğü karşılaştırmak için rol değiştirin.',
    filePreview: 'Oluşturulan dosyanın önizlemesi',
    downloadBlocked: 'Demo görüntüleyicide doğrudan indirme kapalı: dosya burada gösterilir ve "İndir" ile kaydedilebilir.',
    formaLink: 'Demoda görevlerin arkasında gerçek bir Forma projesi yok. Kurulu platformda bu bağlantı görevi Autodesk Forma\'da (yeni sekmede) açar.',
    download: 'İndir',
    downloadSaved: 'Dosya kaydedildi',
    downloadFailed: 'Dosya kaydedilemedi. Lütfen yeniden deneyin.',
    downloadUnavailable: 'Bu görünümde indirme yapılamıyor: dosya burada yalnızca gösterilir.',
  },
  planning: {
    title: 'Planlama',
    subtitle: 'Görev başına plan saatleri ve haftalık personel planı. Proje liderleri ve yönetim için.',
    noProjects: 'Planlanacak proje yok. Proje liderleri (kendi projeleri) ve yönetim planlama yapabilir.',
    chooseProject: 'Proje seçin',
    openPlanning: 'Plan saatlerini düzenle',
    tabs: {
      tasks: 'Görevler (plan saatleri)',
      staff: 'Haftalık personel',
    },
    tasksInfo: 'Plan saatleri görev bazında plan/gerçekleşen karşılaştırmasının temelidir; en iyisi işe başlamadan girin. Sadece burada tutulur, Forma\'dan saat gelmez. Boş = henüz plan yok, 0 = görev değerlendirilmez. Her değişiklik kayıt altına alınır.',
    onlyOpen: 'Yalnızca açık görevler',
    onlyWithoutPlan: 'Yalnızca plansız',
    planHours: 'Plan (sa)',
    noPlan: 'plan yok',
    legend: 'Saat olarak girin, ör. 12 veya 12,5. Enter veya alandan çıkmak kaydeder, Esc vazgeçer.',
    bulkSet: 'Plan belirle',
    bulkRemove: 'Kendi planını kaldır',
    bulkHint: 'Seçili {{count}} görev için geçerli. 0 = değerlendirme.',
    bulkHint_one: 'Seçili {{count}} görev için geçerli. 0 = değerlendirme.',
    bulkDone: '{{count}} görev değişti',
    bulkDone_one: '{{count}} görev değişti',
    location: 'Konum',
    subLocation: 'Alt konum',
    site: 'Proje konumu',
    noLocation: 'Forma\'da konum yok',
    filters: {
      status: 'Durum',
      allStatus: 'Tüm durumlar',
      due: 'Bitiş',
      dueAny: 'Tüm tarihler',
      dueOverdue: 'Gecikmiş',
      due7: '7 gün içinde biten',
      due14: '14 gün içinde biten',
      dueNone: 'Tarihsiz',
      plan: 'Plan',
      planAny: 'Tüm planlar',
      planNone: 'Plansız',
      planZero: 'Değerlendirilmeyen (0)',
      planSet: 'Planlı',
      booked: 'Kayıtlar',
      bookedAny: 'Tümü',
      bookedNone: 'Kayıtsız',
      bookedSome: 'Kayıtlı',
      sort: 'Sıralama',
      sortRef: 'Numara',
      sortDue: 'Bitiş tarihi',
      sortBooked: 'Girilen (çoktan aza)',
      sortPlan: 'Plan (büyükten küçüğe)',
      reset: 'Filtreleri sıfırla',
    },
  },
  evaluation: {
    title: 'Personel değerlendirme',
    subtitle: 'Görüşmeler ve yönetim için kişi bazında göstergeler. Kimin ne zaman müsait olduğu İş yükü sayfasındadır.',
    noAccess: 'Yalnızca yönetim için ("Ekip göstergeleri" yetkisi).',
    signalFastTitle: 'Plandan belirgin hızlı biten görevler',
    signalFastText: 'Plan/gerçekleşen oranı %{{percent}} ve üzeri olan tamamlanmış görevler. Planı kontrol edin (fazla mı büyük?) veya iyi çözümü ekiple paylaşın. Değer göreve aittir, kişiye değil.',
    signalOverTitle: 'Hedef saatin üstünde',
    signalOverText: 'Hedef saatin {{hours}} sa üzerinde geçen haftalar: fazla mesai; iş yükünü konuşun.',
    signalUnderTitle: 'Hedef saatin altında',
    signalUnderText: 'Hedef saatin {{hours}} sa altında kalan haftalar: eksik kayıt veya devamsızlığı netleştirin.',
    sort: 'Sırala',
    sortBy: {
      name: 'Ad',
      balance: 'Bakiye (en düşük önce)',
      billable: 'Faturalanabilir pay',
      flags: 'Uyarılar (en çok önce)',
    },
    hint: 'Plan/gerçekleşen oranı = tamamlanan görevlerin plan saatleri / bu görevlere girilen saatler. Ortak görevlerde herkes için aynıdır; kişinin kendi işi hakkında sadece ağırlıklı olarak tek başına yapılan görevlerin değeri bilgi verir. Ancak birden fazla görevde ve iyi plan kalitesinde anlamlıdır; sıralama değildir ve tek başına personel kararlarına dayanak değildir.',
    criteria: {
      title: 'Değerlendirme kriterleri',
      intro: 'Değerlendirme bu kriterlere dayanır. Seçim yalnızca bu görünümde hangi sütunların gösterileceğini belirler (bu cihaz için); rakamların kendisi değişmez.',
      show: 'Kriterler',
      all: 'Tümünü göster',
      balance: {
        name: 'Hedef süre ve bakiye',
        desc: 'Seçilen dönemde girilen saatler ile sözleşme, resmi tatil ve devamsızlıklardan çıkan hedef süre.',
      },
      weeks: {
        name: 'Hafta uyarıları',
        desc: 'Hedef süreden {{hours}} saatten fazla az veya çok olan tamamlanmış haftalar (tolerans ayarlardan).',
      },
      billable: {
        name: 'Faturalanabilir pay',
        desc: 'Faturalanabilir saatlerin tüm girilen saatlere oranı (sabit bedel ve faturalanmayan hariç).',
      },
      projectShare: {
        name: 'Proje çalışması payı',
        desc: 'Proje işinin girilen saatler içindeki payı; iç süreler (eğitim, iş geliştirme, idari) ayrı gösterilir.',
      },
      efficiency: {
        name: 'Plan/gerçekleşen oranı',
        desc: 'Tamamlanan görevlerin plan saatlerinin girilen saatlere oranı: %{{good}} üzeri yeşil, %{{low}} altı uyarı. Değer göreve aittir, sıralama değildir.',
      },
      punctuality: {
        name: 'Zamanında gönderilen',
        desc: 'Süre içinde ({{days}} gün hafta sonundan sonra) gönderilen haftalar.',
      },
      corrections: {
        name: 'Düzeltme istenen',
        desc: 'Onay sırasında düzeltme için geri gönderilen kayıtların oranı.',
      },
      thresholds: 'Eşikler: plan/gerçekleşen %{{good}} üzeri yeşil, %{{low}} altı uyarı; hafta toleransı {{hours}} sa; gönderim süresi {{days}} gün.',
    },
    export: {
      title: 'Dışa aktar',
      chosen: 'Seçilen {{count}} kişi:',
      chosen_one: 'Seçilen 1 kişi:',
      all: 'Tüm kişiler:',
      html: 'HTML (etkileşimli)',
      htmlHint: 'Her tarayıcının hesap olmadan açabildiği tek dosya; değerlerin üzerine gelince açıklamaları görünür.',
      person: 'Bu kişiyi dışa aktar:',
      reportTitle: 'Personel değerlendirme (gizli)',
      detailsLimited: 'Haftalar ve projeler ilk {{count}} kişi için eklendi; diğer kişileri tek tek veya daha küçük gruplar halinde dışa aktarın.',
    },
    selectHint: 'Yalnızca onları dışa aktarmak için kişileri işaretleyin; seçim yoksa dışa aktarma herkesi kapsar.',
    balanceCol: 'Fark (gerçekleşen − hedef)',
    balanceHint: 'Dönemde girilen saatler eksi hedef saatler. Artı: hedeften fazla girilmiş (fazla çalışma), eksi: daha az. Hedef = sözleşme saatleri eksi resmi tatiller ve devamsızlıklar.',
    basis: {
      title: 'Değerlendirmenin dayanağı ve “en yüksek” ile “en düşük” değerin anlamı',
      data: 'Veri: seçilen dönemde girilen saatler (gönderilmiş ve onaylanmış; taslaklar ancak gönderildikten sonra sayılır), plan saati olan görevler ve onay işlemleri.',
      target: 'Hedef: iş günü başına sözleşme saatleri; resmi tatiller, izin, hastalık ve diğer devamsızlıklar düşülür; kişinin kayıt başlangıcından itibaren.',
      balance: 'Fark = gerçekleşen − hedef. Artı hedeften fazla, eksi daha az girildiği anlamına gelir. Fark bir değerlendirme değildir: fazla çalışma kararlaştırılmış, eksi esnek çalışmayla açıklanabilir olabilir.',
      noScore: 'Genel bir not ve sıralama yoktur. Her sütun kendi başına bir ölçüttür; “en yüksek” ve “en düşük” değer yalnızca o sütun içinde geçerlidir (sütun başlığına tıklama sıralar, ikinci tıklama sırayı çevirir).',
      extremes: 'Hedefin {{hours}} saatten fazla altında veya üstünde kalan haftalar, hedefin altındaki plan/gerçekleşen oranı ve çok sayıda ret dikkat çeker – her zaman bir görüşme vesilesi olarak, hüküm olarak değil.',
      context: 'Göstergeler plan kalitesine, görevlerdeki ortak çalışmaya ve proje rollerine bağlıdır; tek başlarına personel kararlarına dayanak değildir (Betriebsrat’ın katılım hakkı gözetilmeli).',
    },
  },
  absencesPage: {
    title: 'Devamsızlıklar ve tatiller',
    subtitle: 'Haklar ve bakiyeler, tüm devamsızlıklar, giriş ve içe aktarma, bordro için fazla mesai, resmi tatiller ve firma etkinlikleri. Talepler Onaylar sayfasında karara bağlanır.',
    noAccess: 'Sadece personel birimi (devamsızlıklar) ve yönetim (tatiller, firma etkinlikleri) için.',
    searchPerson: 'Kişi ara',
  },
  areas: {
    title: 'Alan bazında saatler',
    titleMine: 'Zamanımı neye ayırdım',
    area: 'Alan',
    project: 'Proje çalışması',
    internal: 'Şirket içi',
    forma: 'Forma görevleri',
    hintMine: 'Alan = manuel görevin kategorisi (ör. toplantı, şantiye) veya Forma görevleri. Şirket içi = proje dışı zaman, ör. eğitim, Ar-Ge, idari işler. Yalnızca siz görürsünüz.',
    hintCockpit: 'Dönemde girilen tüm saatlerin toplamı, kişi bazında değil.',
    hintLead: 'Projelerinizde girilen saatlerin toplamı, kişi bazında değil.',
    shareHint: 'Projelerdeki saatlerin payı (şirket içi proje hariç)',
    internalHours: 'şirket içi {{hours}} sa',
  },
  hourTypes: {
    title: 'Saat türleri',
    type: 'Tür',
    billable: 'Faturalanabilir',
    included: 'Dahil (götürü ücret)',
    nonBillableProject: 'Proje, faturalanmaz',
    internal: 'Dahili',
    termsTitle: 'Kavramlar: planlanan, girilen, faturalanan ve saat türleri',
    coverageShort: 'plansız {{hours}} sa',
    coverageTitle: 'Oran, tamamlanan görevlerdeki saatlerin {{pct}} kadarını kapsıyor. Plan saati olmayan {{count}} tamamlanmış görevdeki {{hours}} sa değerlendirilmiyor.',
    coverageTitle_one: 'Oran, tamamlanan görevlerdeki saatlerin {{pct}} kadarını kapsıyor. Plan saati olmayan {{count}} tamamlanmış görevdeki {{hours}} sa değerlendirilmiyor.',
    coverageNotice: 'Tamamlanan görevlerin bir kısmında plan saati yok: ekipte plan/gerçekleşen oranı tamamlanan görevlerdeki saatlerin yalnızca {{pct}} kadarını kapsıyor, {{hours}} sa değerlendirilmiyor. "Plansız" notu olan değerleri dikkatle okuyun; plan saatlerini Forma\'da veya manuel görevlerde tamamlayın.',
    coverageInfo: 'Bazı tamamlanmış görevlerde plan saati yok (ekipte {{hours}} sa); bu saatler plan/gerçekleşen oranına girmiyor.',
    terms: {
      plan: {
        name: 'Planlanan',
        desc: 'Bir görevin plan saatleri (Forma alanı veya manuel görevde girilen değer). Plan/gerçekleşen oranına yalnızca planı olan tamamlanmış görevler girer. Boş = planlanmamış: değerlendirilmez ama "plansız" olarak gösterilir; 0 = bilerek değerlendirme dışı.',
      },
      booked: {
        name: 'Girilen (gerçekleşen)',
        desc: 'Kişinin girdiği saatler. Hedef/gerçekleşen, bakiye, doluluk ve plan/gerçekleşen oranının temeli. Kişisel göstergeler yalnızca girilen saatleri kullanır.',
      },
      billed: {
        name: 'Faturalanan',
        desc: 'Ofisin saat dökümüne aktardığı saatler; girilen saatlerden farklı olabilir. Proje analizinde ve faturalandırmada (girilene karşı faturalanan) görünür, kişinin değerlendirmesinde yer almaz.',
      },
      billable: {
        name: 'Faturalanabilir',
        desc: 'Müşteri belgesinde saat bazında görünen proje çalışması.',
      },
      included: {
        name: 'Dahil (götürü ücret)',
        desc: 'Götürü ücretin kapsadığı proje çalışması: götürü projenin dökümünde yer alır, ayrıca ücretlendirilmez.',
      },
      nonBillableProject: {
        name: 'Proje, faturalanmaz',
        desc: 'Müşteri projesinde ücretlendirilmeyen iş (örn. iç kontrol). Proje çalışması sayılır ama hiçbir müşteri belgesinde görünmez. Tür, görevden veya kategorisinden gelir.',
      },
      internal: {
        name: 'Dahili',
        desc: 'Dahili projedeki zaman, örn. Ar-Ge, eğitim, idari işler: proje çalışması değildir, hiçbir zaman faturalanmaz. Her kayıt gibi hedef süreye sayılır.',
      },
      example: {
        name: 'Örnek',
        desc: '20 sa planlı, 5 sa girilip tamamlanmış, 8 sa faturalanmış görev: plan/gerçekleşen oranı %400 (planın çok altında), kişinin hedef/gerçekleşeni +5 sa, proje analizinde 5 sa girilen ve 8 sa faturalanan.',
      },
    },
  },
  scope: {
    button: 'Değerleri sınırla',
    col: 'Projede',
    title: 'Projede "{{field}}" değerleri',
    intro: 'Bu alanın hangi değerlerinin projede kullanıldığı: tüm projede, bina bazında ve Forma\'daki konum bazında. Proje analizi yalnızca bu değerleri kullanır; başka bir değere sahip görev orada "değer yok" sayılır ve listelenir. Forma\'daki görevler değişmez.',
    targets: 'Kapsam',
    project: 'Tüm proje',
    buildings: 'Binalar ({{field}})',
    locations: 'Forma konumları',
    all: 'tümü',
    inherit: 'devralınır',
    count: '{{m}} değerden {{n}}',
    selectAll: 'Tümü',
    selectNone: 'Hiçbiri (devral)',
    reset: 'Tüm değerler',
    hintProject: 'Seçilmeyen değerleri proje kullanmaz. Tümü seçili = sınırlama yok.',
    hintPlace: 'Bu binanın veya konumun kullandığı değerler (örn. katları). Seçim yoksa üst konumun, binanın veya tüm projenin değerleri geçerlidir.',
    tasks: '{{count}} görev',
    notOffered: 'artık Forma\'da yok',
    floorHint: 'Bu seçimdeki görevi olmayan katlar analizdeki binada boş (taralı) görünür, seçim dışındaki katlar hiç görünmez.',
    saved: 'Değerler kaydedildi. {{count}} görevin değeri kapsam dışında; analizde listelenir.',
    saved_one: 'Değerler kaydedildi. {{count}} görevin değeri kapsam dışında; analizde listelenir.',
    savedNone: 'Değerler kaydedildi.',
    summaryAll: 'tüm değerler',
    summaryPlaces: '+ {{count}} bina/konum',
    summaryPlaces_one: '+ {{count}} bina/konum',
    notice: '{{count}} görevin değeri projenin değerleri dışında: {{list}}. Projede olmayan bir kat veya disiplin görünmesin diye burada "değer yok" sayılırlar. Değeri Forma\'da düzeltin veya projenin değerlerini uyarlayın.',
    notice_one: '{{count}} görevin değeri projenin değerleri dışında: {{list}}. Projede olmayan bir kat veya disiplin görünmesin diye burada "değer yok" sayılır. Değeri Forma\'da düzeltin veya projenin değerlerini uyarlayın.',
    edit: 'Değerleri düzenle',
    taskMark: 'Projenin değerleri dışında: {{list}}',
  },
  staffing: {
    title: 'Kim nerede çalışıyor',
    intro: 'Projeler ve içindeki kişiler: dönemde girilen saatler (koyulaştıkça daha fazla), proje lideri (PL) ve saati olmayan üyeler. Başkalarının taslakları sayılmaz, dahili proje dahil değildir.',
    introLead: 'Proje lideri olduğunuz projeler ve içindeki kişiler: dönemde girilen saatler (koyulaştıkça daha fazla) ve saati olmayan üyeler. Başkalarının taslakları sayılmaz.',
    period: 'Dönem',
    ranges: {
      '4w': 'Son 4 hafta',
      '3m': 'Son 3 ay',
      '12m': 'Son 12 ay',
    },
    searchProject: 'Proje ara',
    onlyHours: 'Yalnızca saati olanlar',
    inactive: 'Duraklatılan ve tamamlananlar da',
    cellHours: 'dönemde {{hours}} sa',
    cellNoHours: 'dönemde saat yok',
    noMember: 'proje ekibinde değil (açık proje)',
    legendMember: 'Saati olmayan üye',
    hint: '“Kim nerede çalışıyor” yetkisiyle görünür (varsayılan: çalışanlar, ofis, teknik yönetim; harici kişiler hariç). Saatler yalnızca zaten saatlerini gördüğünüz projeler için. Renk = en büyük hücreye oranı; sayı her zaman saat sayısıdır.',
    introBoxes: 'Kimin hangi aktif projede çalıştığı: dolu kutucuk “projede çalışıyor” demektir, “PL” proje liderini gösterir. Saatleri yalnızca proje lideri (kendi projeleri), ofis ve yönetim görür.',
    archived: 'Arşivlenenler de',
    archivedTag: 'arşivlendi',
    projectName: 'Proje, işveren, proje lideri',
    cellWorks: 'projede çalışıyor',
    legendWorks: 'projede çalışıyor (saatsiz)',
  },
  days: {
    mode: 'Seçim türü',
    modes: {
      range: 'Tarih aralığı, yarım gün, saat',
      days: 'Takvim',
    },
    prev: 'Önceki ay',
    next: 'Sonraki ay',
    noWorkday: 'iş günü değil',
    chosen: '{{count}} gün seçildi',
    chosen_one: '{{count}} gün seçildi',
    clear: 'Seçimi temizle',
    legendHoliday: 'Resmi tatil',
    legendAbsence: 'zaten girilmiş',
    hint: 'İş günlerine tıklayın, birden fazla ay boyunca da olabilir; Shift+tıklama iki gün arasındaki tüm iş günlerini seçer. Hafta sonları, tatiller ve izinli günler seçilemez ve asla sayılmaz. Yarım gün tatilleri (½) tam gün olarak seçin: yarım gün izin sayılır. Tek bir günde yarım gün izin veya saatlik izin için: “Tarih aralığı, yarım gün, saat”.',
    records: '{{count}} kayıt olarak kaydedilecek',
    records_one: '{{count}} kayıt olarak kaydedilecek',
    ignored: 'Seçilen {{count}} gün iş günü değil ve sayılmaz',
    ignored_one: 'Seçilen {{count}} gün iş günü değil ve sayılmaz',
    halfHoliday: 'yarım gün tatil: tam gün izin burada ½ sayılır',
    holidaysOfMonth: 'Ayın tatilleri',
    halfAm: 'yarım gün, öğleden önce',
    halfPm: 'yarım gün, öğleden sonra',
  },
  holidays: {
    add: 'Tatil ekle',
    editTitle: 'Tatili düzenle',
    intro: 'Tüm takvimler tamamen düzenlenebilir: standart tatilleri yeniden adlandırın, taşıyın, yarım güne çevirin veya kaldırın (ve geri yükleyin); kendi günlerinizi bir kez veya her yıl, tek bir takvim ya da tümü için ekleyin. Hareketli tatiller (örn. bayramlar) yıl bazında uyarlanır.',
    source: 'Kaynak',
    sources: {
      standard: 'Standart',
      changed: 'Değiştirildi',
      custom: 'Özel gün',
    },
    yearly: 'her yıl',
    yearlyLabel: 'Her yıl bu tarihte',
    yearlyHint: 'Seçilen yıldan itibaren her yıl aynı tarihte geçerlidir (örn. 24.12. yarım gün). Hareketli tatiller için uygun değildir.',
    remove: 'Kaldır (iş günü)',
    removedTitle: 'Kaldırılan standart tatiller',
    restore: 'Geri yükle',
    saved: 'Tatil kaydedildi.',
    removed: '"{{name}}" kaldırıldı: bu gün artık iş günü.',
    deleted: '"{{name}}" silindi.',
    restored: '"{{name}}" geri yüklendi.',
    wasName: 'Standart: {{name}}',
    moveHint: 'Taşındı: {{date}} artık tatil olmayacak.',
    calendarHintStandard: 'Bu takvimin standart tatili: değişiklikler bu takvim için geçerlidir.',
    person: {
      title: 'Kişiye özel tatiller {{year}}',
      intro: 'Resmi tatilde çalışıp bunun yerine başka bir gün veya yarım gün tatil yapan kişiler için (örn. 29.10’da çalışıldı, 27.10 ve 28.10 sabahı tatil). Yalnızca o kişi için geçerlidir: hedef saatler, izin günleri, ekip takvimi ve kişinin Outlook takvimi buna uyar; kişiye bildirim gider. Fazla mesai üzerinden dolambaçlı yola gerek yoktur.',
      add: 'Kişiye özel tatil ekle',
      none: 'Bu yıl kişiye özel tatil yok.',
      kind: 'Tür',
      kinds: {
        day: 'tam gün tatil',
        am: 'öğleden önce tatil',
        pm: 'öğleden sonra tatil',
        work: 'çalışıyor (tatil değil)',
      },
      kindHints: {
        day: 'Bu gün bu kişi için tatildir.',
        am: 'Öğleden önce tatil, öğleden sonra çalışma süresi.',
        pm: 'Öğleden sonra tatil, öğleden önce çalışma süresi.',
        work: 'Takvimdeki tatil bu kişi için geçerli değildir: normal çalışır.',
      },
      nameHint: 'örn. “Cumhuriyet Bayramı (kaydırıldı)” veya “tatil yerine çalışma günü”',
      calendarDay: 'Takvimdeki tatil',
      saved: 'Kaydedildi; kişiye bildirim gider.',
    },
  },
  stepUp: {
    title: 'Ek doğrulama',
    text: '"{{module}}" ek olarak korunuyor. Lütfen yeniden doğrulayın; doğrulama {{minutes}} dakika geçerlidir.',
    password: 'Şifre',
    totp: 'Doğrulama uygulamasındaki kod',
    demoHint: 'Demo: doğrulama kelimesi "demo".',
    confirm: 'Doğrula ve aç',
    unavailable: 'Hesabınız için doğrulama mümkün değil (yalnızca Microsoft ile giriş, şifre ve doğrulama uygulaması yok). Profilden doğrulama uygulamasını kurun.',
    settingsTitle: 'Ek doğrulama',
    forBilling: 'Faturalandırmayı yalnızca yeniden doğrulamadan sonra aç',
    forCustomers: 'Müşterileri yalnızca yeniden doğrulamadan sonra aç',
    minutes: 'Doğrulama süresi',
    minutesValue: '{{count}} dakika',
    minutesValue_one: '{{count}} dakika',
    settingsHint: 'Bunu yalnızca ilgili modülün yetkisine sahip kişiler değiştirebilir, teknik yönetim değiştiremez. Her doğrulama ve her hatalı deneme kayıt altına alınır; hatalı denemeler girişteki gibi hesabı kilitler.',
    limits: 'Sınırlar: doğrulama, açık bir oturumun başkası tarafından kullanılmasına ve uygulama üzerinden erişime karşı korur. Sunucuya, veritabanına veya yedeklere doğrudan erişimi olan kişi verileri orada okuyabilir; buna karşı yalnızca işletme önlemleri yardımcı olur (ayrı erişimler, şifreli yedekler, kayıt tutma).',
    textFinance: 'Tutarlar (ücretler, maliyetler, satışlar, tam dışa aktarmalar) ek olarak korunuyor. Lütfen yeniden doğrulayın; doğrulama {{minutes}} dakika geçerlidir.',
    lockedHelp: '5 hatalı denemeden sonra hesap 15 dakika kilitlenir, ardından kendiliğinden açılır. Kullanıcı yönetimi kilidi hemen kaldırabilir (Kişiler > Erişim > “Kilidi kaldır”). Şifre değişmez.',
    attempts: 'Hatalı denemeler girişteki gibi sayılır: 5 hatalı denemeden sonra 15 dakika kilit, ardından kendiliğinden açılır; kullanıcı yönetimi kilidi hemen kaldırabilir.',
    limitsTitle: 'Doğrulama neyi korur',
    moneyLocked: 'Tutarlar, ek doğrulama yapana kadar gizlidir.',
    showMoney: 'Tutarları göster',
    stateLocked: 'Kilitli',
    stateOpen: '{{time}} saatine kadar açık',
    stateHint: 'Süre bitince alan kendiliğinden kilitlenir; “Şimdi kilitle” ile hemen kilitlenir.',
    lockNow: 'Şimdi kilitle',
    lockedNow: 'Kilitlendi. Bir sonraki açılışta yeniden doğrulama istenir.',
    mandatory: 'Ek doğrulama her zaman açıktır (faturalandırma, müşteriler ve tüm tutarlar). Modül yetkisi olmayan kişi modülü görmez – ofis ve yönetim yetki vermedikçe teknik yönetim (admin) de dahil.',
  },
  jobs: {
    intro: 'Her gece bakım çalışır (Forma eşitleme, tekrarlanan kayıtlar, yedek, hedef süreler, temizlik); her adım sonucuyla kaydedilir. Sondaki günlük kontrol arka planda oluşan sorunları arar. Raporlar sayılar ve proje numaraları içerir, kişisel veri içermez.',
    kind: 'Tür',
    kinds: {
      all: 'Tüm raporlar',
      nightly: 'Gece bakımı',
      check: 'Kontrol (elle)',
    },
    status: {
      ok: 'sorunsuz',
      warning: 'uyarılar',
      error: 'hatalar',
      running: 'çalışıyor',
      skipped: 'atlandı',
    },
    started: 'Başlangıç',
    steps: 'Adımlar',
    step: 'Adım',
    duration: 'Süre',
    findings: 'Bulgular',
    result: 'Sonuç',
    failedCount: '{{count}} başarısız',
    noFindings: 'yok',
    noFindingsLong: 'Sorun bulunmadı.',
    checkNow: 'Şimdi kontrol et',
    checked: 'Kontrol tamamlandı: {{count}} bulgu.',
    checked_one: 'Kontrol tamamlandı: {{count}} bulgu.',
    exportList: 'Listeyi Excel olarak',
    exportOne: 'Raporu Excel olarak',
    latestProblem: 'Son rapor ({{date}}): {{errors}} hata, {{warnings}} uyarı.',
    open: 'Aç',
    none: 'Henüz rapor yok. İlki bir sonraki gece veya "Şimdi kontrol et" ile oluşur.',
    report: 'Rapor',
    reportTitle: '{{date}} tarihli {{kind}}',
    summary: '{{steps}} adım, {{errors}} hata, {{warnings}} uyarı',
    lookAt: 'Göster',
    codes: {
      step_failed: {
        short: 'Adım başarısız',
        text: '{{step}}: {{error}}',
      },
      forma_errors: {
        short: 'Forma hataları',
        text: '{{count}} projede hatalı eşitleme: {{projects}}.',
      },
      forma_warnings: {
        short: 'Forma uyarıları',
        text: '{{count}} projede uyarılı eşitleme: {{projects}}.',
      },
      forma_lost_projects: {
        short: 'Forma bağlantısı koptu',
        text: 'Forma erişimi olmayan veya Forma\'da silinmiş {{count}} aktif proje: {{projects}}.',
      },
      hours_on_lost_tasks: {
        short: 'Silinen Forma görevlerinde saatler',
        text: 'Forma\'da silinmiş veya erişilemeyen {{count}} görevde faturalanmamış {{entries}} kayıt.',
      },
      outlook_errors: {
        short: 'Outlook randevuları başarısız',
        text: '{{count}} randevu yazılamadı (posta kutusu yetkisini kontrol edin).',
      },
      backup_missing: {
        short: 'Yedek yok',
        text: 'Son 36 saatte yedek alınmadı (son: {{last}}).',
      },
      months_open: {
        short: 'Açık aylar',
        text: 'Geçmiş {{count}} ay kapatılmamış ({{months}}).',
      },
      approvals_waiting: {
        short: 'Bekleyen onaylar',
        text: '{{count}} kayıt {{days}} günden uzun süredir onay bekliyor.',
      },
      long_days: {
        short: 'Olağandışı uzun günler',
        text: 'Bir kişinin 16 saatten fazla kayıt girdiği {{count}} gün (son 60 gün).',
      },
      forma_idle: {
        short: 'Forma eşitlemesi durdu',
        text: 'Bir günden uzun süredir eşitleme yok (son: {{last}}).',
      },
    },
    stepNames: {
      'forma-auto-import': 'Yeni Forma projelerini al',
      'forma-full-sync': 'Forma tam eşitleme',
      'recurring-entries': 'Tekrarlanan kayıtlar',
      snapshot: 'Yedek',
      'snapshot-retention': 'Eski yedekleri kaldır',
      'capacity-cache': 'Hedef süreleri hesapla',
      'documents-retention': 'Süresi dolan belgeleri sil',
      'powerbi-export': 'Power BI dışa aktarımı',
      'sessions-cleanup': 'Süresi dolan oturumları kaldır',
      'daily-check': 'Günlük kontrol',
    },
  },
  leave: {
    bookedWarning: 'Bu dönemde zaten {{hours}} sa kayıt var. Dönem doğru mu? Onaydan sonra kayıtlar ayrıca sayılır.',
    cut: {
      text: 'Bu günlerde yıllık izin girilmiş. Raporlu hastalık günleri yıllık izinden sayılmaz (Almanya § 9 BUrlG; Türkiye: İş Kanunu m. 56, Yıllık Ücretli İzin Yönetmeliği m. 6): izin bu günler kadar kısaltılır, {{days}} izin günü iade edilir; izin uzamaz.',
      confirm: 'İzni kısalt ve {{days}} izin gününü iade et',
      self: 'Bu günlerde yıllık izin girilmiş. Lütfen hastalığınızı raporla birlikte personel birimine bildirin: hastalığı personel birimi girer ve izin günlerini iade eder.',
    },
    bookedInPeriod: 'Dönemde zaten {{hours}} sa kayıt var',
    compInfo: 'Fazla mesai izni yıllık izin gibi onaylanır. Gün hedef saatin parçası kalır ve saat yazılmaz; böylece fazla mesai azalır.',
    overtimeAfter: 'Sonra kalan fazla mesai: {{hours}} sa',
    overtimeShort: 'Fazla mesai',
    overtime: {
      title: 'Fazla mesai ve fazla mesai izni',
      earned: 'Kayıtlara göre bakiye',
      adjusted: 'Ödenen / düzeltilen',
      planned: 'Planlanan fazla mesai izni',
      requested: 'Talep edilen fazla mesai izni',
      available: 'Kullanılabilir',
      hint: '{{since}} tarihinden düne kadar: kaydedilen saatler eksi hedef saat. Hafta sonu, resmî tatil ve devamsızlık günlerinde çalışma ile hedefin üzerindeki saatler bakiyeyi artırır; fazla mesai izni ve ödemeler azaltır. Ödemeleri ve düzeltmeleri personel birimi girer. Proje kayıtlarından çıkan bir yön göstergesidir, çalışma süresi hesabı değildir.',
    },
    carryoverHint: 'Kullanılmayan kalan izin otomatik silinmez. Süre dolunca personel birimi kalanı düzeltir; iznin yanıp yanmayacağı, başka koşulların yanı sıra çalışanın zamanında uyarılıp uyarılmadığına bağlıdır.',
    title: 'Devamsızlıklarım',
    subtitle: 'Yıllık izin ve diğer izinleri talep edin, hastalığı belgesiyle bildirin, hak ve talepleri takip edin.',
    request: 'Devamsızlık talep et',
    sickNote: 'Hastalık bildir',
    requestTitle: 'Devamsızlık talep et',
    sickTitle: 'Hastalık bildir',
    hrTitle: 'Devamsızlık gir',
    person: 'Kişi',
    kind: 'Tür',
    extent: 'Kapsam',
    modes: {
      full: 'Tam günler',
      half: 'Yarım gün',
      hours: 'Saat',
    },
    parts: {
      am: 'Öğleden önce',
      pm: 'Öğleden sonra',
    },
    hours: 'Saat',
    startTime: 'Başlangıç',
    note: 'Not',
    noteHint: 'İsteğe bağlı, ör. sebep. Teşhis yazmayın.',
    preview: 'İş günü: {{days}} ({{hours}} sa)',
    previewHours: '{{hours}} sa',
    previewDays: 'İş günü: {{days}}',
    balanceAfter: 'Sonrasında kalan: {{value}} {{unit}}',
    balanceAfterYear: 'Sonrasında kalan ({{year}}): {{value}} {{unit}}',
    overlap: 'Bu günlerde zaten bir devamsızlık var.',
    needsApproval: 'Talep onaylanır veya reddedilir; o zamana kadar hedef saati düşürmez.',
    submit: 'Talep et',
    save: 'Kaydet',
    requested: 'Talep gönderildi',
    recorded: 'Kaydedildi',
    withdraw: 'Geri çek',
    cancel: 'İptal et',
    withdrawn: 'Geri çekildi',
    status: {
      requested: 'Talep edildi',
      approved: 'Onaylandı',
      rejected: 'Değişiklik istendi',
      cancelled: 'İptal edildi',
    },
    balance: {
      entitlement: 'Hak {{year}}',
      carryover: 'Geçen yıldan kalan',
      carryoverUntil: '{{date}} tarihine kadar kullanılmalı',
      taken: 'Kullanılan',
      planned: 'Planlanan',
      requested: 'Talep edilen',
      available: 'Kalan',
      none: 'Bu yıl için henüz izin hakkı girilmedi (personel birimi).',
    },
    units: {
      days: 'gün',
      hours: 'sa',
    },
    empty: 'Bu yıl devamsızlık yok.',
    outlookNote: 'Onaylanan devamsızlıklar Outlook takviminizde otomatik olarak "Ofis dışında" durumuyla görünür.',
    decidedBy: 'karar veren: {{name}}',
    period: 'Dönem',
    state: 'Durum',
    approve: 'Onayla',
    reject: 'Değişiklik talebi',
    rejectTitle: 'Değişiklik talebi gönder',
    rejectReason: 'Ne değiştirilmeli? (kişi notu görür)',
    approvedMany: '{{count}} onaylandı',
    rejectedMany: '{{count}} değişiklik talebi gönderildi',
    undone: '{{count}} karar geri alındı',
    undone_one: '{{count}} karar geri alındı',
    queueEmpty: 'Açık talep yok.',
    own: 'Kendi talebiniz: personel yetkisi olan başka biri karar verir',
    restAfter: 'Sonra kalan',
    alsoAbsent: 'Aynı uzmanlıktan yok: {{names}}',
    requestedAt: 'Gönderildi',
    entitlement: 'Hak',
    editEntitlement: 'Hakkı düzenle',
    unit: 'Birim',
    amount: 'Yıllık hak',
    carryover: 'Geçen yıldan kalan',
    carryoverUntil: 'Kalan izin son kullanım',
    sickDays: 'Hasta (iş günü)',
    allTab: 'Tüm devamsızlıklar',
    overviewTab: 'Haklar ve bakiyeler',
    eventsTab: 'Firma etkinlikleri',
    holidaysTab: 'Resmi tatiller',
    cancelTitle: 'Devamsızlığı iptal et',
    cancelReason: 'Gerekçe',
    statusFilter: 'Durum',
    allStatuses: 'Tümü',
    hrInfo: 'Personel biriminin girdiği devamsızlıklar hemen onaylı sayılır.',
    importHint: 'Sütunlar: email;kind;from;to;halfDay;externalRef olan CSV. Türler: vacation, special, training, overtime, unpaid, sick, child_sick, parental, other. Aynı externalRef kaydı günceller.',
    events: {
      new: 'Etkinlik ekle',
      name: 'Başlık',
      country: 'Konum',
      allCountries: 'Tüm konumlar',
      hint: 'Ekip takviminde, başlangıç sayfasında ve katılımcı varsa onların Outlook takviminde görünür. Herkes için tatil olan günler (örn. şirket tatili) "Resmi tatiller" altında tam veya yarım gün olarak girilir, böylece hedef süreyi düşürür; firma etkinliği (örn. şantiye gezisi) çalışma süresidir ve hedefi düşürmez.',
      edit: 'Etkinliği düzenle',
      part: 'Süre',
      partHint: 'Yarım gün ve saat yalnızca tek bir gün için.',
      parts: {
        full: 'tüm gün',
        time: 'saat aralığı',
      },
      start: 'Başlangıç',
      end: 'Bitiş',
      notePlaceholder: 'örn. buluşma noktası, koruyucu donanım, irtibat kişisi',
      participants: 'Katılımcılar',
      participantsCount: '{{count}} katılımcı',
      participantsCount_one: '{{count}} katılımcı',
      everybody: 'herkes için',
      searchPerson: 'Kişi ara',
      participantsHint: 'Seçim yoksa etkinlik (lokasyondaki) herkes içindir. Seçim varsa katılımcılar etkinliği ekip takvimindeki kendi satırlarında, başlangıç sayfasında ve Outlook bağlantısı açıksa Outlook takvimlerinde "meşgul" randevu olarak görür (davet gönderilmez).',
      deleted: '"{{title}}" etkinliği silindi.',
    },
    profileBirthday: 'Doğum günü (gün ve ay)',
    profileShowBirthday: 'Ekip takviminde göster',
    profileBirthdayHint: 'İsteğe bağlı. Yıl kaydedilmez.',
    decidedByHr: 'Karar veren: personel birimi.',
    decidedByName: 'Karar veren: {{name}}.',
    sickInfo: 'Hastalık bildirimi hemen geçerli olur: hedef saat, ekip takvimi (yalnızca "yok") ve Outlook. Personel birimi onaylar.',
    restAfterHint: 'Yıllık izinde kalan hak, fazla mesai izninde fazla mesai; her biri bu ve kişinin diğer tüm açık talepleri sonrası.',
    sickRecorded: 'Hastalık bildirimi kaydedildi; personel birimi onaylayacak.',
    resubmit: 'Düzenle ve yeniden gönder',
    changeNote: 'Değişiklik notu',
    changeHint: 'Günler yeniden serbest. Lütfen talebi düzenleyip tekrar gönderin.',
    resubmitted: 'Yeniden gönderildi',
    noOvertimeAccount: 'Sizin için fazla mesai hesabı tutulmuyor; bu nedenle izinle telafi öngörülmüyor.',
  },
  team: {
    leadHint: 'Renkli olanlar: kişinin yönettiği projeler.',
    legendEvent: 'Firma etkinliği (katılım)',
    title: 'Ekip',
    subtitle: 'Kim ne zaman burada: devamsızlıklar, konumun resmi tatilleri, firma etkinlikleri ve herkesin projeleri. Burada kimse saat ve görev görmez.',
    today: 'Bugün',
    until: '{{date}} tarihine kadar {{label}}',
    present: 'Burada',
    projects: 'Projeler',
    noProjects: 'Proje yok',
    lead: 'Lider',
    birthday: 'Doğum günü',
    events: 'Firma etkinlikleri',
    country: 'Konum',
    all: 'Tümü',
    discipline: 'Uzmanlık',
    search: 'İsim ara',
    legendAbsent: 'Ofis dışında',
    legendHoliday: 'Resmi tatil',
    legendFree: 'İş günü değil',
    people: 'Kişiler',
    calendar: 'Takvim',
    mail: 'E-posta yaz',
    privacy: 'Hastalık ve diğer kişisel sebepler sadece "Ofis dışında" olarak görünür.',
  },
  overtime: {
    tab: 'Fazla mesai',
    intro: 'Bordro için aylık fazla mesai: hedefin üzerindeki saatlerin nerede oluştuğu, ne kadarının fazla mesai izni olarak kullanıldığı ve ne kadarının ödendiği. Ödeme (bir ayın maaşıyla) veya düzeltme bakiyeyi hemen düşürür ya da artırır, kayda geçer ve kişi tarafından "Devamsızlıklarım" sayfasında görülür. Temel proje kayıtlarıdır; bordro için ayı ancak ay kapatıldıktan sonra kullanın.',
    month: 'Ay',
    closed: 'Ay kapatıldı',
    open: 'Ay henüz açık: değerler değişebilir',
    excel: 'Bordro için Excel',
    empty: 'Bu ay çalışma süresi sözleşmesi olan çalışan yok.',
    adjust: 'Ödeme veya düzeltme',
    adjustTitle: 'Fazla mesai: {{name}}',
    kind: 'Tür',
    kinds: {
      payout: 'Ödeme',
      correction: 'Düzeltme',
    },
    hours: 'Saat',
    sign: 'İşaret',
    payoutHint: 'Saatlerin ödendiği bordro ayı.',
    correctionHint: 'Örneğin Projektzeit öncesinden kalan bakiye veya bir anlaşma. Gerekçe zorunludur.',
    balanceNow: 'Bugünkü bakiye',
    balanceParts: 'kayıtlar {{earned}} sa, ödenen/düzeltilen {{adjusted}} sa, planlı fazla mesai izni {{planned}} sa',
    history: 'Ödemeler ve düzeltmeler',
    none: 'Henüz ödeme veya düzeltme yok.',
    payrollMonth: 'Bordro {{month}}',
    removeTitle: 'Ödemeyi veya düzeltmeyi sil',
    openEntries: '{{count}} kayıt onaylanmadı',
    openEntries_one: '{{count}} kayıt onaylanmadı',
    reset: {
      button: 'Bakiyeyi sıfırla',
      title: 'Bakiyeyi sıfırla: {{name}}',
      question: 'Emin misiniz? {{name}} kişisinin fazla mesai bakiyesi (bugün {{hours}} sa) 0\'a çekilir: fazla mesai, hedef/gerçekleşen ve eksik kayıt uyarıları {{date}} tarihinden itibaren sayılır.',
      confirm: 'Evet, bakiyeyi sıfırla',
      date: 'Başlangıç',
      dateHint: 'Genellikle bugün veya kişinin eksiksiz kayıt girmeye başladığı gün. Gelecek bir tarih olamaz.',
      notePlaceholder: 'örn. alışma dönemi, Projektzeit\'a başlangıç …',
      keeps: 'Girilen saatler ve kayıtlar değişmez. Bu tarihten önceki ödemeler ve düzeltmeler artık sayılmaz. Kişi, silinen saatleri belirten bir bildirim alır; değişiklik kayıt altına alınır ve geri alınabilir.',
      done: '{{name}} bakiyesi sıfırlandı ({{hours}} sa silindi).',
      undoNote: 'Sıfırlama geri alındı',
      since: 'Kayıt başlangıcı {{date}}',
      countsFrom: 'Fazla mesai {{date}} tarihinden itibaren sayılır.',
    },
    cols: {
      target: 'Hedef',
      booked: 'Girilen',
      difference: 'Fark',
      daysOff: 'İzin günleri',
      daysOffHint: 'Hafta sonu ve sözleşmedeki diğer çalışılmayan günler',
      holiday: 'Resmî tatiller',
      absenceDay: 'Devamsızlık günleri',
      workdayExtra: 'Hedef üstü',
      compensation: 'Fazla mesai izni',
      paidOut: 'Ödenen',
      balance: 'Bugünkü bakiye',
      balanceHint: 'Kayıt başlangıcından bu yana tüm aylar, ödemeler ve planlı fazla mesai izni sonrası',
      rate: 'Fazla mesai ücreti',
      paidOutValue: 'Ödenen tutar',
    },
  },
  errors: {
    ABSENCE_OVERLAP: 'Bu günler için zaten talep edilmiş veya onaylanmış bir devamsızlık var.',
    SICK_DURING_LEAVE: 'Bu günlerde yıllık izin girilmiş. İzindeyken hastalığı personel birimi raporla girer; izin günleri iade edilir.',
    STEP_UP_REQUIRED: 'Bu alanı açmak için lütfen yeniden doğrulayın.',
    STEP_UP_UNAVAILABLE: 'Hesabınız için doğrulama mümkün değil; doğrulama uygulamasını kurun.',
    ABSENCE_PAST_MIDNIGHT: 'Birkaç saatlik devamsızlık aynı gün biter (en geç 24:00). Lütfen başlangıcı veya süreyi düzeltin.',
    ATTACHMENT_TYPE: 'Bu dosya türü kabul edilmiyor. PDF, JPG, PNG, WEBP ve HEIC yüklenebilir; içerik dosya türüyle uyuşmalı.',
    ATTACHMENT_SIZE: 'Dosya boş ya da 10 MB’tan büyük.',
    ATTACHMENT_COUNT: 'Bu devamsızlıkta zaten 5 belge var. Lütfen önce birini kaldırın.',
    reasons: {
      NOT_EDIT_FILE: 'Dosya bir Projektzeit düzenleme dosyası değil.',
      OTHER_DOCUMENT: 'Dosya başka bir belgeye ait.',
      FILE_LIMIT: 'Dosya bir düzenleme dosyası için çok büyük (açılmış hâli 24 MB’ın veya 20.000 satırın üzerinde).',
      PREVIEW_CHANGED: 'Önizlemeden sonra sistem verileri değişti.',
      NUMBER_TAKEN: 'Bu numara projede başka bir manuel görevde zaten var.',
      TASK_IN_USE: 'Görevin kapatılmış bir ayda veya faturada saatleri var; yalnızca gizlenebilir.',
      TASK_APPROVED_HOURS: 'Görevde onaylanmış saatler var; yalnızca kayıt düzeltme yetkisi olan kişi silebilir.',
      TASK_HAS_HOURS: 'Görevde girilmiş saatler var; görev silinmez, gizlenir.',
      TASK_DELETED: 'Görev silindi; kayıtları geri getirilemez.',
    },
    IMPORT_UNKNOWN_EMAIL: 'bilinmeyen e-posta {{email}}',
    IMPORT_INVALID_DATES: 'geçersiz tarih (biçim YYYY-AA-GG, başlangıç bitişten sonra olamaz)',
    IMPORT_ABSENCE_OVERLAP: 'talep edilmiş veya onaylanmış bir devamsızlıkla çakışıyor',
    IMPORT_PERIOD_LOCKED: 'kapatılmış bir aya düşüyor',
    IMPORT_SELF_APPROVAL: 'kendi devamsızlığınız: lütfen talep olarak girin, başka biri karar verir',
    NO_WORKDAY: 'Seçilen dönemde iş günü yok (hafta sonu, resmi tatil veya çalışılmayan gün).',
    PROTECTED_ACCOUNT: 'Korunan yetkileri (onaylar, faturalama, ücretler, personel, ekip göstergeleri, iş yükü, tam dışa aktarma) sadece bu yetkilere sahip kişi verir ve değiştirir. Bu, bu hesapların rolü, erişimi, e-postası ve etkinliği için de geçerlidir.',
    SELF_BILLING: 'Kendi kayıtlarınızın faturalanacak saatlerini, faturalama yetkisi olan başka bir kişi değiştirir.',
    UNDO_NOT_POSSIBLE: 'Geri alma artık mümkün değil: kayıt bu arada işlendi.',
    UNAUTHENTICATED: 'Lütfen yeniden giriş yapın.',
    MFA_REQUIRED: 'İkinci faktör gerekli.',
    FORBIDDEN: 'Bunun için yetkiniz yok.',
    NOT_FOUND: 'Bulunamadı.',
    VALIDATION: 'Girdileri kontrol edin.',
    CONFLICT: 'Bu arada başka biri değiştirdi. Lütfen yeniden yükleyin.',
    PERIOD_LOCKED: 'Ay kapatılmış.',
    ENTRY_BILLED: 'Zaten faturalandı. Değişiklik ancak saat dökümü iptal edilince mümkün.',
    ENTRY_APPROVED: 'Zaten onaylandı. Değişikliği yalnızca proje lideri veya ofis yapabilir.',
    ENTRY_DELETED: 'Kayıt silinmiş.',
    SELF_APPROVAL: 'Kendi saatleriniz ve kendi talepleriniz hakkında başka biri karar verir.',
    WRONG_STATUS: 'Bu durumda mümkün değil.',
    REASON_REQUIRED: 'Lütfen bir gerekçe girin.',
    NOT_BOOKABLE: 'Bu göreve kayıt girilemez.',
    DESCRIPTION_REQUIRED: 'Lütfen yapılan işi açıklayın.',
    FUTURE_DATE: 'Bu kadar ileri bir tarihe kayıt girilemez.',
    STEP_MINUTES: 'Lütfen saatleri ayarlanan adımda girin.',
    LAST_ADMIN: 'Son yönetici kaldırılamaz.',
    FORMA_ERROR: 'Forma hata bildirdi.',
    FORMA_NOT_CONNECTED: 'Forma bağlı değil.',
    INTERNAL: 'Beklenmeyen hata. Lütfen tekrar deneyin.',
    NETWORK: 'Sunucuya bağlantı yok.',
    CSRF: 'İstek reddedildi.',
    INVALID_CREDENTIALS: 'E-posta veya parola hatalı.',
    INVALID_TOTP: 'Kod geçersiz.',
    TOTP_SETUP_EXPIRED: 'Kurulumun süresi doldu. Lütfen yeniden başlatıp yeni kodu girin.',
    ACCOUNT_LOCKED: 'Çok fazla deneme. Hesap 15 dakika kilitlendi.',
    SETUP_INVALID: 'Kurulum bağlantısı geçersiz veya süresi dolmuş.',
    PASSWORD_TOO_SHORT: 'Parola çok kısa.',
    PASSWORD_TOO_WEAK: 'Parola çok basit.',
    PASSWORD_TOO_LONG: 'Parola çok uzun.',
    bookability: {
      PROJECT_ARCHIVED: 'Proje arşivlenmiş.',
      TASK_ARCHIVED: 'Görev gizlenmiş.',
      NOT_MEMBER: 'Bu projeye atanmamışsınız.',
      TASK_NOT_ASSIGNED: 'Bu görev size atanmamış.',
      PERSON_INACTIVE: 'Kişi devre dışı.',
      PROJECT_NO_FORMA: 'Projenin etkin bir Forma bağlantısı yok ve kayıt girişine açılmamış.',
      TASK_DRAFT: 'Görev Forma’da hâlâ taslak. Taslaklara saat girilmez; Forma’da yayımlandığında saat girilebilir.',
    },
    shortCodeTaken: 'Bu kısaltma zaten kullanımda. Lütfen başka bir tane seçin veya “Addan öner”i kullanın.',
    shortCodeInvalid: 'Kısaltma 2-6 harf veya rakamdan oluşur.',
    NO_OVERTIME_ACCOUNT: 'Bu kişinin fazla mesai hesabı yok (fazla çalışma maaşla karşılanıyor). Bu nedenle fazla mesai karşılığı izin alınamaz.',
    BUSY: 'Şu anda büyük bir dışa aktarma, yedekleme veya karşılaştırma zaten çalışıyor. Lütfen bir iki dakika sonra yeniden deneyin.',
  },
  picker: {
    source: 'Kaynak',
    sources: {
      all: 'Tümü',
      forma: 'Forma',
      manual: 'Manuel',
    },
    allProjects: 'Tüm projeler',
    counts: '{{forma}} Forma, {{manual}} manuel',
    location: 'Konum',
    allLocations: 'Tüm konumlar',
    subLocation: 'Alt konum',
    allSubLocations: 'Tüm alt konumlar',
    noSubLocations: 'Alt konum yok',
    allCategories: 'Tüm kategoriler',
    plan: 'Plan {{hours}} sa',
    more: 'Daha fazla sonuç var: filtreyi veya aramayı daraltın.',
  },
  cockpit: {
    title: 'Kokpit',
    subtitleAll: 'Tüm projeler tek bakışta. Ayrıntılar proje sayfasında; plan saatleri ve personel Planlama sayfasında.',
    subtitleLead: 'Yönettiğim projeler. Ayrıntılar proje sayfasında; plan saatleri ve personel Planlama sayfasında.',
    noAccess: 'Kokpiti proje liderleri, ofis ve yönetim görür.',
    tabs: {
      overview: 'Genel bakış',
      projects: 'Projeler',
    },
    ranges: {
      thisMonth: 'Bu ay',
      lastMonth: 'Geçen ay',
      year: 'Bu yıl',
      last4w: 'Son 4 hafta',
      last3m: 'Son 3 ay',
      last12m: 'Son 12 ay',
      thisWeek: 'Bu hafta',
    },
    booked: 'Girilen',
    activeProjects: 'Kaydı olan projeler',
    persons: 'Kaydı olan kişiler',
    approvalsPending: 'Bekleyen onaylar',
    budgetAlerts: 'Bütçe %80 ve üzeri',
    overPlan: 'Planı aşan görevler',
    unbilled: 'Henüz faturalanmadı (sa)',
    hoursByProject: 'Projelere göre saatler',
    budgetUsedShort: 'Bütçenin {{value}} kullanıldı',
    otherProjects: '{{count}} diğer proje',
    otherProjects_one: '{{count}} diğer proje',
    alerts: 'Uyarılar',
    noAlerts: 'Bütçesi %80 ve üzeri olan veya planı aşan görevi olan proje yok.',
    budgetNote: '{{budget}} sa bütçeden {{booked}} sa',
    overPlanNote: '{{count}} görev planı aştı',
    overPlanNote_one: '{{count}} görev planı aştı',
    weekly: 'Tüm projelerin haftalık seyri',
    sort: 'Sırala',
    sorts: {
      period: 'Dönemdeki saat',
      total: 'Toplam saat',
      budget: 'Bütçe kullanımı',
      overPlan: 'Planı aşan görevler',
      number: 'Proje numarası',
    },
    colPeriod: 'Dönem (sa)',
    colTotal: 'Toplam (sa)',
    colPlanTasks: 'Planlı görevler',
    colDone: 'Tamamlanan: plan / gerçekleşen',
    colDoneHint: 'Planı olan tamamlanmış görevler: plan toplamı / girilen toplamı',
    colInvoiced: 'Faturalanan / girilen',
    overPlanShort: '{{count}} plan üstü',
    projectsHint: 'Bütçe ve plan değerleri projenin tüm süresine, saatler seçilen döneme aittir. Faturalanan / girilen: aynı kayıtlarda faturalanan saatlerin girilen saatlere oranı.',
    teamEfficiencyHint: 'Değerlendirilen tüm görevlerde plan payı / girilen saat',
    weekFlags: 'Hedefin altında / üstünde haftalar',
    weekFlagsHint: 'Haftada {{hours}} sa üzeri sapma',
    weekFlagsCol: 'Hafta uyarıları',
    noFlags: 'normal ({{count}} hafta)',
    noFlags_one: 'normal ({{count}} hafta)',
    tasksCount: '{{count}} görev',
    tasksCount_one: '{{count}} görev',
    personTitle: 'Göstergeler: {{name}}',
    saved: 'Plana göre',
    savedHint: 'Plan payı eksi girilen saat (pozitif = daha hızlı)',
    toAnalysis: 'Proje analizi',
    searchProject: 'Proje ara (numara veya ad)',
  },
  projectKpi: {
    tasksWithPlan: 'Planı olan görevler',
    planHours: 'Plan {{plan}} sa, girilen {{booked}} sa',
    done: 'Tamamlanan görevler: plan / gerçekleşen',
    doneHint: '{{count}} görev: plan {{plan}} sa, girilen {{booked}} sa',
    doneHint_one: '{{count}} görev: plan {{plan}} sa, girilen {{booked}} sa',
    overPlan: 'Planı aşan açık görevler',
    invoicedFactor: 'Faturalanan / girilen',
    invoicedHint: '{{recorded}} sa girilen için {{invoiced}} sa faturalandı',
    noInvoiced: 'Henüz faturalanan yok.',
    overPlanList: 'Planı aşan açık görevler',
    noOverPlan: 'Planı aşan açık görev yok.',
    plan: 'Plan (sa)',
    onlyOverPlan: 'Yalnızca planı aşanlar',
    notEvaluated: 'değerlendirilmez',
    planHoursLabel: 'Plan (saat)',
  },
  categories: {
    hint: 'Manuel görevler (M numaraları) için kategoriler. "İç" grubu genel giderdir ve asla faturalanmaz. Artık gerekmeyen kategorileri silmek yerine pasifleştirin; mevcut görevler kategorilerini korur.',
    new: 'Kategori oluştur',
    edit: 'Kategoriyi düzenle',
    createInternal: 'İç görevleri oluştur',
    internalCreated: '{{project}} projesinde {{count}} görev oluşturuldu',
    internalCreated_one: '{{project}} projesinde {{count}} görev oluşturuldu',
    internalNone: 'Tüm iç kategoriler için zaten bir görev var.',
    translations: 'İngilizce · Türkçe',
    tasks: 'Görevler',
    fixed: 'sabit',
    nameDe: 'Ad (Almanca)',
    nameEn: 'Ad (İngilizce)',
    nameTr: 'Ad (Türkçe)',
    group: 'Grup',
    groups: {
      projekt: 'Projeye bağlı',
      intern: 'İç (genel gider)',
    },
    sort: 'Sıra',
    fixedLabel: 'Faturalama türünü sabitle',
    fixedHint: 'Kayıtlar faturalama türünü değiştiremez.',
    activeLabel: 'Aktif',
    activeHint: 'Pasif kategoriler yeni görevlerde seçilemez.',
    noOvertime: 'fazla mesai sayılmaz',
    noOvertimeLabel: 'Fazla mesai sayılmaz',
    noOvertimeHint: 'Bu kategorideki görevlere girilen saatler fazla mesai hesabına sayılmaz (örn. gönüllü eğitim). Yalnızca ayar açıkken geçerlidir.',
    noOvertimeRetro: 'Değişiklik bu kategoride daha önce girilmiş saatler için de geçerlidir ve fazla mesai bakiyelerini değiştirir.',
  },
  analysis: {
    title: 'Proje analizi',
    subtitle: 'Tüm projelerin durumu: ilerleme, termin durumu ve plana göre saatler. Bina, kat, disiplin, zaman planı ve ekip için bir projeyi açın.',
    backToPortfolio: 'Tüm projelere dön',
    period: 'Dönem',
    periodHint: 'Dönem saatler ve maliyetler için geçerlidir. İlerleme ve termin durumu her zaman bugünkü durumu gösterir.',
    periods: {
      all: 'Projenin tamamı',
      year: 'Bu yıl',
      last12w: 'Son 12 hafta',
      last4w: 'Son 4 hafta',
      month: 'Bu ay',
      lastMonth: 'Geçen ay',
      week: 'Bu hafta',
      custom: 'Özel dönem',
    },
    includeInactive: 'Duraklatılmış ve tamamlanmış projeleri göster',
    excel: 'Excel',
    pdf: 'PDF rapor',
    noProjects: 'Erişiminizde proje yok.',
    search: 'Proje, numara veya müşteri ara',
    shownOf: '{{total}} projeden {{shown}} tanesi',
    more: 'Daha fazla göster',
    overdueAll: 'Tüm projelerin geciken görevleri',
    noOverdue: 'Geciken görev yok.',
    dueOn: 'bitiş {{date}}',
    daysLate: '{{count}} gün gecikmede',
    daysLate_one: '{{count}} gün gecikmede',
    definitions: 'İlerleme: tamamlanan (kapanan) görevler / tüm görevler veya plan saatlerine göre (proje ayarı). Termin durumu: tarihli açık görevlerin en az 3 tanesi veya beşte biri gecikmedeyse gecikme; bir geciken ya da yakında bitmesi gereken ama başlanmamış görevde risk. Plan/fiili oranı: tamamlanan görevlerin plan saatleri / bu görevlere yazılan saatler (%100 üzeri = plandan hızlı). Gizlenen görevler sayılmaz, saatleri sayılır.',
    portfolioReport: 'Proje portföyü',
    projectReport: 'Proje raporu',
    reportAsOf: '{{date}} itibarıyla',
    printNow: 'Yazdır / PDF olarak kaydet',
    demoPrint: 'Demoda yazdırma penceresi engellenmiş olabilir. Kurulu platformda "PDF rapor" doğrudan yazdırma penceresini açar; orada "PDF olarak kaydet" ve yatay sayfayı seçin.',
    kpi: {
      projects: 'Projeler',
      progress: 'İlerleme',
      doneOf: '{{tasks}} görevden {{done}} tamamlandı',
      byPlan: '{{plan}} plan saatinden {{done}} tamamlandı',
      overdue: 'Geciken',
      dueSoon: '{{count}} görev 7 gün içinde bitmeli',
      overdueSoon: '{{overdue}} geciken, {{soon}} 7 gün içinde bitmeli',
      withDue: 'tarihli {{count}} açık görevden',
      actual: 'Dönemdeki saat',
      lifetime: 'toplam {{hours}} sa',
      lifetimeShort: 'Toplam fiili (sa)',
      plan: 'Plan saatleri',
      plannedTasks: '{{tasks}} görevden {{count}} planlı',
      planUse: 'Plan kullanımı',
      planUseHint: 'Yazılan / planlanan (planlı görevler)',
      planRatio: 'Plan/fiili oranı',
      planRatioHint: 'Tamamlanan görevler: plan / fiili',
      onTime: 'Termine uyum',
      avgClose: 'ort. {{days}} günde tamamlandı',
      noneDone: 'henüz tamamlanan yok',
      tasks: 'Görevler',
      cost: 'Maliyet',
      costHint: 'Yazılan saat × maliyet ücreti',
      costMissing: '{{hours}} sa için maliyet ücreti eksik.',
      sales: 'Gelir değeri',
      salesHint: 'Faturalanabilir saat × satış ücreti',
      margin: 'Katkı payı',
      marginHint: 'Gelir değeri eksi maliyet',
      fee: 'Sözleşme ücreti',
      feeHint: 'Projenin götürü ücreti',
    },
    schedule: {
      label: 'Termin durumu',
      ok: 'planda',
      risk: 'risk',
      late: 'gecikme',
      none: 'tarih yok',
    },
    scheduleHint: {
      ok: 'Geciken görev yok, başlanmamış yakın tarihli görev yok.',
      risk: 'Bazı görevler gecikmede veya yakında bitmeli ama başlanmadı.',
      late: 'Birden fazla görev gecikmede (en az 3 veya tarihli açık görevlerin beşte biri).',
      none: 'Bitiş tarihli açık görev yok.',
    },
    buildings: 'Binalar ve katlar',
    buildingAria: 'Kat bazında ilerlemeyle binaların şematik görünümü',
    settings: 'Ayarlar',
    filters: 'Filtreler',
    removeFilter: 'Filtreyi kaldır',
    clearFilters: 'Tüm filtreleri sıfırla',
    tabs: {
      overview: 'Özet',
      building: 'Bina',
      matrix: 'Matris',
      schedule: 'Zaman planı',
      team: 'Ekip',
      tasks: 'Görevler',
      cost: 'Maliyetler',
    },
    dims: {
      building: 'Bina / blok',
      floor: 'Kat',
      zone: 'Bölge (zone)',
      trade: 'Disiplin',
      phase: 'Hizmet fazı',
      category: 'Kategori (Forma)',
      type: 'Tip (Forma)',
      stage: 'İşlem durumu',
      person: 'Kişi',
      formaField: 'Forma alanı',
    },
    none: 'belirtilmemiş',
    stages: {
      open: 'açık',
      progress: 'devam ediyor',
      review: 'kontrolde',
      done: 'tamamlandı',
    },
    legendProgress: 'İlerleme:',
    legendHours: 'Saat:',
    legendLess: 'az',
    legendMore: 'çok',
    export: {
      button: 'Dışa aktar …',
      title: 'Proje analizini dışa aktar',
      format: 'Biçim',
      parts: 'İçerik',
      formats: {
        pdf: 'PDF (raporu yazdır)',
        html: 'Etkileşimli HTML dosyası',
        xlsx: 'Excel (veri)',
      },
      formatHints: {
        pdf: 'Arşivlemek ve göndermek için; yazdırma penceresinde "PDF olarak kaydet".',
        html: 'Her tarayıcının açabildiği tek dosya, oturum açmadan: alan kişi bir kata, çubuğa veya hücreye fareyle gelince ayrıntıları görür.',
        xlsx: 'Hesaplama yapılacak tablolar; çizimler olmadan (bina, zaman planı ve maliyetler yalnızca PDF ve HTML\'de).',
      },
      part: {
        overview: 'Göstergeler ve ilerleme',
        building: 'Binalar',
        matrix: 'Kat × disiplin',
        schedule: 'Zaman planı (burn-up, çubuk plan, gecikenler)',
        team: 'Kim nerede çalışıyor',
        tasks: 'Tüm görevler',
        cost: 'Maliyet ve satış değeri',
      },
      notAvailable: 'Bu projede yok',
      notInExcel: 'Yalnızca PDF ve HTML\'de',
      filtersHint: 'Analizin dönemi ve filtreleri dışa aktarmada da geçerlidir. Dosya yalnızca yetkilerinizle gördüklerinizi içerir.',
      go: {
        pdf: 'Raporu yazdır',
        html: 'HTML dosyası oluştur',
        xlsx: 'Excel oluştur',
      },
      html: 'HTML (etkileşimli)',
      htmlHint: 'Her tarayıcının açabildiği dosya olarak rapor; değerlerin üzerine gelince ayrıntılar',
      htmlNote: '{{date}} tarihinde {{name}} tarafından {{app}} ile oluşturuldu. Ayrıntılar için katların, çubukların ve hücrelerin üzerine gelin.',
      htmlShort: 'HTML (etkileşimli)',
    },
    noTasks: 'görev yok',
    floorAria: '{{progress}} tamamlandı ({{tasks}} görevden {{done}}), {{overdue}} geciken, dönemde {{hours}} sa',
    tipProgress: '{{progress}} tamamlandı ({{tasks}} görevden {{done}})',
    tipStages: 'devam eden {{progress}} · kontrolde {{review}} · açık {{open}}',
    tipDue: '{{overdue}} geciken · {{soon}} 7 gün içinde bitmeli',
    tipHours: 'dönemde {{actual}} sa yazıldı · plan {{plan}} sa',
    wholeProject: 'Projenin tamamı',
    buildingTotal: '{{progress}} tamamlandı · {{done}}/{{tasks}} görev',
    general: 'Bina geneli',
    area: 'Katsız alan',
    progressBy: '{{dim}} bazında ilerleme',
    noFloorsTitle: 'Henüz bina görünümü yok',
    noFloors: 'Kat bulunamadı. "Ayarlar" altında katın hangi Forma alanından veya konum ağacının hangi seviyesinden geldiğini seçin. Alanlar projenin "Forma" sekmesinde aktarılır.',
    burn: {
      title: 'Gidişat (burn-up)',
      total: 'Toplam görev',
      due: 'tarihe göre bitmesi gereken',
      finished: 'tamamlanan',
      aria: 'Burn-up: {{total}} görevden {{finished}} tamamlandı',
      week: 'Hafta içinde: {{done}} tamamlandı, {{created}} yeni, {{hours}} sa yazıldı',
    },
    hoursPerWeek: 'Haftalık saatler',
    overdueTop: 'En uzun süredir geciken',
    colourBy: 'Renklendirme',
    modes: {
      progress: 'İlerleme',
      schedule: 'Termin durumu',
      hours: 'Saatler',
    },
    buildingHint: 'Bir kata tıklamak tüm analizi o kata filtreler, ikinci tıklama filtreyi kaldırır. Görünüm görevlerin katlarından çizilir: bodrumlar zemin çizgisinin altında, çatı üstte, bina geneli görevler alttaki tabelada.',
    detailOf: '{{place}}: {{dim}} bazında ilerleme',
    rows: 'Satırlar',
    cols: 'Sütunlar',
    matrixHint: 'Üstte ilerleme, altta tamamlanan/toplam; kırmızı sayı: geciken görevler. Bir hücreye, satıra veya sütuna tıklamak analizi filtreler.',
    noData: 'Bu seçim için veri yok.',
    groupBy: 'Gruplama',
    openOnly: 'Yalnızca açık görevler',
    gantt: {
      empty: 'Başlangıç veya bitiş tarihli görev yok.',
      overdue: 'gecikmede',
      noDue: 'bitiş tarihi yok',
      overdueDays: '{{count}} gün gecikmede',
      overdueDays_one: '{{count}} gün gecikmede',
      limited: 'İlk {{count}} görev gösteriliyor; filtrelerle daraltın.',
      without: 'Tarihsiz {{count}} görev gösterilmiyor.',
      without_one: 'Tarihsiz 1 görev gösterilmiyor.',
    },
    overdueAllProject: 'Geciken görevler ({{count}})',
    overdueCount: '{{count}} geciken',
    whoWhere: 'Kim neyde çalışıyor (dönemdeki saatler)',
    teamHint: 'Seçilen dönemde Projektzeit\'a yazılan saatler.',
    personTasks: 'Kişiler: saatler ve saat yazdıkları görevler',
    noHours: 'Bu dönemde saat yok.',
    hoursUnit: 'Değerler saat cinsindendir.',
    sortBy: 'Sıralama',
    sort: {
      overdue: 'Önce gecikenler',
      due: 'Bitiş tarihi',
      ref: 'Numara',
      plan: 'Plan saatleri',
      actual: 'Fiili saatler',
    },
    startDue: 'Başlangıç - bitiş',
    showMore: '{{count}} tane daha göster',
    costNote: 'Maliyet, kişilerin saat yazılan gündeki maliyet ücretlerinden; gelir değeri faturalanabilir saatlerin satış ücretlerinden (girildiyse faturalanan saatler). Yalnızca ilgili yetkiye sahip kişiler görür.',
    cfg: {
      intro: 'Analizin bir görevin binasını, katını, disiplinini ve hizmet fazını nereden aldığı. Öneri aktarılan Forma alanlarından ve konumlardan gelir, burada değiştirilebilir.',
      none: 'kullanılmıyor',
      field: 'Alan: {{title}}',
      loc1: 'Forma konumu, seviye 1',
      loc2: 'Forma konumu, seviye 2',
      loc3: 'Forma lokasyonu, 3. kademe',
      noFields: 'Bu proje için henüz Forma alanı aktarılmadı (proje, "Forma" sekmesi, alanlar).',
      buildingHint: 'En iyisi Forma lokasyonları (1. kademe: bina, 2. kademe: kat, 3. kademe: bölge); bu durumda “Teilprojekt” gibi ayrı bir alana gerek yoktur.',
      floorHint: '2.UG, KG, EG, 1.OG, DG, çatı gibi adlar tanınır ve aşağıdan yukarı sıralanır.',
      progressBy: 'İlerleme ölçüsü',
      progressByHint: 'Plan saatlerine göre yalnızca planlı görevler sayılır; büyük görevler daha ağır basar.',
      byCount: 'Görev sayısı',
      byPlan: 'Plan saatleri',
      fieldsHint: 'Aktarılan diğer alanlar (örn. öncelik, sprintler) otomatik olarak filtre olur.',
      reset: 'Öneriyi kullan',
      zoneHint: 'Bir katın bölgeleri (genellikle Forma lokasyonları, 3. kademe). Bir kat seçildiğinde analiz yalnızca o katı bölgeleriyle ve her bölgede kalan işle gösterir.',
    },
    scheduleCol: 'Termin durumu',
    view: {
      label: 'Görünüm',
      cards: 'Kartlar',
      list: 'Liste',
    },
    zones: {
      title: 'Bölgeler: {{floor}}',
      none: 'Bu kattaki hiçbir görev bir bölgeye bağlı değil.',
      noZone: 'bölgesiz',
      progress: '%{{pct}} tamamlandı',
      left: '{{count}} açık',
      tileHint: '{{zone}}: {{tasks}} görevden {{done}} tamamlandı, {{open}} açık. Tıklama bölgeye göre filtreler.',
      hint: 'Bölgeleriyle tek bir kat (Forma lokasyonları, 3. kademe). Yeşil = tamamlanan işin oranı; “açık” = hâlâ yapılacak görevler.',
    },
    portfolioTitle: 'Proje analizleri',
  },
  documents: {
    title: 'Belgeler',
    column: 'Belge',
    choose: 'Dosya seç',
    pickHint: 'PDF veya fotoğraf (JPG, PNG, HEIC), en fazla 10 MB, en çok 5 dosya. Sürükleyip bırakabilirsiniz.',
    tooMany: 'İzin başına en fazla {{count}} dosya.',
    badType: '"{{name}}": yalnızca PDF veya resim (JPG, PNG, WEBP, HEIC).',
    tooLarge: '"{{name}}" 10 MB\'tan büyük.',
    download: 'İndir',
    view: 'Görüntüle',
    heicHint: 'HEIC fotoğrafları (iPhone) her tarayıcı göstermez. Görmek için indirin.',
    demoPdf: 'Demoda önizleme belgenin metnini gösterir; kurulu platformda PDF tarayıcıda açılır.',
    noPreview: 'Bu dosya için önizleme yok. Lütfen indirin.',
    added: 'Belge eklendi',
    missing: 'Bu dönem için belge bekleniyor; henüz eklenmedi.',
    missingShort: 'Belge eksik',
    none: 'Belge yok.',
    upload: '{{count}} dosya yükle',
    upload_one: 'Dosyayı yükle',
    removeTitle: 'Belgeyi sil',
    removeText: 'Dosyanın içeriği silinir; adı ve zamanı kayıtta kalır. Karardan sonra yalnızca personel birimi gerekçeyle silebilir.',
    removed: 'Belge silindi',
    count: '{{count}} belge',
    count_one: '1 belge',
    add: 'Belge ekle',
    uploadFailed: '{{count}} dosya yüklenemedi; lütfen "Devamsızlıklarım" altında sonradan ekleyin.',
    uploadFailed_one: 'Bir dosya yüklenemedi; lütfen "Devamsızlıklarım" altında sonradan ekleyin.',
    labelRequired: 'Belge (gerekli)',
    labelOptional: 'Belge (isteğe bağlı)',
    healthHint: 'İş göremezlik raporu veya doktor belgesi, {{day}}. takvim gününden itibaren gerekli. Yalnızca siz ve personel birimi görebilir.',
    otherHint: 'örn. davet, kayıt onayı, belge. Siz, onaylayan kişi ve personel birimi görebilir.',
    requiredNotice: '{{day}}. takvim gününden itibaren belge bekleniyor. Daha sonra "Devamsızlıklarım" altında da yükleyebilirsiniz.',
    missingNotice: '{{count}} hastalık bildirimi için belge eksik:',
    missingNotice_one: 'Bir hastalık bildirimi için belge eksik:',
  },
  leaveRequests: {
    title: 'İzin talepleri',
    noAccess: 'İzin taleplerine siz karar vermiyorsunuz. Bir kişinin taleplerini kimin onaylayacağını personel birimi belirler.',
    subtitleHr: 'Tüm açık talepler ve hastalık bildirimleri. Kendi onaylayanı (örn. ekip lideri) olan kişilerin taleplerine de karar verebilirsiniz; hastalık bildirimlerini yalnızca personel birimi onaylar.',
    subtitleApprover: 'Onay verdiğiniz kişilerin talepleri (yıllık izin, fazla mesai izni, eğitim, mazeret izni). Hastalık bildirimlerini personel birimi onaylar.',
    open: 'Açık',
    decided: 'Son kararlar',
    provisionalHint: 'Hastalık bildirimleri onay beklerken de geçerlidir.',
    healthNote: 'Sağlık verisi: yalnızca personel birimi',
    approverIs: 'onaylayan: {{name}}',
    approverHr: 'onaylayan: personel birimi',
    confirm: 'Onayla',
    decidedHint: 'Son 30 günde verdiğiniz kararlar. Sonrasında değişiklik olmadıkça ve ay açık oldukça "Geri al" mümkündür.',
    noneDecided: 'Son 30 günde karar yok.',
    stage: {
      l1: '1. aşama: atanmış onaylayan',
      final: '2. aşama: personel birimi',
    },
    split: 'Artık 10 günlük izin parçası mümkün değil',
    splitHint: 'Türkiye (İş Kanunu m. 56/3): yıllık iznin bir bölümü en az 10 iş günü olmalıdır. Bu yılın hiçbir izni 10 güne ulaşmıyor ve 10 günden az izin kaldı. Yalnızca uyarıdır: taraflar başka türlü anlaşabilir.',
  },
  customers: {
    title: 'Müşteriler',
    subtitle: 'Kişi listesi, firmalar ve projelerin ödeme koşulları. Muhasebe ve fatura kesme yok.',
    noAccess: 'Yalnızca yönetim için ("Müşteri portföyü" yetkisi).',
    tabs: {
      contacts: 'Kişiler',
      companies: 'Firmalar',
      terms: 'Koşullar',
      analytics: 'Analiz',
      migration: 'Metinden aktarım',
    },
    search: 'Ara: firma, ad, şehir, e-posta …',
    filterStatus: 'Duruma göre filtrele',
    allStatus: 'Tümü',
    showInactive: 'Pasif kişileri de göster',
    showArchived: 'Arşivlenenleri göster',
    archivedPill: 'arşivde',
    inactivePill: 'pasif',
    shownOf: '{{total}} kayıttan {{shown}} tanesi gösteriliyor',
    noMatches: 'Bu arama veya duruma uyan kayıt yok.',
    resetFilters: 'Filtreleri sıfırla',
    newContact: 'Yeni kişi',
    newCompany: 'Yeni firma',
    importCsv: 'CSV içe aktar',
    exportCsv: 'CSV dışa aktar',
    emptyContacts: 'Henüz kişi yok. Bir kişi ekleyin veya mevcut listenizi CSV dosyası olarak içe aktarın (Excel: „Farklı kaydet“ → CSV).',
    emptyCompanies: 'Henüz firma yok. Firmalar bir kişi eklenirken veya burada oluşturulur.',
    dncHint: 'İletişime geçilmeyecek: lütfen e-posta göndermeyin, aramayın.',
    statuses: {
      prospect: 'Potansiyel müşteri',
      offered: 'Teklif verildi',
      active: 'Aktif müşteri',
      former: 'Eski müşteri',
      partner: 'İş ortağı',
      do_not_contact: 'İletişime geçilmeyecek',
    },
    cols: {
      company: 'Firma',
      contact: 'Kişi',
      email: 'E-posta',
      phone: 'Telefon',
      status: 'Durum',
      note: 'Not',
      city: 'Şehir',
      owner: 'Sorumlu',
      contacts: 'Kişiler',
      projects: 'Projeler',
      hours12m: 'Saat (12 ay)',
      wip: 'Faturalanmamış',
      billed: 'Belgeler net',
      project: 'Proje',
      role: 'Rol',
      roles: 'Sorumlu olduğu konu',
      kind: 'Tür',
      client: 'İşveren',
      recipient: 'Fatura alıcısı',
      paymentTerm: 'Ödeme koşulu',
      method: 'Faturalama',
      completeness: 'Tamlık',
      items: 'Ekler',
      number: 'Numara',
      period: 'Dönem',
      amount: 'Tutar',
    },
    stats: {
      companies: 'Firmalar',
      active: 'Aktif müşteriler',
      prospects: 'Adaylar ve teklifler',
      prospectsHint: 'Durum „Potansiyel müşteri“ veya „Teklif verildi“',
      wip: 'Faturalanmamış iş değeri',
      wipHint: 'Onaylı, henüz faturalanmamış saat × kayıt günündeki satış oranı',
      billed: 'Belgeler (net)',
      billedHint: 'Kesinleşmiş saat çizelgeleri ve hakedişler; muhasebe değil',
    },
    types: {
      company: 'Şirket',
      public: 'Kamu',
      person: 'Gerçek kişi',
    },
    roles: {
      auftraggeber: 'İşveren (Auftraggeber)',
      rechnungsempfaenger: 'Fatura alıcısı',
      bauherr: 'Yatırımcı / nihai müşteri',
      generalplaner: 'Genel planlayıcı / ortak',
      subplaner: 'Alt planlayıcı',
    },
    contactRoles: {
      invoice: 'Fatura',
      technical: 'Teknik',
      sn_approver: 'Saat çizelgesi onayı',
    },
    methods: {
      hourly: 'Saat bazlı',
      hoai: 'HOAI hakedişleri',
      fixed_fee: 'Sabit bedel',
      mixed: 'Karma',
    },
    channels: {
      email: 'E-posta',
      post: 'Posta',
      portal: 'Portal',
    },
    itemKinds: {
      nachtrag: 'Ek (Nachtrag)',
      nebenkosten: 'Yan giderler',
    },
    itemStatuses: {
      offered: 'Teklif edildi',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
      invoiced: 'Faturalandı',
    },
    taxScenarios: {
      de_standard: 'Yurt içi, genel oran (ayarlardan)',
      pending_advisor: 'Steuerberater teyidi bekliyor',
    },
    company: {
      newTitle: 'Yeni firma',
      editTitle: 'Firmayı düzenle',
      name: 'Firma adı',
      status: 'Durum',
      owner: 'Sorumlu',
      ownerHint: 'Bu müşteriden bizde kimin sorumlu olduğu',
      noOwner: 'atanmamış',
      street: 'Cadde ve numara',
      postalCode: 'Posta kodu',
      city: 'Şehir',
      country: 'Ülke',
      countryHint: '2 harf, örn. DE',
      note: 'Not',
      more: 'Faturalama için ek bilgiler',
      moreHint: 'Yalnızca bu firma fatura alıyorsa gerekir: vergi numarası, müşteri numarası …',
      type: 'Tür',
      legalName: 'Tam unvan',
      vatId: 'KDV no / vergi no',
      vatIdHint: 'DE: "DE" + 9 rakam; TR: 10 veya 11 rakam',
      taxBad: 'Biçimi kontrol edin',
      taxOk: 'Biçim uygun',
      leitwegId: 'Leitweg-ID',
      leitwegHint: 'Kamu işverenlerinde zorunlu (alıcı referansı)',
      customerNo: 'Müşteri numarası',
      debitorNo: 'Borçlu hesap numarası',
      debitorHint: 'Steuerberater verir',
    },
    contact: {
      newTitle: 'Yeni kişi',
      editTitle: 'Kişiyi düzenle',
      company: 'Firma',
      pickCompany: 'Firma seçin …',
      newCompany: 'Yeni firma',
      firstName: 'Ad',
      lastName: 'Soyad',
      position: 'Görev',
      phone: 'Telefon',
      email: 'E-posta',
      note: 'Not',
      responsible: 'Sorumlu olduğu konu',
      active: 'Aktif',
      activeHint: 'Pasif kişiler (örn. şirketten ayrılan) kayıtlı kalır, ancak listede yalnızca istenirse görünür.',
      deleteTitle: 'Kişi silinsin mi?',
      deleteText: 'Kişi proje rollerinden çıkarılır. Yalnızca iş bilgisi saklayın, özel veri saklamayın (KVKK/GDPR).',
    },
    party: {
      add: 'Projeye ata',
      title: 'Projedeki rol',
      none: 'Henüz bir projeye atanmadı.',
      pickProject: 'Proje seçin …',
      noContact: 'belirli bir kişi yok',
      contactHint: 'İsteğe bağlı: bu firmada projeden kimin sorumlu olduğu',
      remove: 'Rolü kaldır',
      removeTitle: 'Rol kaldırılsın mı?',
      removeText: 'Firmanın projeyle bağı kaldırılır. Projedeki serbest metin değişmez.',
    },
    detail: {
      back: 'Müşterilere dön',
      master: 'Ana veri',
      address: 'Adres',
      contacts: 'İletişim kişileri',
      addContact: 'Kişi ekle',
      noContacts: 'Henüz iletişim kişisi yok.',
      projects: 'Projeler ve roller',
      terms: 'Koşullar',
      archive: 'Arşivle',
      unarchive: 'Geri al',
      archiveTitle: 'Firma arşivlensin mi?',
      archiveText: 'Firma ve kişileri listelerden kalkar; projelerdeki roller korunur. Firmayı istediğiniz zaman geri alabilirsiniz.',
    },
    docs: {
      title: 'Saat çizelgeleri ve hakedişler',
      hint: 'Bu firmanın projelerindeki mevcut belgeler (salt okunur). Burada fatura oluşturulmaz.',
      none: 'Henüz belge yok.',
      draft: 'Taslak',
    },
    terms: {
      title: 'Koşullar',
      intro: 'Proje başına: ödeme vadesi (örn. 14 gün), erken ödeme iskontosu (örn. 7 günde %1,5), KDV sonrası kesintiler, fatura alıcısı ve teslimat. Koşulları düzenlemek için bir projeye tıklayın. Burada fatura oluşturulmaz.',
      defaultDays: 'Önerilen ödeme vadesi (gün)',
      defaultDaysHint: 'Bir projenin koşulları oluşturulurken kullanılan varsayılan.',
      search: 'Ara: proje, işveren …',
      onlyOpen: 'Yalnızca eksik olanlar',
      allComplete: 'Tüm projelerin koşulları tam.',
      none: 'koşul yok',
      complete: 'tam',
      gapsCount: '{{count}} eksik',
      gapsCount_one: '{{count}} eksik',
      stillNeeded: 'Hâlâ gerekli',
      freeText: 'Projedeki serbest metin',
      customer: 'Müşteri',
      partner: 'Partner',
      sectionRecipient: 'Fatura alıcısı ve referanslar',
      recipient: 'Fatura alıcısı (firma)',
      noRecipient: 'seçilmedi',
      recipientAddress: 'Farklı fatura adresi',
      recipientAddressHint: 'boş = firmanın adresi',
      orderRef: 'İşveren referansı (sipariş no)',
      buyerRef: 'Alıcı referansı (BT-10 / Leitweg-ID)',
      sectionPayment: 'Ödeme koşulları',
      paymentIntro: 'Ödeme vadesi, erken ödeme iskontosu (Skonto) ve KDV dahil toplamdan sonra düşülen kesintiler (örn. indirim, teminat kesintisi).',
      paymentDays: 'Ödeme vadesi (gün)',
      paymentHint: 'Ayarlardaki varsayılan: {{days}} gün',
      discountPercent: 'Erken ödeme iskontosu (%)',
      discountDays: 'şu süre içinde ödenirse (gün)',
      adjustments: 'KDV sonrası kesintiler',
      adjustmentsHint: 'Her kesinti KDV dahil toplam üzerinden hesaplanır, diğer kesintiler üzerinden değil. İskonto kalan ödenecek tutar üzerinden hesaplanır.',
      addAdjustment: 'Kesinti ekle',
      adjustmentLabel: 'Ad (örn. indirim)',
      modePercent: 'Toplamın %’si',
      modeAmount: 'Tutar (EUR)',
      exampleTitle: 'Örnek hesap',
      exampleNet: 'Net tutar (EUR)',
      net: 'Net',
      vat: 'KDV %{{percent}}',
      gross: 'Brüt (KDV dahil)',
      payable: 'Ödenecek tutar',
      payableDue: '{{days}} gün içinde ödenecek tutar',
      payableDiscount: '{{days}} gün içinde ödenirse (%{{percent}} iskonto)',
      documentText: 'Belgedeki metin',
      taxAdvisorNote: 'İskontoda KDV’nin düzeltilip düzeltilmeyeceğine ve nasıl düzeltileceğine Steuerberater karar verir (§ 17 UStG). Örnek hesap yalnızca müşterinin ne ödeyeceğini gösterir; faturanın yerini tutmaz.',
      daysShort: '{{count}} gün',
      daysShort_one: '{{count}} gün',
      discountShort: '{{days}} günde %{{percent}} iskonto',
      sectionBilling: 'Faturalama ve vergi',
      method: 'Faturalama yöntemi',
      notChosen: 'seçilmedi',
      taxScenario: 'Vergi senaryosu',
      taxOpen: 'Açık soru: onaylı vergi senaryosu listesini (yurt içi, reverse charge, AB, üçüncü ülke) Steuerberater belirler. Cevap gelene kadar yalnızca bu örnek var, serbest KDV oranı yok.',
      sectionDelivery: 'Teslimat ve onay',
      delivery: 'Teslimat',
      deliveryAddress: 'Teslimat adresi (e-posta veya posta)',
      snApproval: 'Saat çizelgesi müşteri onayı gerektirir',
      snTemplate: 'Saat çizelgesi şablonu',
      note: 'Not',
      itemsTitle: 'Ek sözleşmeler ve yan giderler',
      itemsTotal: 'Onaylı veya faturalanmış',
      addItem: 'Kalem ekle',
      itemEdit: 'Kalemi düzenle',
      itemTitle: 'Açıklama',
      itemAmount: 'Tutar net (EUR)',
      noItems: 'Kalem yok',
      needTerms: 'Önce koşulları kaydedin, sonra kalem ekleyin.',
      discountMax: 'En fazla %{{max}}',
    },
    gaps: {
      recipient: 'Fatura alıcısı eksik',
      address: 'Fatura adresi eksik',
      payment_days: 'Ödeme vadesi eksik',
      discount: 'İskonto: süre eksik veya ödeme vadesinden kısa değil',
      billing_method: 'Faturalama yöntemi eksik',
      tax_scenario: 'Vergi senaryosu eksik',
      delivery: 'Teslimat eksik',
      vat_id: 'KDV no eksik veya geçersiz',
      leitweg: 'Leitweg-ID eksik (kamu işvereni)',
    },
    import: {
      title: 'Kişi listesini içe aktar',
      intro: 'Mevcut tablonuzu CSV dosyası olarak yükleyin (Excel: Farklı kaydet → CSV). Önce önizleme görürsünüz; onaylamadan hiçbir şey kaydedilmez. Mevcut firmalar değişmez, yalnızca yeni kişiler eklenir.',
      choose: 'CSV dosyası seç',
      formatTitle: 'Hangi sütunlar tanınır?',
      format: 'İlk satır = başlıklar. Tanınanlar: Firma (zorunlu), Adres, Posta kodu, Şehir, Ülke, Ad, Soyad, Görev, E-posta, Telefon, Durum, Not – Almanca, İngilizce veya Türkçe. Ayırıcı ";" veya ",". Durum metinden okunur (örn. „Aktif müşteri“); boşsa „Potansiyel müşteri“ sayılır.',
      line: 'Satır',
      result: 'Sonuç',
      rows: '{{count}} satır',
      rows_one: '1 satır',
      newCompanies: '{{count}} yeni firma',
      newCompanies_one: '1 yeni firma',
      newContacts: '{{count}} yeni kişi',
      newContacts_one: '1 yeni kişi',
      skipped: '{{count}} zaten var',
      skipped_one: '1 zaten var',
      errors: '{{count}} hatalı',
      errors_one: '1 hatalı',
      apply: 'İçe aktar',
      done: '{{contacts}} kişi ve {{companies}} firma aktarıldı.',
      actions: {
        create_company: 'Yeni firma',
        add_contact: 'Yeni kişi',
        skip_duplicate: 'Zaten var',
        error: 'Hata',
      },
      errorCodes: {
        missing_company: 'Firma eksik',
        missing_name: 'Ad eksik',
        unknown_status: 'Durum tanınmadı',
      },
    },
    migration: {
      intro: 'Projelerdeki "müşteri" ve "partner" metinlerinden firma adayları çıkarılır. Yazım farkları yalnızca grup olarak önerilir; her grubu siz onaylarsınız. Aynı ad otomatik birleştirme nedeni değildir. Projedeki serbest metinler yedek olarak kalır.',
      none: 'Açık serbest metin yok: tüm projelerin firmaları tanımlı.',
      selectAll: 'Tümünü seç',
      selectNone: 'Seçimi kaldır',
      selected: '{{count}} grup seçildi',
      selected_one: '1 grup seçildi',
      fieldCustomer: 'Müşteri → işveren',
      fieldPartner: 'Partner → genel planlayıcı',
      projectCount: '{{count}} proje',
      projectCount_one: '1 proje',
      spellings: 'Yazımlar',
      usedIn: 'Kullanıldığı yer',
      createNew: 'Yeni firma oluştur',
      linkExisting: 'Mevcut firmaya bağla',
      suggested: 'Öneri: mevcut firma',
      shortName: 'Firma adı',
      pickCompany: 'Firma seçin …',
      apply: 'Seçilenleri aktar',
      applied: '{{created}} firma oluşturuldu, {{linked}} proje rolü atandı',
    },
    analytics: {
      year: 'Yıl',
      intro: 'Firma başına: projeler (aktif / tümü), gönderilen belgeler (kesinleşmiş, faturalanmış, ödenmiş; iptal edilenler sayılmaz) saat ve net tutarlarıyla, açık taslaklar ve son belge. Belgenin firması, müşteri verilerindeki alıcısıdır; yoksa koşullardaki fatura alıcısı.',
      topAmount: '{{year}} yılında en yüksek net tutara sahip on firma',
      topHours: '{{year}} yılında en çok saat faturalanan on firma',
      empty: 'Henüz projesi veya belgesi olan firma yok.',
      company: 'Firma',
      projects: 'Projeler',
      activeOf: '{{all}} projeden {{active}} aktif',
      documents: 'Belgeler',
      drafts: 'Taslaklar',
      hoursYear: 'Saat {{year}}',
      amountYear: 'Net {{year}}',
      amountAll: 'Toplam net',
      last: 'Son belge',
    },
  },
  shell: {
    back: 'Geri',
    forward: 'İleri',
    backTitle: 'Önceki sayfaya (Alt + sol ok)',
    forwardTitle: 'Sonraki sayfaya (Alt + sağ ok)',
    quickLinks: 'Şirket bağlantıları',
    links: {
      standards: 'Standartlar ve şablonlar',
      meetings: 'Koordinasyon notları',
      website: 'Web sitesi',
      formaHome: 'Forma My Home',
      sharepoint: 'Şirket SharePoint’i',
    },
    linkHints: {
      standards: 'Şirketin yönergeleri, şablonları ve düzenleri',
      meetings: 'Haftalık koordinasyon toplantısı notları (SharePoint)',
      website: 'Şirketin web sitesi',
      formaHome: 'Forma’daki kendi ana sayfanız (herkes için aynı adres)',
      sharepoint: 'Şirketin SharePoint’teki ana klasörü',
    },
  },
  notif: {
    title: 'Bildirimler',
    bellUnread: '{{count}} okunmamış bildirim',
    bellUnread_one: '1 okunmamış bildirim',
    tabFeed: 'Bildirimler',
    tabHistory: 'Geçmişim',
    filterTitle: 'Göster',
    filterReset: 'Hepsini göster',
    filterHint: 'Seçiminiz hesabınıza kaydedilir ve her cihazda geçerlidir. Burada gördükleriniz yalnızca sizi ilgilendirir ve yetkilerinize bağlıdır.',
    hideCategory: '“{{name}}” kategorisini gizle',
    showCategory: '“{{name}}” kategorisini göster',
    onlyUnread: 'Yalnızca okunmamışlar',
    markAll: 'Hepsini okundu işaretle',
    empty: 'Bildirim yok. Dikkatinizi gerektiren bir şey olduğunda burada görünür.',
    emptyFiltered: 'Gösterilecek bir şey yok. Yukarıdaki seçimi kontrol edin.',
    unread: 'okunmamış',
    critical: 'Acil',
    todo: 'Yapılacak',
    categories: {
      hours: 'Saatlerim',
      leave: 'Devamsızlıklar',
      approvals: 'Onaylar',
      period: 'Ay kapanışı',
      missing: 'Eksik kayıtlar',
      announcement: 'Duyurular',
      system: 'Sistem',
      forma: 'Forma',
    },
    historyHint: 'Yakın zamandaki kendi işlemleriniz. Başkalarının verileri için yalnızca işlemin türü gösterilir, içeriği değil.',
    historyEmpty: 'Henüz işlem yok.',
    historyMore: 'Daha fazla yükle',
    actions: {
      time_update: 'Saat kaydı değiştirildi',
      time_delete: 'Saat kaydı silindi',
      time_restore: 'Saat kaydı geri alındı',
      time_submit: 'Saatler gönderildi',
      time_withdraw: 'Saatler geri çekildi',
      time_approve: 'Saatler onaylandı',
      time_approve_undo: 'Onay geri alındı',
      time_reject: 'Saatler reddedildi',
      time_reject_undo: 'Reddetme geri alındı',
      time_reopen: 'Saatler yeniden açıldı',
      time_create_for_other: 'Başka bir kişi için saat girildi',
      time_billed: 'Saatler faturalandı olarak işaretlendi',
      absence_request: 'Devamsızlık talep edildi',
      absence_create: 'Devamsızlık girildi',
      absence_withdraw: 'Talep geri çekildi',
      absence_withdraw_undo: 'Geri çekme geri alındı',
      absence_cancel: 'Devamsızlık iptal edildi',
      absence_approve: 'Devamsızlık onaylandı',
      absence_reject: 'Devamsızlık reddedildi',
      absence_change_request: 'Değişiklik istendi',
      absence_decision_undo: 'Karar geri alındı',
      absence_document_add: 'Belge yüklendi',
      absence_document_removed: 'Belge kaldırıldı',
      absence_import: 'Devamsızlıklar içe aktarıldı',
      person_update: 'Kişi kaydı değiştirildi',
      person_avatar: 'Profil resmi değiştirildi',
      person_avatar_removed: 'Profil resmi kaldırıldı',
      person_create: 'Kişi oluşturuldu',
      person_activate: 'Kişi etkinleştirildi',
      person_deactivate: 'Kişi devre dışı bırakıldı',
      person_role: 'Rol değiştirildi',
      person_approver: 'Onaylayan kişi değiştirildi',
      person_reset_access: 'Erişim sıfırlandı',
      person_fill_codes: 'Kısaltmalar tamamlandı',
      project_create: 'Proje oluşturuldu',
      project_update: 'Proje değiştirildi',
      project_archive: 'Proje arşivlendi',
      project_unarchive: 'Proje geri yüklendi',
      project_member_set: 'Proje ekibi değiştirildi',
      project_member_remove: 'Kişi projeden çıkarıldı',
      project_party_set: 'Firma projeye atandı',
      project_party_remove: 'Firma ataması kaldırıldı',
      task_create_manual: 'Görev oluşturuldu',
      task_create_internal: 'İç görev oluşturuldu',
      task_update_manual: 'Görev değiştirildi',
      task_archive: 'Görev arşivlendi',
      task_unarchive: 'Görev geri yüklendi',
      task_plan: 'Plan saatleri değiştirildi',
      billing_create: 'Belge oluşturuldu',
      billing_finalize: 'Belge kesinleştirildi',
      billing_cancel: 'Belge iptal edildi',
      billing_delete_draft: 'Taslak silindi',
      company_create: 'Firma oluşturuldu',
      company_update: 'Firma değiştirildi',
      company_archive: 'Firma arşivlendi',
      company_unarchive: 'Firma geri yüklendi',
      company_contact_create: 'Kişi oluşturuldu',
      company_contact_update: 'Kişi değiştirildi',
      company_contact_delete: 'Kişi silindi',
      company_contacts_export: 'Kişi listesi dışa aktarıldı',
      company_contacts_import: 'Kişi listesi içe aktarıldı',
      terms_create: 'Koşullar oluşturuldu',
      terms_update: 'Koşullar değiştirildi',
      terms_item_create: 'Ek kalem girildi',
      terms_item_update: 'Ek kalem değiştirildi',
      terms_item_delete: 'Ek kalem silindi',
      announcement_create: 'Duyuru yayınlandı',
      announcement_update: 'Duyuru değiştirildi',
      announcement_archive: 'Duyuru arşivlendi',
      announcement_unarchive: 'Duyuru geri yüklendi',
      period_lock: 'Ay kapatıldı',
      period_unlock: 'Ay yeniden açıldı',
      settings_update: 'Ayarlar değiştirildi',
      settings_logo: 'Logo değiştirildi',
      settings_logo_removed: 'Logo kaldırıldı',
      quick_favorites: 'Favoriler değiştirildi',
      quick_templates: 'Hafta şablonları değiştirildi',
      notifications: 'Bildirim filtresi değiştirildi',
      contract_set: 'Sözleşme değiştirildi',
      rate_cost: 'Maliyet oranı değiştirildi',
      rate_sales: 'Satış oranı değiştirildi',
      rate_delete: 'Oran silindi',
      company_event_create: 'Şirket etkinliği oluşturuldu',
      company_event_update: 'Şirket etkinliği değiştirildi',
      company_event_delete: 'Şirket etkinliği silindi',
      holiday_set: 'Resmi tatil değiştirildi',
      holiday_delete: 'Resmi tatil kaldırıldı',
      absence_document_viewed: 'Belge açıldı',
      absence_export: 'Devamsızlıklar dışa aktarıldı',
      absence_leave_cut: 'Hastalık nedeniyle izin kısaltıldı',
      absence_resubmit: 'Talep düzenlenip yeniden gönderildi',
      allocation_fill: 'Planlama dolduruldu',
      analysis_export: 'Proje analizi dışa aktarıldı',
      analysis_export_portfolio: 'Portföy analizi dışa aktarıldı',
      auth_entra_linked: 'Microsoft oturumu bağlandı',
      auth_entra_mismatch: 'Microsoft oturumu reddedildi',
      auth_step_up: 'Yeniden doğrulandı (faturalandırma, müşteriler)',
      auth_step_up_failed: 'Ek doğrulama başarısız',
      bi_export: 'Power BI dışa aktarımı oluşturuldu',
      billing_basis_checked: 'Belge kontrol edildi olarak işaretlendi',
      billing_import_edit: 'Excel’deki düzenleme aktarıldı',
      category_create: 'Kategori oluşturuldu',
      category_update: 'Kategori değiştirildi',
      contract_delete: 'Sözleşme dönemi silindi',
      data_export_all: 'Tam dışa aktarım oluşturuldu',
      entitlement_set: 'İzin hakkı değiştirildi',
      forma_connect: 'Forma bağlandı',
      holiday_revert: 'Tatil değişikliği geri alındı',
      jobs_check: 'Günlük kontrol çalıştırıldı',
      kpi_person_viewed: 'Bir kişinin göstergeleri açıldı',
      kpi_team_viewed: 'Personel değerlendirme açıldı',
      outlook_sync: 'Outlook eşitlemesi çalıştırıldı',
      overtime_remove: 'Ödeme veya düzeltme silindi',
      overtime_report_viewed: 'Fazla mesai raporu açıldı',
      overtime_reset: 'Fazla mesai bakiyesi sıfırlandı',
      project_analysis_config: 'Proje analizi ayarları değiştirildi',
      project_attribute_scope: 'Projenin alan değerleri sınırlandı',
      project_colors: 'Proje renkleri atandı',
      project_fee_phases: 'Ücret aşamaları değiştirildi',
      project_forma_auto_import: 'Forma projesi otomatik aktarıldı',
      project_forma_import: 'Forma projeleri aktarıldı',
      project_forma_link: 'Forma’ya bağlandı',
      project_forma_renamed: 'Ad Forma’dan alındı',
      project_forma_unlink: 'Forma bağlantısı kaldırıldı',
      project_import_cleanup: 'Hariç tutulan görevler temizlendi',
      project_import_filter: 'İçe aktarma filtresi değiştirildi',
      project_member_tasks: 'Bir üyenin görevleri sınırlandı',
      project_sync_config: 'Projenin Forma ayarları değiştirildi',
      settings_step_up: 'Ek doğrulama değiştirildi',
      task_delete_manual: 'Görev silindi',
      task_forma_access_lost: 'Forma görevine artık erişilemiyor',
      task_forma_deleted: 'Forma görevi silindi',
      task_forma_restored: 'Forma görevi yeniden etkin',
      task_template_delete: 'Görev şablonu silindi',
      task_template_save: 'Görev şablonu kaydedildi',
    },
    fields: {
      minutes: 'Süre (dk)',
      status: 'Durum',
      work_date: 'Tarih',
      description: 'Yapılan iş',
      billing_type: 'Faturalama türü',
      work_location: 'Çalışma yeri',
      task_id: 'Görev',
      project_id: 'Proje',
      date_from: 'Başlangıç',
      date_to: 'Bitiş',
      kind: 'Tür',
      half_day: 'Yarım gün',
      note: 'Not',
      display_name: 'Ad',
      birthday: 'Doğum günü',
      show_birthday: 'Ekip takviminde doğum günü',
      short_code: 'Kısaltma',
      language: 'Dil',
    },
  },
  notify: {
    hours: {
      rejected: 'Reddedildi: {{week}}. haftada {{count}} kayıt',
      rejected_one: 'Reddedildi: {{week}}. haftada 1 kayıt',
      returned: 'Onaylanmış saatler düzeltme için iade edildi: {{week}}. haftada {{count}} kayıt',
      returned_one: 'Onaylanmış saat düzeltme için iade edildi: {{week}}. haftada 1 kayıt',
      approved: 'Onaylandı: {{week}}. haftada {{count}} kayıt',
      approved_one: 'Onaylandı: {{week}}. haftada 1 kayıt',
      l1: '1. onay verildi: {{week}}. haftada {{count}} kayıt nihai onayı bekliyor',
      l1_one: '1. onay verildi: {{week}}. haftada 1 kayıt nihai onayı bekliyor',
      waiting: '{{week}}. haftada {{count}} kayıt {{days}} gündür onay bekliyor',
      waiting_one: '{{week}}. haftada 1 kayıt {{days}} gündür onay bekliyor',
    },
    missing: {
      days: '{{count}} iş gününde kayıt yok (son: {{last}})',
      days_one: '{{last}} tarihinde kayıt yok',
      week_due: '{{week}}. hafta için son gün bugün: {{count}} taslak henüz gönderilmedi',
      week_due_one: '{{week}}. hafta için son gün bugün: 1 taslak henüz gönderilmedi',
      week_overdue: '{{week}}. hafta süresi ({{deadline}}) geçti: {{count}} taslak henüz gönderilmedi',
      week_overdue_one: '{{week}}. hafta süresi ({{deadline}}) geçti: 1 taslak henüz gönderilmedi',
    },
    leave: {
      pending: '{{kind}} {{period}} karar bekliyor',
      approved: '{{kind}} {{period}} onaylandı',
      rejected: '{{kind}} {{period}} reddedildi',
      change_requested: '{{kind}} {{period}} için değişiklik istendi: lütfen düzenleyip yeniden gönderin',
      cancelled: '{{kind}} {{period}} iptal edildi',
      document_missing: '{{count}} devamsızlıkta belge eksik (rapor veya onay yazısı)',
      document_missing_one: '1 devamsızlıkta belge eksik (rapor veya onay yazısı)',
      overtime_reset: 'Fazla mesai bakiyeniz {{by}} tarafından sıfırlandı: fazla mesai {{date}} tarihinden itibaren sayılıyor. Önceki bakiye {{before}} sa, şimdi {{after}} sa; silinen: {{hours}} sa. Girdiğiniz saatler değişmedi.',
      holiday_personal: '{{date}} tarihli tatiliniz belirlendi veya değişti: {{name}}',
      holiday_changed: 'Tatil değişti: {{date}} {{name}}',
    },
    approvals: {
      time: '{{count}} saat kaydı onayınızı bekliyor (en eskisi {{days}} gündür)',
      time_one: '1 saat kaydı onayınızı bekliyor ({{days}} gündür)',
      leave: '{{count}} devamsızlık talebi kararınızı bekliyor',
      leave_one: '1 devamsızlık talebi kararınızı bekliyor',
    },
    period: {
      open: '{{month}} ayı henüz kapatılmadı',
    },
    announcement: {
      new: 'Yeni duyuru: {{title}}',
      confirm: 'Lütfen onaylayın: {{title}}',
    },
    system: {
      sync_error: 'Forma eşitlemesi: son 24 saatte hata',
      access_lost: '{{count}} proje: Forma erişimi kaybedildi',
      access_lost_one: '1 proje: Forma erişimi kaybedildi',
      backup_old: 'Son yedek 8 günden eski',
      job_errors: '{{date}} gece bakımı veya kontrolü: {{count}} hata veya uyarı',
      job_warnings: '{{date}} gece bakımı veya kontrolü: {{count}} uyarı',
      access_reset_cli: 'Erişiminiz doğrudan sunucuda kuruldu veya sıfırlandı (yeni kurulum bağlantısı, parola ve doğrulayıcı silindi, tüm oturumlar kapatıldı). Bunu siz istemediyseniz lütfen yönetime bildirin.',
    },
    forma: {
      own_deleted: '{{ref}} {{title}} ({{project}}) Forma\'da silindi: üzerindeki {{hours}} saatinizi kontrol edip başka göreve aktarın',
      own_lost: '{{ref}} {{title}} ({{project}}) için Forma erişimi kalktı: üzerindeki {{hours}} saatinizi kontrol edin',
      team_lost: 'Silinmiş veya artık erişilemeyen {{count}} Forma görevinde {{persons}} kişiye ait {{hours}} saat duruyor',
    },
  },
  ann: {
    title: 'Duyurular',
    subtitle: 'Şirketten haberler: tarihler, duyurular, talimatlar. Yalnızca yönetimin “Duyurular” yetkisini verdiği kişiler yayınlayabilir.',
    tabCurrent: 'Güncel (herkesin gördüğü gibi)',
    tabManage: 'Yönet',
    emptyCurrent: 'Sizin için güncel duyuru yok.',
    emptyManage: 'Henüz duyuru yayınlanmadı. İlkini “Yeni duyuru” ile oluşturun.',
    types: {
      info: 'Bilgi',
      event: 'Etkinlik',
      closure: 'Kapalı gün',
      deadline: 'Son tarih',
      safety: 'Talimat / iş güvenliği',
      it: 'BT ve sistem',
      policy: 'Yönerge değişti',
    },
    typeHints: {
      info: 'Çalışanlara genel mesaj.',
      event: 'Etkinlik veya randevu (yaz şenliği, ekip günü). Ayrıca “Yaklaşanlar” altında görünür.',
      closure: 'Köprü günü veya şirket tatili. Ayrıca “Yaklaşanlar” altında görünür.',
      deadline: 'Tarihli hatırlatma (saatleri gönderme, izin planı). Ayrıca “Yaklaşanlar” altında görünür.',
      safety: 'Talimat veya iş güvenliği uyarısı. Okuduğunu onaylama varsayılan olarak açıktır (kanıt).',
      it: 'Bakım, parola, yeni özellik.',
      policy: 'Bir yönerge veya belge değişti. Şirketin sakladığı yere bir bağlantıyla yönlendirin.',
    },
    priorities: {
      normal: 'Normal',
      important: 'Önemli',
      critical: 'Acil',
    },
    pinned: 'Sabit',
    pinnedHint: 'Üstte kalır',
    new: 'Yeni',
    needsConfirm: 'Onay bekliyor',
    more: 'Devamını göster',
    less: 'Daha az göster',
    openLink: 'Aç',
    markRead: 'Okundu işaretle',
    confirm: 'Okudum, onaylıyorum',
    confirmed: 'Teşekkürler, onayınız kaydedildi.',
    confirmedShort: 'Onaylandı',
    newButton: 'Yeni duyuru',
    showArchived: 'Arşivlenenleri göster',
    status: {
      active: 'Aktif',
      planned: 'Planlandı',
      expired: 'Süresi doldu',
      archived: 'Arşivlendi',
    },
    needsAck: 'onaylı',
    readText: '{{reach}} kişiden {{read}} okudu',
    ackText: '{{ack}} onayladı',
    audienceAll: 'Tüm çalışanlar',
    locationOne: 'Konum {{code}}',
    projectsN: '{{count}} proje',
    projectsN_one: '1 proje',
    personsN: '{{count}} kişi',
    personsN_one: '1 kişi',
    roleLead: 'Proje liderleri',
    every: {
      weekly: 'haftalık',
      monthly: 'aylık',
      yearly: 'yıllık',
    },
    everyN: '{{count}} {{unit}} arayla',
    units: {
      weeks: 'hafta',
      months: 'ay',
      years: 'yıl',
    },
    recurring: 'yinelenen',
    untilShort: '{{date}} tarihine kadar',
    fromShort: '{{date}} tarihinden',
    eventShort: 'tarih {{date}}',
    duplicate: 'Çoğalt',
    receipts: 'Okunma durumu',
    restored: 'Duyuru geri yüklendi',
    archivedToast: 'Duyuru arşivlendi',
    published: 'Duyuru yayınlandı',
    form: {
      titleNew: 'Yeni duyuru',
      titleEdit: 'Duyuruyu düzenle',
      publish: 'Yayınla',
      type: 'Tür',
      headline: 'Başlık',
      body: 'Metin',
      priority: 'Önem',
      pin: 'Üste sabitle',
      pinHint: 'Sabitlenen duyurular diğerlerinden önce gelir (acillerden sonra).',
      startsOn: 'Şu tarihten itibaren görünür',
      endsOn: 'Şu tarihe kadar görünür',
      endsOnHint: 'Boş: duyuruyu arşivleyene kadar görünür kalır.',
      endsOnRepeat: 'Tekrarda süreyi “Görünme süresi (gün)” belirler.',
      eventDate: 'Etkinlik tarihi',
      eventTime: 'Saat',
      repeat: 'Tekrarla',
      repeatHint: 'Yinelenen konular için, örn. aylık saat teslimi veya yıllık eğitim. Her tekrar okunma takibinde yeniden sayılır.',
      freq: 'Sıklık',
      interval: 'Aralık ({{unit}})',
      until: 'Şu tarihe kadar tekrarla',
      duration: 'Görünme süresi (gün)',
      lead: 'Önceden göster (gün)',
      leadHint: 'Başlangıçtan bu kadar gün önce görünür.',
      audience: 'Hedef kitle',
      audienceAll: 'Tüm çalışanlar',
      audienceAllHint: 'Harici kişiler görmez.',
      audienceHint: 'Gruplardan en az birine ait olan herkes duyuruyu görür.',
      locations: 'Konumlar (kişinin resmi tatil takvimi)',
      roles: 'Roller',
      projects: 'Proje ekipleri',
      addProject: 'Proje ekle …',
      persons: 'Tek tek kişiler',
      personsHint: 'Örneğin yalnızca bir kişiye yönelik bir duyuru için. Harici kişiler de seçilebilir.',
      addPerson: 'Kişi ekle …',
      externalShort: 'harici',
      externalHint: 'Harici kişiler yalnızca “Harici” rolüne, projelerinden birine veya doğrudan kendilerine yönelik duyuruları görür.',
      needAudience: 'Lütfen bir hedef kitle seçin.',
      email: 'E-posta olarak da gönderilsin',
      emailHint: 'Duyuru görünür olduğu anda ulaşılan kişilerin şirket adreslerine (gizli alıcı olarak) gider: tekrarlanan duyuruda her tarihte, yeni sürümde yeniden.',
      emailSenderFixed: 'Gönderen: {{name}} ({{email}})',
      emailSenderSelf: 'Gönderen: kendi adresiniz',
      emailOff: 'E-posta ile gönderim kapalı. Sistem yönetimi bunu Yönetim › Ayarlar › Duyuruların e-postayla gönderilmesi bölümünden açar.',
      emailNoService: 'E-posta hizmeti kurulu değil (Microsoft Graph); e-posta gönderilemez.',
      ack: 'Okunduğunun onaylanmasını iste',
      ackHint: 'Talimatlar için: herkes tek tıkla onaylar. Henüz onaylamayanları görürsünüz.',
      linkUrl: 'Bağlantı (isteğe bağlı)',
      linkHint: 'Şirket yönergeleri ve belgeler bulundukları yerde kalır; burada oraya bağlantı yeterlidir.',
      linkLabel: 'Bağlantı etiketi',
      newRevision: 'Yeni sürüm olarak yeniden okunmasını iste',
      newRevisionHint: 'Metin değişti. Kapalı: yalnızca düzeltme; okunan ve onaylanan sürümler geçerli kalır.',
    },
    receiptsTitle: 'Okunma durumu',
    receiptsOccurrence: '{{date}} tarihinden başlayan dönem için durum',
    receiptsReach: 'Ulaşılan kişi',
    receiptsRead: 'Okudu',
    receiptsAcked: 'Onayladı',
    receiptsPending: 'Henüz onaylamayan ({{count}})',
    receiptsAllDone: 'Herkes onayladı.',
    receiptsPrivacy: 'Sistem isimleri yalnızca onay isteyen duyurularda gösterir. Diğerlerinde yalnızca sayıları görürsünüz.',
    archiveFilter: 'Görünüm',
    archiveModes: {
      active: 'Güncel',
      all: 'Güncel ve arşiv',
      only: 'Yalnızca arşiv',
    },
    receiptsRevision: 'Sürüm {{revision}}',
    mail: {
      button: 'E-posta',
      title: 'Duyurunun e-postası',
      states: {
        disabled: 'E-posta kapalı',
        scheduled: 'E-posta {{date}} tarihinde',
        pending: 'E-posta gönderiliyor',
        sent: 'E-posta {{count}} kişiye gönderildi',
        error: 'E-posta hatalı',
      },
      sentAt: '{{date}} tarihinde {{recipients}} adresin {{sent}} tanesine gönderildi.',
      scheduledText: 'E-posta, duyuru görünür olduğunda {{date}} tarihinde gider.',
      pendingText: 'Duyuru görünür; e-posta birkaç dakika içinde gider.',
      disabledText: 'Duyurunun e-postayla da gitmesi isteniyor, ancak gönderim ayarlarda kapalı. Hiçbir şey gönderilmez.',
      errors: {
        NO_SENDER: 'Geçerli bir gönderen yok: seçilen kişinin e-posta adresi yok veya artık aktif değil. Lütfen Yönetim › Ayarlar bölümünde göndereni kontrol edin.',
        NO_RECIPIENTS: 'Ulaşılan kişilerin hiçbirinin e-posta adresi yok.',
      },
      errorText: 'Gönderim hatası: {{error}}',
      preview: 'Önizleme',
      from: 'Gönderen',
      noSender: 'geçerli gönderen yok',
      subject: 'Konu',
      recipients: 'Alıcılar: gizli alıcı olarak {{count}} kişi',
      recipients_one: 'Alıcılar: gizli alıcı olarak 1 kişi',
      withoutAddress: `Ulaşılan {{count}} kişinin e-posta adresi yok; duyuruyu yalnızca Projektzeit'ta görürler.`,
      languageHint: 'E-postanın sabit satırları her kişinin kendi dilindedir; başlık ve metin sizin yazdığınız gibidir.',
      demo: 'Demo: hiçbir e-posta tarayıcıdan çıkmaz. Önizleme neyin gönderileceğini gösterir.',
      resend: 'Yeniden gönder',
      resendHint: 'Güncel sürümü ulaşılan herkese bir kez daha gönderir (ör. bir hatadan sonra).',
      toastSent: 'E-posta {{count}} kişiye gönderildi',
      toastSent_one: 'E-posta 1 kişiye gönderildi',
      toastScheduled: 'E-posta, duyuru görünür olur olmaz gider.',
      toastError: 'Duyuru kaydedildi, ancak e-posta (tamamen) gönderilmedi. Ayrıntılar listede "E-posta" altında.',
    },
  },
  home: {
    announcements: 'Duyurular',
    manageAnnouncements: 'Yönet',
    allAnnouncements: 'Tümünü gör',
    noAnnouncements: 'Duyuru yok.',
    moreAnnouncements: '{{count}} duyuru daha',
    moreAnnouncements_one: '1 duyuru daha',
    standards: 'Şirket standartları ve şablonlar',
    standardsHint: 'Şirketin yönergeleri, şablonları ve düzenleri (yeni sekmede açılır)',
    upcoming: 'Yaklaşanlar',
    upcomingEmpty: 'Önümüzdeki günlerde bir şey yok.',
    up: {
      requested: 'talep edildi',
      birthday: 'Doğum günü: {{name}}',
      projectEnd: 'Proje bitişi: {{project}}',
      weekDeadline: '{{week}}. haftanın gönderim süresi',
    },
    upKinds: {
      leave: 'Devamsızlık',
      holiday: 'Resmi tatil',
      event: 'Etkinlik',
      closure: 'Kapalı gün',
      deadline: 'Son tarih',
      birthday: 'Doğum günü',
      project_end: 'Proje bitişi',
      week_deadline: 'Saatleri gönder',
    },
    myWork: 'Yapılacaklarım',
    tiles: {
      absence: 'Devamsızlık',
      openCount: '{{count}} açık',
      toCorrect: '{{count}} düzeltilecek',
      publish: 'Duyuru yayınla',
    },
  },
  quick: {
    pin: 'Favori olarak işaretle',
    unpin: 'Favoriden çıkar',
    favorites: 'Favoriler',
    sortLabel: 'Görevlerin sırası',
    sort: {
      manual: 'Kendi sıram',
      hours: 'En çok saat önce',
      project: 'Projeye göre',
    },
    pinnedAt: '{{ref}} favorilere eklendi',
    moveUp: 'Yukarı taşı',
    moveDown: 'Aşağı taşı',
    favoritesEmpty: 'Henüz favori yok. Sık kullandığınız görevleri yıldızla işaretleyin.',
    favoritesFull: 'En fazla 30 favori olabilir. Önce birini çıkarın.',
    multi: 'Birden çok güne gir',
    multiHint: 'Aynı görev, aynı saat ve aynı yapılan iş birden çok güne, örneğin bir hafta şantiye. Kaydetmeden önce her günü ayrı ayrı görürsünüz.',
    from: 'Başlangıç',
    to: 'Bitiş',
    weekdays: 'Günler',
    hoursPerDay: 'Günlük saat',
    daysCount: '{{count}} gün',
    daysCount_one: '{{count}} gün',
    daysNone: 'Seçilen aralıkta gün yok',
    daysTooMany: 'Tek seferde en fazla {{max}} gün',
    checkDays: 'Günleri kontrol et',
    back: 'Geri',
    bookN: '{{count}} kaydı gir',
    bookN_one: '{{count}} kaydı gir',
    bookNDraft: '{{count}} taslak kayıt oluştur',
    bookNDraft_one: '{{count}} taslak kayıt oluştur',
    reviewIntro: 'Kayıttan önce ne olacağını burada görürsünüz. Uyarılı günler (tatil, devamsızlık, zaten girilmiş) işaretli gelmez; o gün çalıştıysanız işaretleyin. Girilemeyen günler gridir.',
    selected: '{{total}} kaydın {{count}} tanesi seçili, toplam {{hours}} sa',
    doneMany: '{{count}} kayıt oluşturuldu',
    doneMany_one: '{{count}} kayıt oluşturuldu',
    partial: '{{ok}} oluşturuldu, {{failed}} oluşturulamadı. Oluşturulamayanlar nedenleriyle birlikte listede kalır.',
    unknownTask: 'Görev kullanılamıyor',
    hint: {
      DUPLICATE: 'Bu görev o gün zaten girilmiş',
      WEEKEND: 'Hafta sonu',
      WEEKEND_DATE: 'Hafta sonu',
      FREE_DAY: 'Çalışılmayan gün',
      HOLIDAY: 'Resmi tatil',
      ABSENCE_DAY: 'Devamsızlık',
    },
    copyWeek: 'Haftayı al',
    copyTitle: 'Haftayı al',
    copyIntro: 'Önceki bir haftanın veya bir şablonun kayıtlarını {{week}}. haftaya taşır. Her şey taslak olarak oluşur; önce her satırı kontrol eder, sonra her zamanki gibi gönderirsiniz.',
    source: 'Kaynak',
    sourceLast: 'Geçen hafta ({{week}}. hafta)',
    sourceOther: 'Başka bir hafta …',
    sourceTemplate: 'Şablon: {{name}}',
    otherWeek: 'İstediğiniz haftadan bir tarih',
    emptySource: 'Bu kaynakta taşınacak kayıt yok.',
    saveTemplate: 'Bu haftayı şablon olarak kaydet',
    templateHint: 'Şablon, {{week}}. haftadaki kayıtların görevini, gününü, saatini, yapılan işini ve çalışma yerini hatırlar. Yalnızca siz görürsünüz.',
    templateName: 'Şablon adı',
    templateNamePlaceholder: 'ör. Standart hafta',
    templateSave: 'Şablonu kaydet',
    templateSaved: '“{{name}}” şablonu kaydedildi',
    templateDelete: 'Şablonu sil',
    templateDeleted: 'Şablon silindi',
    templateLimit: 'En fazla 20 şablon olabilir. Önce birini silin.',
    templateEmptyWeek: '{{week}}. haftada şablon olarak kaydedilebilecek kayıt henüz yok.',
  },
  recurring: {
    title: 'Tekrarlanan',
    add: 'Yeni',
    empty: 'Her hafta tekrarlanan işler (ör. haftalık ekip toplantısı): kayıt penceresinde "Her hafta tekrarla"yı seçin.',
    edit: 'Düzenle',
    editTitle: 'Tekrarlanan kaydı düzenle',
    pause: 'Duraklat',
    resume: 'Devam ettir',
    paused: 'duraklatıldı',
    pausedDone: 'Duraklatıldı: artık taslak oluşturulmuyor',
    resumedDone: 'Devam ediyor',
    notBookable: 'göreve artık kayıt girilemiyor',
    delete: 'Sil',
    deleteTitle: 'Tekrarlanan kayıt silinsin mi?',
    deleteText: 'Artık yeni taslak oluşturulmaz. Daha önce oluşturulan kayıtlar saatlerinizde kalır; orada değiştirilebilir veya silinebilir.',
    deleted: 'Tekrarlanan kayıt silindi',
    save: 'Tekrarlanan olarak kaydet',
    saved: 'Tekrarlanan kayıt kaydedildi',
    savedBooked: 'Tekrarlanan kayıt kaydedildi, bu hafta için {{count}} taslak oluşturuldu',
    savedBooked_one: 'Tekrarlanan kayıt kaydedildi, bu hafta için {{count}} taslak oluşturuldu',
    bookedNow: '{{count}} tekrarlanan kayıt taslak olarak oluşturuldu',
    bookedNow_one: '{{count}} tekrarlanan kayıt taslak olarak oluşturuldu',
    from: 'Başlangıç',
    until: 'Bitiş (isteğe bağlı)',
    untilHint: 'Boş: süresiz',
    untilShort: '{{date}} tarihine kadar',
    hoursPerDay: 'Gün başına saat',
    toggle: 'Her hafta tekrarla',
    toggleHint: 'Örneğin haftalık ekip toplantısı: her haftanın seçilen günlerinde taslak olarak.',
    toggleOnHint: 'Kayıtlar, haftayı açtığınızda taslak olarak oluşur (içinde bulunulan hafta gece de oluşturulur).',
    everyWeek: 'her hafta',
    explain: 'Resmi tatiller, şirket tatili, tam gün devamsızlıklar ve çalışma süresi olmayan günler atlanır. Silinen taslak geri gelmez. Gönderme her zamanki gibi haftayla birlikte yapılır.',
  },
  templates: {
    title: 'Şablonlar',
    new: 'Yeni şablon',
    empty: 'Henüz şablon yok.',
    pick: 'Soldan bir şablon seçin veya yeni oluşturun.',
    count: '{{count}} görev',
    count_one: '{{count}} görev',
    hint: 'Manuel görev şablonları: bir kez oluşturun (ör. 20-30 standart görev), yeni bir projede Görevler > "Şablondan" ile tek adımda aktarın. Görevler elle oluşturulmuş gibi oluşur; projede zaten olan başlıklar atlanır.',
    name: 'Şablon adı',
    namePlaceholder: 'ör. TGA standart',
    fromProject: 'Bir projenin görevlerini al',
    fromProjectHint: 'Projenin manuel görevlerini aşağıya ekler',
    fromProjectDone: 'Projeden {{count}} görev eklendi',
    descriptionPlaceholder: 'Açıklama (isteğe bağlı)',
    billingDefault: 'Kategorinin varsayılanı',
    fixed: 'tüm kayıtlar için sabitle',
    duplicate: 'Başlık iki kez geçiyor',
    addRow: 'Satır',
    rowsHint: 'en çok 100 satırdan {{count}}',
    removeRow: 'Satırı kaldır',
    deleteTitle: '"{{name}}" şablonu silinsin mi?',
    deleteText: 'Şablondan daha önce aktarılmış görevler projelerinde kalır.',
    deleted: 'Şablon silindi',
    fromTemplate: 'Şablondan',
    applyTitle: 'Şablondan görev aktar',
    applyHint: 'Seçilen satırlar manuel görev olarak oluşturulur. Planlanan saat ve faturalama türünü yalnızca bunları projede belirleyebilen kişi aktarır; diğerlerinde kategorinin varsayılanı geçerlidir.',
    applyN: '{{count}} görev oluştur',
    applyN_one: '{{count}} görev oluştur',
    applied: '{{count}} görev oluşturuldu',
    applied_one: '{{count}} görev oluşturuldu',
    appliedSkipped: '{{count}} atlandı (başlık zaten var veya kategori pasif)',
    exists: 'projede zaten var',
    noneYet: 'Henüz şablon yok. Ofis bunları Yönetim > Görev şablonları altında oluşturur.',
  },
  search: {
    open: 'Bölüm ara (Ctrl+K)',
    placeholder: 'Bölüm ara …',
    title: 'Bölüm ara',
    inputPlaceholder: 'Bölüm, proje veya kişi, ör. fazla mesai, 2026-012, Brandt',
    none: 'Hiçbir şey bulunamadı.',
    hint: 'Bölüm ve sekmelerin yanı sıra proje ve kişileri bulur, ancak yalnızca açabileceklerinizi; içerikler (kayıtlar, metinler) aranmaz. Ok tuşlarıyla seçin, Enter ile açın.',
    projects: 'Projeler',
    people: 'Kişiler',
    personRecord: 'Kişi kartı',
    archived: 'arşivlendi',
    inactive: 'pasif',
    searching: 'Projelerde ve kişilerde aranıyor …',
  },
};

export default tr;
